// ozel-olcu-plus v6.0-sepet (2026-07-31: taslak siparis -> tema sepeti) / v5.3-basak — cart:change dispatch + hdt-cart-drawer native openDialog fix
// The special-size CTA keeps its own flow; theme and cart-drawer requests must complete normally.
// The global fetch override is removed. Retain the compatibility flag for the existing special-size flow.
var _ozelOlcuCartBypass = false;

/**
 * Özel Ölçü Plus — DPO Bağımsız Sistem
 * Paradiso Plus koleksiyonu için tema bazlı özel ölçü hesaplama ve sipariş.
 * Nebim entegreli stok kontrolü + dinamik fiyat + Shopify sepet entegrasyonu.
 * v2.0.0 — 2026-03-27
 */
(function() {
  'use strict';

  // ========== CONFIG (inline'dan al) ==========
  let inlineCfg = window.__OZEL_OLCU_CONFIG__;
  if (!inlineCfg) {
    console.warn('[OzelOlcuPlus] Inline config bulunamadı');
    return;
  }

  let MASSIMO_API = inlineCfg.massimoApi || '';
  let SNAP_RANGES = inlineCfg.snapRanges || [];
  let M2_PRICE = inlineCfg.m2Price || 0;
  let BARCODES = inlineCfg.barcodes || {};
  let INCLUDE_FULL_ROLLS = inlineCfg.includeFullRolls === true;
  let EDGE_TYPES = inlineCfg.edgeTypes || {};
  let SHOPIFY_HANDLES = inlineCfg.shopifyHandles || {};
  // FIX 2026-05-07-SACAK: Sacak edge type'i Overlok'un alias'i (Tokyo HARIC).
  // Ayni varyant + ayni fiyat, sadece label "Sacak" ve gorsel motor "overlok"ta saçaklari gizler.
  function _ensureSacakAlias() {
    var _q = (inlineCfg && inlineCfg.qualityCode || '').toLowerCase();
    // FIX 2026-05-07-NOSACAK: Saçaksız kaliteler — orijinal halı saçaksız olduğu için
    // saçak seçeneği yanıltıcı (motor saçak ekleyemez). Bu kalitelerde Saçak butonu gizli kalır.
    // Doğal saçaklı kaliteler: Garda, Record, Monza, Puffy (sacak alias eklenir).
    // FIX 2026-05-07-SACAK-TOKYO-HARIC: Tokyo hariç TÜM kalitelerde saçak butonu aktif.
    // (Paradiso, Bohem, Opera, Jakarta dahil — overlok'tan alias eklenir, aynı varyant + fiyat).
    var _noSacakKeywords = ['tokyo'];
    var _isNoSacak = false;
    for (var _ni = 0; _ni < _noSacakKeywords.length; _ni++) {
      if (_q.indexOf(_noSacakKeywords[_ni]) >= 0) { _isNoSacak = true; break; }
    }
    var _hasSacakBtn = !!document.querySelector('label[data-edge="sacak"]');
    if (_hasSacakBtn && !_isNoSacak && EDGE_TYPES.overlok && !EDGE_TYPES.sacak) {
      EDGE_TYPES.sacak = Object.assign({}, EDGE_TYPES.overlok, { label: 'Sa\u00e7ak' });
      if (SHOPIFY_HANDLES.overlok) SHOPIFY_HANDLES.sacak = SHOPIFY_HANDLES.overlok;
      // FIX 2026-05-07-FAZ1: amorf engine __OZEL_OLCU_CONFIG__.edgeTypes'tan okuyor.
      // Sacak alias buraya da eklenmeli, yoksa yuvarlak/oval'de Sacak butonu display:none.
      if (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.edgeTypes) {
        var _ocfg = window.__OZEL_OLCU_CONFIG__.edgeTypes;
        if (_ocfg.overlok && !_ocfg.sacak) {
          _ocfg.sacak = Object.assign({}, _ocfg.overlok, { label: 'Sa\u00e7ak' });
        }
      }
    }
  }
  _ensureSacakAlias();

  // Biye yalnizca Paradiso Plus kalitesinde satisa acik. Config'teki biye
  // verisini silmeden gorunurluk ve secim dogrulamasini kalite bazinda uygula.
  function _normalizeQualityCode(config) {
    return String(config && config.qualityCode || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');
  }

  function _isBiyeAllowed(config) {
    return _normalizeQualityCode(config || inlineCfg) === 'paradiso-plus';
  }

  function _isEdgeAllowed(edgeKey, config) {
    var cfg = config || inlineCfg || {};
    var edgeTypes = cfg.edgeTypes || EDGE_TYPES || {};
    return !!edgeTypes[edgeKey] && (edgeKey !== 'biye' || _isBiyeAllowed(cfg));
  }

  function _syncDvVisualEdgeInputAvailability(config) {
    if (typeof document === 'undefined') return;
    var flowRoot = document.getElementById('banner-product');
    if (!flowRoot || flowRoot.getAttribute('data-dv-order-flow') !== 'visual-v3') return;
    var cfg = config || inlineCfg || {};
    var labels = document.querySelectorAll('#bp-edge-section [data-edge]');
    for (var i = 0; i < labels.length; i += 1) {
      var edgeKey = labels[i].getAttribute('data-edge');
      var radio = labels[i].querySelector('input[name="ozel-olcu-edge"]');
      if (radio) radio.disabled = !_isEdgeAllowed(edgeKey, cfg);
    }
  }

  function _getFallbackEdge(config) {
    var cfg = config || inlineCfg;
    if (_isEdgeAllowed('sacak', cfg)) return 'sacak';
    if (_isEdgeAllowed('overlok', cfg)) return 'overlok';
    if (_isEdgeAllowed('bordur', cfg)) return 'bordur';
    if (_isEdgeAllowed('biye', cfg)) return 'biye';
    return '';
  }
  let COMPARE_MULTIPLIER = inlineCfg.compareMultiplier || 1.43;
  const MIN_LENGTH = 50;
  const MAX_LENGTH = 2000; // [OZEL-OLCU MAX 2026-08-29] gercek sinir canli top kontrolu
  const STOCK_CACHE_TTL = 300000;
  const DEBOUNCE_MS = 500;

  // ========== STATE ==========
  let selectedEdge = 'biye';
  let selectedBiyeColor = null;
  let currentSnappedWidth = null;
  let stockCache = {};
  let stockCheckAbort = null;
  let debounceTimer = null;
  let alternativeCheckSeq = 0;
  let pendingAlternativeRequest = null;
  let alternativeStockAbort = null;

  // ========== DOM ==========
  const container = document.getElementById('ozel-olcu-plus');
  if (!container) return;

  function _syncBiyeAvailability(config) {
    var allowed = _isBiyeAllowed(config || inlineCfg);
    container.setAttribute('data-biye-allowed', allowed ? 'true' : 'false');
    var radio = container.querySelector('input[name="ozel-olcu-edge"][value="biye"]');
    if (radio) radio.disabled = !allowed;
    _syncDvVisualEdgeInputAvailability(config || inlineCfg);
  }

  _syncBiyeAvailability(inlineCfg);

  let variantId = container.dataset.variantId;

  function resolveVariantIdForEdge(config, edgeKey) {
    var cfg = config || {};
    // Eski aktif Dolce Vita URL'si canonical config'e alias ile baglandiysa,
    // sepette o sayfanin kendi varyanti kalmali.
    if (cfg.__resolvedByAlias && cfg.__resolvedPageVariantId) {
      return cfg.__resolvedPageVariantId;
    }
    var variants = cfg.shopifyVariantIds || {};
    var resolved = variants[edgeKey];
    // Sacak, Shopify tarafinda Overlok'un uretim/varyant alias'idir.
    if (!resolved && edgeKey === 'sacak') resolved = variants.overlok;
    return resolved || cfg.shopifyVariantId || null;
  }

  function syncVariantIdForEdge(config, edgeKey) {
    var resolved = resolveVariantIdForEdge(config, edgeKey);
    if (resolved) {
      variantId = String(resolved);
      container.dataset.variantId = String(resolved);
    }
  }

  function getSingleShopifyProductHandle(handles) {
    var source = handles || {};
    var values = [];
    ['biye', 'overlok', 'bordur', 'sacak'].forEach(function(edgeKey) {
      var handle = source[edgeKey];
      if (handle && values.indexOf(handle) === -1) values.push(handle);
    });
    return values.length === 1 ? values[0] : '';
  }

  function syncSingleHandleUrl(handle) {
    if (!handle || !window.history || !window.history.replaceState) return;
    var nextUrl = '/products/' + handle + window.location.search + window.location.hash;
    window.history.replaceState(window.history.state || {}, '', nextUrl);
    container.setAttribute('data-product-handle', handle);
    var banner = document.getElementById('banner-product');
    if (banner) banner.setAttribute('data-product-handle', handle);
  }

  function buildEdgeRedirectUrl(handle, edgeKey) {
    var params = new URLSearchParams(window.location.search || '');
    var widthValue = elWidth ? parseInt(elWidth.value) : 0;
    var lengthValue = elLength ? parseInt(elLength.value) : 0;
    var shapeEl = document.getElementById('ozel-olcu-shape');
    var shapeValue = shapeEl ? shapeEl.value : 'dikdortgen';

    if (widthValue > 0) params.set('_ow', String(widthValue));
    if (lengthValue > 0) params.set('_oh', String(lengthValue));
    if (shapeValue && shapeValue !== 'dikdortgen') params.set('_shape', shapeValue);
    else params.delete('_shape');
    params.set('_edge', edgeKey);

    var query = params.toString();
    return '/products/' + handle + (query ? '?' + query : '');
  }

  // URL handle'ını shopifyHandles ile eşleştirerek kesin edge tespiti yap
  // (Liquid "contains plus" kontrolü bazı variant'larda yanılıyor — örn. bordur "kopya" sonlu)
  var _curHandle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
  var _edgeFromHandle = null;
  // FIX C (2026-05-04): edgeTypes guard + handle suffix kontrolü
  // Bordur sadece config'te DOLU ise default; biye/overlok sadece handle suffix eşleşirse
  var _cfgFC = (window.__OZEL_OLCU_CONFIG__ || {});
  var _eTFC = _cfgFC.edgeTypes || {};
  var _hasBordurFC = !!(_eTFC.bordur && _eTFC.bordur.colors && _eTFC.bordur.colors.length);
  if (_hasBordurFC && SHOPIFY_HANDLES.bordur === _curHandle) _edgeFromHandle = 'bordur';
  else if (SHOPIFY_HANDLES.biye === _curHandle && /-biyeli/.test(_curHandle)) _edgeFromHandle = 'biye';
  else if (SHOPIFY_HANDLES.overlok === _curHandle && /-overlok/.test(_curHandle)) _edgeFromHandle = 'overlok';
  // Liquid biye veriyorsa ve handle gerçekten -biyeli sayfası DEĞİLSE -> overlok'a override
  var _liquidEdgeFC = container.dataset.defaultEdge;
  // FIX 2026-05-07-FIX: Eski 'biye→overlok override' kaldırıldı. Yeni Liquid mantığı doğru
  // default veriyor (Bohem→biye, Tokyo→overlok, Garda→sacak, vb). Override bug'a sebep oluyordu.
  selectedEdge = _edgeFromHandle ||
    _liquidEdgeFC ||
    ((document.querySelector('input[name="ozel-olcu-edge"]:checked') || {}).value) ||
    selectedEdge ||
    'overlok';
  if (!_isEdgeAllowed(selectedEdge, inlineCfg)) {
    selectedEdge = _getFallbackEdge(inlineCfg);
  }
  syncVariantIdForEdge(inlineCfg, selectedEdge);
  // FIX C (2026-05-04): DOM sync UNCONDITIONAL — selectedEdge'in son değerine göre
  // Bu, Liquid'in default biye verdiği bohem/opera/jakarta gibi sayfalarda da DOM'u Saçak'a günceller
  if (selectedEdge) {
    container.setAttribute('data-default-edge', selectedEdge);
    var _rFix = document.querySelector('input[name="ozel-olcu-edge"][value="' + selectedEdge + '"]');
    if (_rFix && !_rFix.checked) {
      _rFix.checked = true;
      // active class
      document.querySelectorAll('.ozel-olcu-plus__radio').forEach(function(l) { l.classList.remove('active'); });
      var _lblFix = _rFix.closest('.ozel-olcu-plus__radio');
      if (_lblFix) _lblFix.classList.add('active');
    } else if (_rFix && _rFix.checked) {
      // Radio zaten checked ama active class farklı bir butonda olabilir — sync et
      var _lblExisting = _rFix.closest('.ozel-olcu-plus__radio');
      if (_lblExisting && !_lblExisting.classList.contains('active')) {
        document.querySelectorAll('.ozel-olcu-plus__radio').forEach(function(l) { l.classList.remove('active'); });
        _lblExisting.classList.add('active');
      }
    }
  }

  const elWidth = document.getElementById('ozel-olcu-width');
  const elLength = document.getElementById('ozel-olcu-length');
  const elWidthInfo = document.getElementById('ozel-olcu-width-info');
  const elLengthInfo = document.getElementById('ozel-olcu-length-info');
  const elEdgeGroup = document.getElementById('ozel-olcu-edge-type');
  const elBiyeColors = document.getElementById('ozel-olcu-biye-colors');
  const elColorOptions = document.getElementById('ozel-olcu-color-options');
  const elFabricTitle = document.getElementById('ozel-olcu-fabric-title');
  const elStockStatus = document.getElementById('ozel-olcu-stock-status');
  const elStockIcon = document.getElementById('ozel-olcu-stock-icon');
  const elStockText = document.getElementById('ozel-olcu-stock-text');
  const elPriceDisplay = document.getElementById('ozel-olcu-price-display');
  const elPrice = document.getElementById('ozel-olcu-price');
  const elComparePrice = document.getElementById('ozel-olcu-compare-price');
  const elPriceDetail = document.getElementById('ozel-olcu-price-detail');
  const elAddToCart = document.getElementById('ozel-olcu-add-to-cart');
  const elBtnText = document.getElementById('ozel-olcu-btn-text');
  const elBtnSpinner = document.getElementById('ozel-olcu-btn-spinner');
  const elError = document.getElementById('ozel-olcu-error');

  function getEdgeColors(edgeKey) {
    var edge = EDGE_TYPES[edgeKey];
    if (edge && Array.isArray(edge.colors) && edge.colors.length > 0) return edge.colors;
    if (EDGE_TYPES.biye && Array.isArray(EDGE_TYPES.biye.colors)) return EDGE_TYPES.biye.colors;
    return [];
  }

  function edgeUsesFabric(edgeKey) {
    // FIX 2026-05-07-NOFABRIC: Saçak ve Overlok için kumaş seçimi yok
    // (saçak orijinal halıdan, overlok motor kırpıyor — kumaş seçimine gerek yok)
    if (edgeKey === 'overlok' || edgeKey === 'sacak') return false;
    return getEdgeColors(edgeKey).length > 0;
  }

  function updateFabricTitle() {
    if (!elFabricTitle) return;
    /* v4.3: Desen alanındaki "· {kod}" pattern'ı — başlığa aktif kumaş kodu ekle.
       selectedBiyeColor = color.id (= "1130", "1033"). Edge'in kumaş kullanıp kullanmadığı
       edgeUsesFabric() ile kontrol ediliyor (overlok kumaşsız). */
    var codeSuffix = '';
    if (selectedBiyeColor && edgeUsesFabric(selectedEdge)) {
      codeSuffix = ' · ' + selectedBiyeColor;
    }
    if (selectedEdge === 'biye') elFabricTitle.textContent = 'Biye Kumaş Seçimi' + codeSuffix;
    else if (selectedEdge === 'bordur') elFabricTitle.textContent = 'Bordür Kumaş Seçimi' + codeSuffix;
    else if (selectedEdge === 'overlok') elFabricTitle.textContent = 'Overlok Kumaş Seçimi';
    else {
      var _edgeName = selectedEdge ? (selectedEdge.charAt(0).toUpperCase() + selectedEdge.slice(1)) : 'Kumaş';
      elFabricTitle.textContent = _edgeName + ' Kumaş Seçimi' + codeSuffix;
    }
  }

  function syncSelectedFabricColor() {
    var colors = getEdgeColors(selectedEdge);
    if (!colors.length) {
      selectedBiyeColor = null;
      return;
    }
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].id === selectedBiyeColor) return;
    }
    selectedBiyeColor = colors[0].id;
  }

  function getSelectedFabricLabel() {
    var selected = getSelectedFabricConfig();
    return selected ? (selected.label || selected.id || '') : selectedBiyeColor;
  }

  function getSelectedFabricConfig() {
    if (!selectedBiyeColor) return null;
    var colors = getEdgeColors(selectedEdge);
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].id === selectedBiyeColor) return colors[i];
    }
    return null;
  }

  function getSelectedFabricUrl() {
    var selected = getSelectedFabricConfig();
    return selected ? (selected.image || null) : null;
  }

  // ========== INIT ==========
  function init() {
    renderBiyeColors();
    elBiyeColors.style.display = edgeUsesFabric(selectedEdge) ? 'block' : 'none';
    // Config'de tanımlı olmayan edge tiplerini GIZLE (Puffy'de bordur yok — biye ve overlok var)
    // __reinitOzelOlcuConfig aynı mantığı uygular; init'te de yapmazsak ilk page load'da bordur görünür.
    try {
      var _initEdgeBtns = document.querySelectorAll('[data-edge]');
      // FIX 2026-05-07-FAZ1.1: Shape-aware edge visibility — amorf'ta saçak/bordur gizli, yuvarlak/oval'da sadece bordur gizli
      var _initShape = document.getElementById('ozel-olcu-shape');
      var _initShapeVal = _initShape ? _initShape.value : 'dikdortgen';
      var _initIsAmorf = (_initShapeVal === 'amorf' || _initShapeVal === 'daire' || _initShapeVal === 'oval');
      var _initIsPureAmorf = (_initShapeVal === 'amorf');
      for (var _iei = 0; _iei < _initEdgeBtns.length; _iei++) {
        var _ek = _initEdgeBtns[_iei].getAttribute('data-edge');
        var _initHideForShape = (_initIsPureAmorf && _ek === 'bordur') || (_initIsPureAmorf && _ek === 'sacak'); // daire/oval'de bordür gizleme
        _initEdgeBtns[_iei].style.display = (_isEdgeAllowed(_ek, inlineCfg) && !_initHideForShape) ? '' : 'none';
      }
    } catch(e) {}
    bindEvents();
    relocateForm();
    hideDpoForm();

    // FIX 2026-05-07-FAZ6: CSS-driven amorf saçak gizleme + body data attribute sync.
    // JS race condition'lardan bağımsız: CSS rule body[data-ozel-shape="amorf"] iken
    // saçak/bordur butonlarını !important display:none yapar — sessionStorage restore,
    // shape change, programmatic update — hepsinde otomatik çalışır.
    try {
      // 1. CSS rule enjekte (tek seferlik)
      if (!document.getElementById('ozel-olcu-shape-css-faz6')) {
        var _cssEl = document.createElement('style');
        _cssEl.id = 'ozel-olcu-shape-css-faz6';
        _cssEl.textContent =
          'body[data-ozel-shape="amorf"] [data-edge="sacak"]{display:none !important;}' +
          'body[data-ozel-shape="amorf"] [data-edge="bordur"]{display:none !important;}';
          // daire/oval'de bordür Paradiso için serbest — gizleme kuralı kaldırıldı
        document.head.appendChild(_cssEl);
      }

      // 2. Sync fonksiyonu — body attribute set + aktif edge re-route
      window.__ozelOlcuSyncShape = function() {
        var _ss = document.getElementById('ozel-olcu-shape');
        var _sv = _ss ? (_ss.value || 'dikdortgen') : 'dikdortgen';
        document.body.setAttribute('data-ozel-shape', _sv);
        // Eğer aktif edge artık gizlenmişse → biye'ye düş, biye yoksa overlok'a
        var _aR = document.querySelector('input[name="ozel-olcu-edge"]:checked');
        if (_aR) {
          var _aL = _aR.closest('[data-edge]');
          if (_aL && window.getComputedStyle(_aL).display === 'none') {
            var _bR = document.querySelector('input[name="ozel-olcu-edge"][value="biye"]');
            var _bL = document.querySelector('label[data-edge="biye"]');
            if (_bR && _bL && window.getComputedStyle(_bL).display !== 'none') {
              _bR.checked = true;
              _bR.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              var _oR = document.querySelector('input[name="ozel-olcu-edge"][value="overlok"]');
              if (_oR) {
                _oR.checked = true;
                _oR.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
        }
      };

      // 3. Init: ilk çağrı + 800ms gecikmeli (sessionStorage restore tamamlanmasını bekle)
      window.__ozelOlcuSyncShape();
      setTimeout(window.__ozelOlcuSyncShape, 800);
      setTimeout(window.__ozelOlcuSyncShape, 1800);  // güvence

      // 4. shape select change'e bağla
      var _shapeSelF6 = document.getElementById('ozel-olcu-shape');
      if (_shapeSelF6) {
        _shapeSelF6.addEventListener('change', window.__ozelOlcuSyncShape);
      }
      console.log('[OzelOlcu FAZ6] CSS-driven shape-edge sync aktif');
    } catch(eF6) { console.warn('[OzelOlcu FAZ6] sync init fail:', eF6); }


    // Sayfa yüklendiğinde inputlar zaten dolu ise (browser autofill / sessionStorage restore /
    // banner'dan gelen değer) onDimensionChange'i bir kere tetikle — aksi halde "Ölçü giriniz"
    // uyarısı durduğu gibi kalır, stok kontrolü yapılmaz.
    setTimeout(function() {
      var _wv = elWidth && parseInt(elWidth.value);
      var _lv = elLength && parseInt(elLength.value);
      if (_wv > 0 && _lv > 0 && !currentSnappedWidth) {
        onDimensionChange();
      }
    }, 500);

    // DPO geç yükleniyor (itoris external JS) — MutationObserver ile yakala
    var dpoObserver = new MutationObserver(function(mutations) {
      var found = false;
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if ((node.id && node.id.indexOf('dynamic_option_id_') === 0) ||
                (node.className && node.className.indexOf && node.className.indexOf('itoris') > -1)) {
              found = true;
            }
            // Alt elementlerde de ara
            if (node.querySelector && node.querySelector('[id^="dynamic_option_id_"]')) {
              found = true;
            }
          }
        });
      });
      if (found) {
        hideDpoForm();
      }
    });
    dpoObserver.observe(document.body, { childList: true, subtree: true });

    // 15 saniye sonra observer'ı durdur (itoris çok geç yüklenebilir)
    setTimeout(function() { dpoObserver.disconnect(); }, 15000);

    // Ek güvenlik: itoris geç inject yapabilir — birden fazla noktada gizle
    setTimeout(hideDpoForm, 1000);
    setTimeout(hideDpoForm, 2000);
    setTimeout(hideDpoForm, 4000);
    setTimeout(hideDpoForm, 8000);

    // CSS ile de gizle (JS'ten bağımsız, anında etkili)
    var dpoStyle = document.createElement('style');
    dpoStyle.textContent =
      '.itoris-dynamicproductoptions, #itoris_dynamicproductoptions, ' +
      '.itoris-options-container, [id^="dynamic_option_id_"] { display: none !important; }';
    document.head.appendChild(dpoStyle);

    console.log('[OzelOlcuPlus] Sistem aktif (inline config)');

    // İlk yüklemede preview'i İMMEDIATE tetikle — kullanıcı ham product image (play
    // button içeren video poster, farklı bg vs.) görmesin. Amorf modda force update
    // kullan, debounce'suz anında render. Dikdörtgende preview engine senkron.
    function _firstRender() {
      try {
        var _sh = document.getElementById('ozel-olcu-shape');
        var _isAm = _sh && (_sh.value === 'amorf' || _sh.value === 'daire' || _sh.value === 'oval');
        if (_isAm && window.__amorfForceUpdate) {
          window.__amorfForceUpdate();
        } else {
          notifyPreview();
        }
      } catch (e) {}
    }
    // Çift tetikleme: amorf engine IIFE'si henüz çalışmadıysa retry
    setTimeout(_firstRender, 80);
    setTimeout(_firstRender, 400);
    setTimeout(_firstRender, 1200);
  }

  // ========== PREVIEW ENTEGRASYONU ==========
  function notifyPreview() {
    // Amorf modda giydirme motoru CALISTIRILMAZ — amorf kendi edge render'ini yapar
    var _shapeEl = document.getElementById('ozel-olcu-shape');
    var _isAmorfMode = _shapeEl && (_shapeEl.value === 'amorf' || _shapeEl.value === 'daire' || _shapeEl.value === 'oval');

    if (_isAmorfMode) {
      // Amorf: giydirme motoru yerine amorf engine + galeri guncelle
      if (window.__amorfGaleriGuncelle) {
        window.__amorfGaleriGuncelle();
      }
      updateEdgeFabricHotspot();
      return;
    }

    // Dikdortgen: normal giydirme motoru
    var preview = window.__ozelOlcuPreview;
    if (!preview) return;

    preview.setEdgeType(selectedEdge);
    if (selectedEdge === 'overlok') {
      return;
    }
    var fabric = getSelectedFabricConfig();

    if (fabric && fabric.image) {
      preview.setFabric(fabric.image);
    }

    // Edge fabric hotspot guncelle
    updateEdgeFabricHotspot();
    updateFireHotspot();
  }

  // ========== FIRE BILGI HOTSPOT (dikdortgen mod) ==========
  function updateFireHotspot() {
    // Fire hotspot (kenar ! ikonu) kullanıcı isteğiyle devre dışı — galery görselini
    // bozuyor ve uyarı havası veriyordu. Mevcut DOM elemanını da gizle.
    var _existing = document.getElementById('bp-hs-fire');
    if (_existing) _existing.style.display = 'none';
    return;
    /* eslint-disable-next-line no-unreachable */
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery) return;
    var _shSel = document.getElementById('ozel-olcu-shape');
    var _isAmorf = _shSel && (_shSel.value === 'amorf' || _shSel.value === 'daire' || _shSel.value === 'oval');
    var shouldShow = !_isAmorf && edgeUsesFabric(selectedEdge);
    var hs = document.getElementById('bp-hs-fire');
    if (!shouldShow) { if (hs) hs.style.display = 'none'; return; }
    ensureHotspotCSS();
    if (!hs) {
      hs = document.createElement('div');
      hs.id = 'bp-hs-fire';
      hs.className = 'bp-hs';
      hs.innerHTML =
        '<div class="bp-hs__dot" style="width:16px;height:16px;font-size:9px;background:#fff3e0;border-color:#f59e0b;">!</div>' +
        '<div class="bp-hs__tip" id="bp-hs-fire-tip" style="bottom:calc(100% + 6px);right:-20px;width:220px;">' +
          '<div class="bp-hs__tip-inner" id="bp-hs-fire-text"></div></div>';
      hs.addEventListener('click', function(e) {
        e.stopPropagation(); e.preventDefault();
        var wasOpen = hs.classList.contains('open');
        document.querySelectorAll('.bp-hs.open').forEach(function(el) { el.classList.remove('open'); });
        if (!wasOpen) hs.classList.add('open');
      });
      gallery.appendChild(hs);
    }
    hs.style.display = '';
    // Pozisyon: yatay ruler'in sag ucunda
    var _rulerH = document.getElementById('bp-ruler-h');
    if (_rulerH) {
      var _rRect = _rulerH.getBoundingClientRect();
      var _gRect = gallery.getBoundingClientRect();
      hs.style.cssText = 'top:' + Math.round(_rRect.top - _gRect.top + _rRect.height/2 - 8) + 'px;left:' + Math.round(_rRect.right - _gRect.left + 4) + 'px;';
    } else { hs.style.cssText = 'bottom:8px;right:50px;'; }
    // Fire hesapla
    var w = parseInt(document.getElementById('ozel-olcu-width').value) || 80;
    var h = parseInt(document.getElementById('ozel-olcu-length').value) || 100;
    var fireCm = selectedEdge === 'bordur' ? 7 : 5;
    var fireW = w - fireCm, fireH = h - fireCm;
    var firePct = Math.round((1 - (fireW * fireH) / (w * h)) * 100);
    var edgeLabel = selectedEdge === 'bordur' ? 'Bord\u00fcr' : 'Biye';
    var tipEl = document.getElementById('bp-hs-fire-text');
    if (tipEl) {
      tipEl.innerHTML = '<b style="color:#f59e0b;">\u26a0 Fire Bilgisi</b><br>' +
        '<span style="color:#555;font-size:10px;line-height:1.5;">' +
        '<b>' + w + '\u00d7' + h + ' cm</b> sipari\u015finizde se\u00e7ti\u011finiz <b>' + edgeLabel + '</b> i\u015f\u00e7ili\u011finde <b>~' + fireCm + ' cm</b> fire \u00e7\u0131kmaktad\u0131r.<br>' +
        'Sipari\u015finiz <b style="color:#e8622a;">~' + fireW + '\u00d7' + fireH + ' cm</b> <span style="color:#f59e0b;font-weight:600;">(%' + firePct + ')</span> olarak teslim edilecektir.</span>';
    }
  }

  // ========== PORTAL TOOLTIP (tüm hotspot'lar için, body seviyesi — gallery overflow kırpmaz) ==========
  if (!window.__bpPortalTip) {
    window.__bpPortalTip = {
      _open: false,
      _forId: null,
      _ensureEl: function() {
        var p = document.getElementById('bp-tooltip-portal');
        if (!p) {
          p = document.createElement('div');
          p.id = 'bp-tooltip-portal';
          p.style.cssText = 'position:fixed;z-index:10001;background:#fff;border-radius:10px;padding:12px 14px;box-shadow:0 10px 28px rgba(0,0,0,.18),0 2px 6px rgba(0,0,0,.08);font-size:12px;line-height:1.55;color:#444;width:min(240px,84vw);max-width:240px;display:none;pointer-events:auto;border:1px solid rgba(0,0,0,0.06);';
          document.body.appendChild(p);
          p.addEventListener('click', function(e) { e.stopPropagation(); });
          // v4.1 — CTA "Kumas Secimini Gor" PORTAL kopyasinda tiklaniyordu ama handler
          // ORIJINAL (gizli) #bp-hs-edge-tip icine atandigi icin modal acilmiyordu.
          // Portal seviyesinde delegation: gosterilen kart hangi kumasiysa ONU ac.
          p.addEventListener('click', function(e) {
            var t = e.target;
            if (!t) return;
            var cta = t.closest ? t.closest('#bp-hs-edge-cta, .bp-hs-edge__cta') : null;
            if (!cta) return;
            e.preventDefault();
            e.stopPropagation();
            try {
              // selectedBiyeColor module state — "1033" / "1130" vb.
              // getSelectedFabricConfig biye/bordur ayrimini secilen edge'den alir (ayni slot).
              var _fab = (typeof getSelectedFabricConfig === 'function') ? getSelectedFabricConfig() : null;
              if (_fab && _fab.image && typeof _showFabricModal === 'function') {
                _showFabricModal(_fab.image, _fab.label || _fab.id || '');
              }
            } catch(_eCta) {}
            // Hotspot portal tooltip'ini kapat (modal on plana cikmasin diye)
            try { window.__bpPortalTip && window.__bpPortalTip.hide(); } catch(_eH) {}
            var _openHs = document.querySelectorAll('.bp-hs.open');
            for (var _oi=0;_oi<_openHs.length;_oi++) _openHs[_oi].classList.remove('open');
          });
        }
        return p;
      },
      show: function(hsEl, html) {
        var p = this._ensureEl();
        p.innerHTML = html;
        p.style.display = 'block';
        p.style.left = '0px'; p.style.top = '0px';
        var pW = p.offsetWidth, pH = p.offsetHeight;
        var r = hsEl.getBoundingClientRect();
        var vw = window.innerWidth, vh = window.innerHeight;
        var x = r.left + r.width / 2 - pW / 2;
        x = Math.max(8, Math.min(vw - pW - 8, x));
        var y = r.top - 12 - pH;
        if (y < 8) y = r.bottom + 12;
        if (y + pH > vh - 8) y = vh - pH - 8;
        p.style.left = x + 'px';
        p.style.top = y + 'px';
        this._open = true;
        this._forId = hsEl.id || '';
      },
      hide: function() {
        var p = document.getElementById('bp-tooltip-portal');
        if (p) p.style.display = 'none';
        this._open = false;
        this._forId = null;
      },
      toggle: function(hsEl, html) {
        if (this._open && this._forId === (hsEl.id || '__')) { this.hide(); return; }
        this.show(hsEl, html);
      }
    };
    // Dışarı tıklama ile kapat
    document.addEventListener('click', function(e) {
      if (!window.__bpPortalTip._open) return;
      if (e.target.closest('#bp-tooltip-portal')) return;
      if (e.target.closest('.bp-hs')) return;
      window.__bpPortalTip.hide();
    });
    // Scroll/resize ile kapat
    window.addEventListener('scroll', function() {
      if (window.__bpPortalTip._open) window.__bpPortalTip.hide();
    }, true);
    window.addEventListener('resize', function() {
      if (window.__bpPortalTip._open) window.__bpPortalTip.hide();
    });

    // v4.0 — Hotspot (2) amorf kenarina dinamik otursun: resize/orientation/load eventlerinde yeniden hesapla.
    // Birden fazla kayit olmasin diye flag kullan.
    if (!window.__bpHsResizeBound) {
      window.__bpHsResizeBound = true;
      var _hsReflow = function() {
        try {
          if (typeof updateEdgeFabricHotspot === 'function') updateEdgeFabricHotspot();
        } catch(_e) {}
      };
      var _hsDebounced = null;
      var _hsReflowDebounced = function() {
        clearTimeout(_hsDebounced);
        _hsDebounced = setTimeout(_hsReflow, 120);
      };
      window.addEventListener('resize', _hsReflowDebounced);
      window.addEventListener('orientationchange', _hsReflowDebounced);
      // Img naturalWidth/Height load sonrasinda olusur — ilk open'da hotspot'u dogru kurar
      var _bpImgForHs = document.getElementById('bp-product-img');
      if (_bpImgForHs) {
        _bpImgForHs.addEventListener('load', _hsReflowDebounced);
      }
      // Amorf preview render tamamlandi, target-canvas bbox guncellendi → hotspot'u tazele
      window.addEventListener('amorf:render-bounds-updated', _hsReflowDebounced);
    }
  }

  // ========== KENAR KUMASI HOTSPOT (2) ==========
  function ensureHotspotCSS() {
    if (document.getElementById('bp-hotspot-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-hotspot-css';
    s.textContent =
      '@keyframes bp-pulse{0%{box-shadow:0 0 0 0 rgba(232,98,42,.4)}70%{box-shadow:0 0 0 8px rgba(232,98,42,0)}100%{box-shadow:0 0 0 0 rgba(232,98,42,0)}}' +
      '.bp-hs{position:absolute;z-index:25;cursor:pointer;pointer-events:auto}' +
      '.bp-hs__dot{width:20px;height:20px;border-radius:50%;background:#fff;border:2px solid #e8622a;animation:bp-pulse 2s infinite;transition:transform .2s;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#e8622a}' +
      '.bp-hs__dot:hover{transform:scale(1.2)}' +
      '.bp-hs__tip{display:none}' +
      '.bp-hs__tip-inner{font-size:12px;line-height:1.55;color:#444}' +
      '#bp-tooltip-portal b{color:#e8622a;font-weight:700}' +
      '.bp-hs.open .bp-hs__dot{animation:none;background:#e8622a;color:#fff;border-color:#e8622a}' +
      '.bp-hs-edge__connector{position:absolute;top:50%;right:100%;width:0;height:0;margin-right:4px;pointer-events:none;border-top:7px solid transparent;border-bottom:7px solid transparent;border-right:10px solid #e8622a;transform:translateY(-50%);filter:drop-shadow(0 1px 2px rgba(0,0,0,0.15))}' +
      '.bp-hs-edge__cta{display:inline-block;margin-top:6px;padding:3px 8px;background:#e8622a;color:#fff;border-radius:4px;font-size:10px;font-weight:600;cursor:pointer;text-decoration:none;transition:background .2s}' +
      '.bp-hs-edge__cta:hover{background:#c2410c}' +
      '';
    document.head.appendChild(s);
  }

  function updateEdgeFabricHotspot() {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery) return;

    var shouldShow = edgeUsesFabric(selectedEdge) && selectedBiyeColor;
    var hs = document.getElementById('bp-hs-edge');

    if (!shouldShow) {
      if (hs) hs.style.display = 'none';
      return;
    }

    ensureHotspotCSS();

    // Document-level click handler (tum hotspot'lar icin — tekrar ekleme)
    if (!window._bpHsClickHandler) {
      window._bpHsClickHandler = true;
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.bp-hs')) {
          document.querySelectorAll('.bp-hs.open').forEach(function(el) { el.classList.remove('open'); });
        }
      });
    }

    if (!hs) {
      hs = document.createElement('div');
      hs.id = 'bp-hs-edge';
      hs.className = 'bp-hs';
      // pozisyon asagida dinamik hesaplanacak
      hs.innerHTML =
        '<div class="bp-hs-edge__connector"></div>' +
        '<div class="bp-hs__dot">②</div>' +
        '<div class="bp-hs__tip" id="bp-hs-edge-tip" style="display:none;">' +
          '<div class="bp-hs__tip-inner" id="bp-hs-edge-text"></div>' +
        '</div>';
      hs.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        var inner = document.getElementById('bp-hs-edge-text');
        var html = inner ? inner.innerHTML : '';
        window.__bpPortalTip.toggle(hs, html);
      });
      gallery.appendChild(hs);
    }

    hs.style.display = '';

    // Dinamik pozisyon: halinin sag kenarina hizala
    // v4.0 — Amorf icin: __OzelOlcuAmorf.getShape().rightAnchor ile gercek dis kenara oturt.
    //        Hardcode px offset yok — her amorf seklinde, her resize'da dogru kalir.
    var _img = document.getElementById('bp-product-img');
    if (_img && gallery) {
      var _gW = gallery.offsetWidth;
      var _gH = gallery.offsetHeight;
      var _nw = _img.naturalWidth || 1200;
      var _nh = _img.naturalHeight || 2250;
      var _imgRatio = _nw / _nh;
      var _gRatio = _gW / _gH;
      var _rendW, _rendH, _offL, _offT;
      if (_imgRatio > _gRatio) {
        _rendW = _gW; _rendH = _gW / _imgRatio;
        _offL = 0; _offT = (_gH - _rendH) / 2;
      } else {
        _rendH = _gH; _rendW = _gH * _imgRatio;
        _offL = (_gW - _rendW) / 2; _offT = 0;
      }
      var _carpetRight = _offL + _rendW;
      var _mob = window.innerWidth < 768;
      var _shSel = document.getElementById('ozel-olcu-shape');
      var _isAmorf = _shSel && (_shSel.value === 'amorf' || _shSel.value === 'daire' || _shSel.value === 'oval');
      // Ok ucu geometrisi (CSS bp-hs-edge__connector):
      //   dot width 20px, connector margin-right 4px, border-right 10px.
      //   Ok temas noktasi: X = hsLeft - 14, Y = hsTop + 10 (dot merkezi).
      var _DOT = 20, _ARROW_TIP_X_OFFSET = 14, _DOT_HALF_Y = 10;
      var _hsLeft, _hsTop;
      var _anchorUsed = false;
      if (_isAmorf && window.__OzelOlcuAmorf && typeof window.__OzelOlcuAmorf.getShape === 'function') {
        try {
          var _shData = window.__OzelOlcuAmorf.getShape();
          if (_shData && _shData.rightAnchor && _shData.canvasSize) {
            // v4.5 — PRODUCTION: Hotspot gövdesi ASLA shape üstüne binmemeli.
            // rightAnchor sadece "tip" için referans Y verir. X'i, render edilmiş görselin ALPHA konturundan buluruz:
            // - ok ucu = gerçek kontura temas eder
            // - gövde tamamen dışarıda kalır (dot yüksekliği bandında max-right kontur seçilir)
            //
            // Not: Bu işlem SHAPE'i değiştirmez; sadece render edilmiş (dataURL) img'den piksel okur.
            var _dispAnchorY = _offT + _rendH * _shData.rightAnchor.y;
            var _scaleY = _nh / Math.max(_rendH, 1);
            var _rPx = Math.max(2, Math.ceil((_DOT_HALF_Y + 2) * _scaleY)); // dot yarıçapı bandı (px)

            // Alpha sampler cache (yalnız data:image güvenli; CORS taint olursa otomatik fallback)
            window.__bpAmorfAlphaCache = window.__bpAmorfAlphaCache || {};
            var _cacheKey = String(_img.src || '') + '|' + _nw + 'x' + _nh;
            var _alpha = window.__bpAmorfAlphaCache[_cacheKey];
            if (!_alpha) {
              try {
                var _c = document.createElement('canvas');
                _c.width = _nw; _c.height = _nh;
                var _cx = _c.getContext('2d', { willReadFrequently: true });
                _cx.drawImage(_img, 0, 0, _nw, _nh);
                _alpha = _cx.getImageData(0, 0, _nw, _nh).data; // RGBA
                window.__bpAmorfAlphaCache[_cacheKey] = _alpha;
              } catch(_eCanvas) {
                _alpha = null;
              }
            }

            // Eğer alpha okunamazsa: eski rightAnchor transform ile devam (ama yine de amorf fallback yok)
            if (_alpha) {
              var _y0 = Math.max(0, Math.min(_nh - 1, Math.round((_dispAnchorY - _offT) / Math.max(_rendH, 1) * _nh)));
              var _bestX = -1, _bestY = _y0;
              var _yStart = Math.max(0, _y0 - _rPx);
              var _yEnd = Math.min(_nh - 1, _y0 + _rPx);
              // Her satırda: sağdan sola tarayıp ilk alpha>0 pikselini bul → kontur
              for (var _yy = _yStart; _yy <= _yEnd; _yy++) {
                var _row = _yy * _nw;
                var _xFound = -1;
                for (var _xx = _nw - 1; _xx >= 0; _xx--) {
                  var _ai = (_row + _xx) * 4 + 3;
                  if (_alpha[_ai] > 12) { _xFound = _xx; break; } // 12: yumuşak kenar toleransı
                }
                if (_xFound > _bestX) { _bestX = _xFound; _bestY = _yy; }
              }
              if (_bestX >= 0) {
                // Kontura temas eden tip noktası (display coord)
                var _tipX2 = _offL + _rendW * ((_bestX + 0.5) / _nw);
                var _tipY2 = _offT + _rendH * ((_bestY + 0.5) / _nh);
                _hsLeft = Math.round(_tipX2 + _ARROW_TIP_X_OFFSET);
                _hsTop  = Math.round(_tipY2 - _DOT_HALF_Y);
                _anchorUsed = true;
              }
            }

            if (!_anchorUsed) {
              // rightAnchor fallback (dinamik) — X/Y normalize
              var _tipX = _offL + _rendW * _shData.rightAnchor.x;
              var _tipY = _offT + _rendH * _shData.rightAnchor.y;
              _hsLeft = Math.round(_tipX + _ARROW_TIP_X_OFFSET);
              _hsTop  = Math.round(_tipY - _DOT_HALF_Y);
              _anchorUsed = true;
            }

            // Güvenlik: galery dışına taşmasın (mobilde kenar daralması)
            var _maxLeft = _gW - _DOT;
            if (_hsLeft > _maxLeft) _hsLeft = _maxLeft;
            if (_hsTop < 4) _hsTop = 4;
            if (_hsTop > _gH - 20) _hsTop = _gH - 20;
          }
        } catch(_eAnchor) { _anchorUsed = false; }
      }
      if (!_anchorUsed) {
        if (_isAmorf) {
          // v4.4 — KRİTİK: Amorf'ta sabit px/% fallback YASAK.
          // rightAnchor yoksa yanlış yere koymak yerine hotspot'u geçici gizle.
          // Render/resize sonrası (amorf:render-bounds-updated + img load + resize) tekrar hesaplanır.
          hs.style.display = 'none';
          hs.setAttribute('data-anchor', 'missing-anchor');
          return;
        }
        // Dikdortgen: dot tam sag kenarda, connector iceri bakar
        _hsLeft = _mob ? _carpetRight + 2 : _carpetRight + 4;
        _hsTop = Math.round(_gH * 0.30);
      }
      hs.style.cssText = 'top:' + _hsTop + 'px;left:' + _hsLeft + 'px;';
      hs.setAttribute('data-anchor', _anchorUsed ? 'dynamic' : 'fallback');
    } else {
      hs.style.cssText = 'top:28%;left:60%;';
    }

    // Tooltip yonunu ayarla + dikdortgende connector gizle
    var _tipEl2 = document.getElementById('bp-hs-edge-tip');
    var _connEl = hs.querySelector('.bp-hs-edge__connector');
    var _isMobile = window.innerWidth < 768;
    // Dikdortgende dot zaten kenarda — connector gereksiz
    var _shSel2 = document.getElementById('ozel-olcu-shape');
    var _isAmorf2 = _shSel2 && (_shSel2.value === 'amorf' || _shSel2.value === 'daire' || _shSel2.value === 'oval');
    if (_connEl) {
      if (_isAmorf2) {
        // Amorf: cizgi + ok gorunur
        _connEl.style.borderTop = '';
        _connEl.style.width = '';
      } else {
        // Dikdortgen: sadece ok gorunur, cizgi gizli
        _connEl.style.borderTop = 'none';
        _connEl.style.width = '8px';
      }
    }
    if (_tipEl2) {
      // Tooltip HER ZAMAN yukarı doğru açılır — çizgilerin altına/yanına taşmaz
      _tipEl2.style.cssText = 'bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);right:auto;top:auto;width:min(220px, 80vw);max-width:220px;';
    }

    // Tooltip icerigini guncelle
    var fabricLabel = getSelectedFabricLabel() || selectedBiyeColor || '';
    var edgeLabel = selectedEdge === 'bordur' ? 'Bord\u00fcr' : 'Biye';
    var tipEl = document.getElementById('bp-hs-edge-text');
    if (tipEl) {
      tipEl.innerHTML =
        '<b>' + edgeLabel + ' Kuma\u015f\u0131</b><br>' +
        '<span style="font-size:13px;font-weight:700;color:#333;">' + fabricLabel + '</span>' +
        '<br><span class="bp-hs-edge__cta" id="bp-hs-edge-cta">Se\u00e7ilen kuma\u015f\u0131 g\u00f6r\u00fcnt\u00fcle</span>';
      // CTA click -> scroll to kumas secimi
      var cta = document.getElementById('bp-hs-edge-cta');
      if (cta && !cta._init) {
        cta._init = true;
        cta.addEventListener('click', function(ev) {
          ev.stopPropagation();
          // Secili kumasin buyuk resmini modal'da ac
          var fabConfig = getSelectedFabricConfig();
          if (fabConfig && fabConfig.image) {
            _showFabricModal(fabConfig.image, fabConfig.label || fabConfig.id || '');
          }
          hs.classList.remove('open');
        });
      }
    }
  }

  // ========== FORMU ÜRÜN BİLGİ ALANINA TAŞI ==========
  function relocateForm() {
    // Visual-v3 Liquid yerleşimi zaten Dolce Vita bilgi kolonunun içindedir.
    // Bu akışta container'ı tekrar taşımak şekil/ölçü/kenar sırasını bozar.
    if (container && container.closest('#banner-product[data-dv-order-flow="visual-v3"]')) return;
    // Strateji: Ana ürün formu (cart form) üzerinden parent zincirini bul
    // Bu en güvenilir yöntem — tema ne olursa olsun çalışır
    var mainCartForm = null;
    var allForms = document.querySelectorAll('form[action="/cart/add"]');
    for (var i = 0; i < allForms.length; i++) {
      // Ana ürün formu: genişliği > 300px olan (sidebar/card formları küçüktür)
      if (allForms[i].getBoundingClientRect().width > 300 ||
          allForms[i].closest('.hdt-main-product, .product-single, [class*="main-product"]')) {
        mainCartForm = allForms[i];
        break;
      }
    }

    // Fallback: İlk cart form'un parent zincirinde genişliği > 400px olan container'ı bul
    if (!mainCartForm && allForms.length > 0) {
      mainCartForm = allForms[0];
    }

    if (!mainCartForm) {
      console.warn('[OzelOlcuPlus] Cart form bulunamadı');
      return;
    }

    // Cart form'un doğrudan parent'ından yukarı çık, uygun bilgi container'ını bul
    var target = null;
    var el = mainCartForm.parentElement;
    while (el && el !== document.body) {
      var w = el.getBoundingClientRect().width;
      var cls = el.className || '';
      // Tema-özel selectors (HDT / Dawn / Debut vb.)
      if (cls.indexOf('product-info-wrapp') > -1 ||
          cls.indexOf('product-info__list') > -1 ||
          cls.indexOf('product__info-wrapper') > -1 ||
          cls.indexOf('product-single__meta') > -1) {
        target = el;
        break;
      }
      // Genişliği makul (400-900px arası) olan ilk container
      if (w > 400 && w < 900 && el.children.length > 1) {
        target = el;
        break;
      }
      el = el.parentElement;
    }

    if (!target) {
      // Son fallback: cart form'un parent'ı
      target = mainCartForm.parentElement;
    }

    // Formu cart form'un hemen ÖNÜNE koy
    mainCartForm.parentNode.insertBefore(container, mainCartForm);

    // Boş kalan orijinal section wrapper'ını gizle
    var origSection = document.querySelector('.ozel-olcu-plus-section');
    if (origSection && !origSection.contains(container)) {
      origSection.style.display = 'none';
    }

    console.log('[OzelOlcuPlus] Form taşındı, parent:', container.parentElement.className.substring(0,60));
  }

  // ========== DPO + STANDART FORM GİZLE ==========
  function hideDpoForm() {
    // Standart Shopify sepet formunu gizle (bizim container'ı içermeyenler)
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function(e) { e.preventDefault(); e.stopPropagation(); console.log('[OzelOlcuPlus] Form submit ENGELLENDI'); return false; }, true);
      if (!form.contains(container) && !container.contains(form)) {
        form.style.display = 'none';
      }
    });

    // DPO + standart fiyat + adet alanlarını gizle
    var hideSelectors = [
      '.product__price',
      '.product-single__price',
      '.itoris-dynamicproductoptions',
      '#itoris_dynamicproductoptions',
      '.itoris-options-container',
      '[id^="dynamic_option_id_"]',
      '.product-form__buttons',
      '.product-form__quantity',
      '.hdt-product__buy-button',
      '.hdt-product__quantity',
      '.hdt-product-info__item--quantity'
    ];
    hideSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (!el.contains(container)) {
          el.style.display = 'none';
        }
      });
    });

    // HDT tema: Adet seçici (quantity) — "Adet" textini içeren hdt-product-info__item'ı gizle
    var infoItems = document.querySelectorAll('.hdt-product-info__item');
    infoItems.forEach(function(item) {
      if (item.contains(container)) return; // Kendi container'ımızı atlat
      var text = item.textContent || '';
      // Adet seçici veya buy button içeren item'ları gizle
      if (text.indexOf('Adet') > -1 && item.querySelector('input[type="number"], .quantity, [name="quantity"]')) {
        item.style.display = 'none';
      }
    });

    // Standart fiyat alanını gizle (2,840.00 TL)
    var priceItem = document.querySelector('.hdt-product-info__item.hdt-product__price');
    if (priceItem && !priceItem.contains(container)) {
      priceItem.style.display = 'none';
    }
  }

  // ========== BİYE RENKLERİ ==========

  // Kumaş detay modal
  var _fabricModal = null;
  function _ensureFabricModal() {
    if (_fabricModal) return;
    var m = document.createElement('div');
    m.id = 'bp-fabric-modal';
    m.style.cssText = 'display:none;position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.6);align-items:center;justify-content:center;';
    // v4.3 — Metinleri netlestir (Biye/Bordur kenar kumaşı): "Yakın Çekim" ve "Gerçek doku..." kaldır.
    m.innerHTML = '<div style="background:#fff;border-radius:14px;max-width:420px;width:92%;padding:18px;position:relative;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,0.25);">'
      + '<button id="bp-fm-close" style="position:absolute;top:10px;right:14px;background:none;border:none;font-size:22px;cursor:pointer;color:#666;z-index:2;">&times;</button>'
      + '<div id="bp-fm-title" style="margin-top:4px;font-size:14px;font-weight:700;color:#222;letter-spacing:0.1px;"></div>'
      + '<img id="bp-fm-img" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:10px;border:1px solid #eee;margin-top:10px;" />'
      + '<div id="bp-fm-label" style="margin-top:12px;font-size:16px;font-weight:700;color:#333;"></div>'
      + '<div id="bp-fm-desc" style="margin-top:6px;font-size:12px;line-height:1.5;color:#666;"></div>'
      + '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function(e) { if (e.target === m) { m.style.display = 'none'; } });
    m.querySelector('#bp-fm-close').addEventListener('click', function() { m.style.display = 'none'; });
    _fabricModal = m;
  }
  function _showFabricModal(imgSrc, label) {
    _ensureFabricModal();
    /* v4.2: 600→1200 yüksek çözünürlüklü zoom (doku blur olmasın, magnifier hissi) */
    _fabricModal.querySelector('#bp-fm-img').src = imgSrc.replace(/width=\d+/, 'width=1200');
    // v4.3 — Sadece Biye/Bordur: kullanici hangi kenarin kumasini gordugunu net anlasin.
    var _edge = selectedEdge === 'bordur' ? 'bordur' : (selectedEdge === 'biye' ? 'biye' : '');
    var _edgeTitle = _edge === 'bordur'
      ? 'Seçilen Bordür Kenarının Kumaşı'
      : (_edge === 'biye' ? 'Seçilen Biye Kenarının Kumaşı' : '');
    var _edgeDesc = _edge === 'bordur'
      ? 'Bu görüntü, seçilen bordür kenarında kullanılacak kumaşa aittir.'
      : (_edge === 'biye' ? 'Bu görüntü, seçilen biye kenarında kullanılacak kumaşa aittir.' : '');
    var _tEl = _fabricModal.querySelector('#bp-fm-title');
    var _dEl = _fabricModal.querySelector('#bp-fm-desc');
    if (_tEl) _tEl.textContent = _edgeTitle;
    if (_dEl) _dEl.textContent = _edgeDesc;
    // label param: mevcut çağrılar (hotspot + swatch) burada kod/etiket olarak kullanılıyor
    _fabricModal.querySelector('#bp-fm-label').textContent = label || '';
    _fabricModal.style.display = 'flex';
  }

  function renderBiyeColors() {
    var colors = getEdgeColors(selectedEdge);
    elColorOptions.innerHTML = '';

    if (colors.length === 0) {
      elBiyeColors.style.display = 'none';
      selectedBiyeColor = null;
      updateFabricTitle();
      return;
    }

    syncSelectedFabricColor();
    updateFabricTitle();

    colors.forEach(function(color, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      var isActive = color.id === selectedBiyeColor;
      btn.className = 'ozel-olcu-plus__color-btn' + (isActive ? ' active' : '');
      btn.dataset.colorId = color.id;
      btn.title = color.label;

      if (color.image) {
        btn.innerHTML =
          '<img class="ozel-olcu-plus__color-img" src="' + color.image + '" alt="' + color.label + '" loading="lazy">' +
          '<span class="ozel-olcu-plus__color-name">' + color.label + '</span>';
      } else {
        btn.innerHTML =
          '<span class="ozel-olcu-plus__color-swatch" style="background-color: ' + (color.hex || '#ccc') + '"></span>' +
          '<span class="ozel-olcu-plus__color-name">' + color.label + '</span>';
      }

      btn.addEventListener('click', function(e) {
        if (btn.classList.contains('active') && e.isTrusted) {
          // Kullanici tiklamasi + zaten secili — modal ac
          var img = btn.querySelector('img');
          if (img) _showFabricModal(img.src, color.label);
        } else if (!btn.classList.contains('active')) {
          // Ilk tiklama — kumas sec + giydirme
          selectBiyeColor(color.id, btn);
        }
      });
      elColorOptions.appendChild(btn);
    });
  }

  function selectBiyeColor(colorId, btnEl) {
    selectedBiyeColor = colorId;
    elColorOptions.querySelectorAll('.ozel-olcu-plus__color-btn').forEach(function(b) { b.classList.remove('active'); });
    btnEl.classList.add('active');
    updateState();
    updateFabricTitle();  /* v4.3: başlıktaki kumaş kodu anında güncellensin */

    // Update preview with selected fabric
    notifyPreview();

    // Edge fabric hotspot guncelle (notifyPreview icinde de cagriliyor ama
    // selectBiyeColor direkt cagirdiginda fabricLabel hemen dogru olsun)
    updateEdgeFabricHotspot();
    updateFireHotspot();
  }

  // ========== EVENTS ==========
  function bindEvents() {
    // Halı şekli 4-buton click handler — select.value'yu set edip change dispatch eder.
    var _shapeBtnsInit = document.getElementById('bp-shape-btns');
    if (_shapeBtnsInit) {
      _shapeBtnsInit.querySelectorAll('.bp-shape-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var _shapeVal = this.getAttribute('data-shape');
          var _sel = document.getElementById('ozel-olcu-shape');
          if (_sel && _sel.value !== _shapeVal) {
            _sel.value = _shapeVal;
            _sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // FIX 2026-05-07-FAZ1.2: Edge visibility DIRECT update — change tetiklense de tetiklenmese de
          // (onShapeChange aynı shape için tetiklenmiyor, ama display update olmalı)
          try {
            var _isAm12 = (_shapeVal === 'amorf' || _shapeVal === 'daire' || _shapeVal === 'oval');
            var _isPA12 = (_shapeVal === 'amorf');
            document.querySelectorAll('[data-edge]').forEach(function(_l) {
              var _e = _l.getAttribute('data-edge');
              var _hide12 = (_isPA12 && _e === 'bordur') || (_isPA12 && _e === 'sacak'); // daire/oval'de bordür serbest
              var _exists12 = _isEdgeAllowed(_e, inlineCfg);
              var _ok12 = _exists12 && !_hide12;
              _l.style.display = _ok12 ? '' : 'none';
              _l.setAttribute('data-edge-allowed', _ok12 ? 'true' : 'false');
            });
            // Eğer aktif radio gizlenen bir edge ise (saçak amorf'a geçince) → biye'ye düş
            var _activeRadio12 = document.querySelector('input[name="ozel-olcu-edge"]:checked');
            if (_activeRadio12) {
              var _activeLabel12 = _activeRadio12.closest('[data-edge]');
              if (_activeLabel12 && _activeLabel12.style.display === 'none') {
                var _biyeRadio12 = document.querySelector('input[name="ozel-olcu-edge"][value="biye"]');
                if (_biyeRadio12 && _isEdgeAllowed('biye', inlineCfg) && document.querySelector('label[data-edge="biye"]').style.display !== 'none') {
                  _biyeRadio12.checked = true;
                  _biyeRadio12.dispatchEvent(new Event('change', { bubbles: true }));
                } else {
                  var _olRadio12 = document.querySelector('input[name="ozel-olcu-edge"][value="overlok"]');
                  if (_olRadio12) {
                    _olRadio12.checked = true;
                    _olRadio12.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              }
            }
          } catch(eF12) { console.warn('[FAZ1.2] edge update fail:', eF12); }
        });
      });
    }

    elWidth.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(onDimensionChange, DEBOUNCE_MS);
    });

    elLength.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(onDimensionChange, DEBOUNCE_MS);
    });

    elEdgeGroup.querySelectorAll('input[name="ozel-olcu-edge"]').forEach(function(radio) {
      radio.addEventListener('change', function(e) {
        try {
        var _requestedEdge = e.target.value;
        if (!_isEdgeAllowed(_requestedEdge, inlineCfg)) {
          var _safeEdge = _getFallbackEdge(inlineCfg);
          var _safeRadio = _safeEdge && document.querySelector('input[name="ozel-olcu-edge"][value="' + _safeEdge + '"]');
          e.target.checked = false;
          if (_safeRadio) {
            _safeRadio.checked = true;
            _safeRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
        var _prevEdge = selectedEdge;
        selectedEdge = _requestedEdge;
        syncVariantIdForEdge(inlineCfg, selectedEdge);
        elEdgeGroup.querySelectorAll('.ozel-olcu-plus__radio').forEach(function(l) { l.classList.remove('active'); });
        e.target.closest('.ozel-olcu-plus__radio').classList.add('active');
        updateFabricTitle();
        renderBiyeColors();
        elBiyeColors.style.display = edgeUsesFabric(selectedEdge) ? 'block' : 'none';
        updateState();
        // [DEMIRCI ASAMA 2] kenar degisti → stok kontrolu yeni kenarla (edge param) yenilensin; onbellek anahtari kenari icerir
        try {
          if (_prevEdge !== selectedEdge && currentSnappedWidth && parseInt(elLength.value) >= MIN_LENGTH) {
            checkStock(currentSnappedWidth, parseInt(elLength.value));
          }
        } catch (_eDk) { /* stok yenileme basarisiz olsa da kenar secimi bozulmasin */ }

        // Amorf modunda: edge değişimlerinde DOĞRUDAN amorf motoru tetikle
        var _shpEl_edge = document.getElementById('ozel-olcu-shape');
        var _isAmorf_edge = _shpEl_edge && (_shpEl_edge.value === 'amorf' || _shpEl_edge.value === 'daire' || _shpEl_edge.value === 'oval');
        var _preview = window.__ozelOlcuPreview;
        if (_isAmorf_edge) {
          // Amorf motorunu yeni edge type ile tetikle (restoreGallery yok, amorf zaten kendi galerisi)
          try {
            if (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.setEdgeType) {
              window.__OzelOlcuAmorf.setEdgeType(selectedEdge);
            }
          } catch(e) {}
          setTimeout(function() {
            if (window.__amorfGaleriGuncelle) window.__amorfGaleriGuncelle();
          }, 150);
          updateEdgeFabricHotspot();
          updateFireHotspot();
        } else if (_prevEdge === 'overlok' && selectedEdge !== 'overlok') {
          // Dikdörtgen: Overlok -> biye/bordur: galeri restore + fresh biye render
          console.log('[OzelOlcu] Overlok->biye: galeri restore + fresh render');
          if (_preview && _preview.restoreGallery) _preview.restoreGallery();
          setTimeout(function() {
            var _fab = getSelectedFabricConfig();
            if (!_fab) {
              // FIX_CLICK_2026-05-07: programatik click + zaten-active btn = handler hiçbir dala girmez.
              // selectBiyeColor'ı doğrudan çağır (aynı module scope'unda private fn).
              var _colors = (typeof getEdgeColors === 'function') ? getEdgeColors(selectedEdge) : null;
              var _firstBtn = document.querySelector('.ozel-olcu-plus__color-btn');
              if (_firstBtn && _colors && _colors.length > 0) {
                console.log('[OzelOlcu] FIX_CLICK: directly calling selectBiyeColor for first fabric');
                selectBiyeColor(_colors[0].id, _firstBtn);
                return;
              }
            }
            if (_preview && _fab && _fab.image) {
              _preview.setEdgeType(selectedEdge);
              _preview.setFabric(_fab.image);
            }
          }, 300);
          updateEdgeFabricHotspot();
          updateFireHotspot();
        } else if (selectedEdge === 'overlok' && _prevEdge !== 'overlok') {
          // Dikdörtgen: Biye/bordur -> overlok: galeri restore
          if (_preview && _preview.restoreGallery) _preview.restoreGallery();
          notifyPreview();
        } else {
          // Dikdörtgen: aynı tip içi geçiş (biye->bordur vs.)
          notifyPreview();
        }
        // Amorf aktifse sessionStorage — SADECE radii dolu ise kaydet
        try {
          var _ssShapeEl = document.getElementById('ozel-olcu-shape');
          var _isAmorfSs = _ssShapeEl && (_ssShapeEl.value === 'amorf' || _ssShapeEl.value === 'daire' || _ssShapeEl.value === 'oval');
          if (_isAmorfSs) {
            var _curShape = window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape ? window.__OzelOlcuAmorf.getShape() : null;
            var _hasR2 = _curShape && _curShape.radii && _curShape.radii.length > 0 &&
                         Array.from(_curShape.radii).some(function(r) { return r > 0.1; });
            if (_hasR2) {
              sessionStorage.setItem('amorf_active', JSON.stringify({
                shape: _ssShapeEl.value,
                edgeType: selectedEdge,
                radii: Array.prototype.slice.call(_curShape.radii),
                widthCm: elWidth && parseInt(elWidth.value) > 0 ? parseInt(elWidth.value) : _curShape.widthCm,
                lengthCm: elLength && parseInt(elLength.value) > 0 ? parseInt(elLength.value) : _curShape.lengthCm,
                ts: Date.now()
              }));
            }
          }
        } catch(e) {}
        // Tek Shopify urunu kullanan kalitelerde (Macaron, Sumatra vb.) kenar
        // degisimi yalnizca state/preview degisimidir; sayfa yenilemek deseni ve
        // secilen kenari karistirir. Ayri kenar urunleri kullanan kalitelerde
        // gercek urun navigasyonunu koru ve olcu/sekil/kenar state'ini URL ile tasi.
        var _curH = window.location.pathname.split('/products/')[1] || '';
        if (_curH.indexOf('?') > -1) _curH = _curH.split('?')[0];
        try { _curH = decodeURIComponent(_curH); } catch(_eDec) {}
        var _tgtH = SHOPIFY_HANDLES[selectedEdge];
        if (_tgtH && _tgtH !== _curH) {
          // Alias sayfasi kendi Shopify varyantini kullanir. Yalniz kenar
          // secildi diye URL'yi canonical urune sessizce cevirmeyiz.
          if (inlineCfg.__resolvedByAlias) {
            console.log('[OzelOlcu] Alias handle korundu:', _curH);
            return;
          }
          var _singleProductHandle = getSingleShopifyProductHandle(SHOPIFY_HANDLES);
          if (_singleProductHandle) {
            syncSingleHandleUrl(_singleProductHandle);
            console.log('[OzelOlcu] Single-handle edge sync:', selectedEdge, '->', _singleProductHandle);
            return;
          }

          var _edgeRedirectUrl = buildEdgeRedirectUrl(_tgtH, selectedEdge);
          console.log('[OzelOlcu] Redirect (edge):', selectedEdge, '->', _edgeRedirectUrl);
          window.location.href = _edgeRedirectUrl;
          return;
        }
        } catch(_eeErr) {
          console.error('[OzelOlcu] Edge handler ERROR:', _eeErr.message, _eeErr.stack);
        }
      });
    });

    elAddToCart.addEventListener('click', addToCart);

    // ═══ KESİM ŞABLONU İNDİR BUTONU + MODAL ═══ DEVRE DISI
    (function initPdfRequest() { return; // DISABLED
      // Buton ekle (SEPETE EKLE'den sonra)
      var pdfBtn = document.createElement('button');
      pdfBtn.type = 'button';
      pdfBtn.id = 'ozel-olcu-pdf-btn';
      pdfBtn.className = 'ozel-olcu-plus__btn';
      pdfBtn.style.cssText = 'margin-top:8px;background:#9b59b6;border-color:#9b59b6;display:none;';
      pdfBtn.innerHTML = '<i class="fas fa-file-pdf" style="margin-right:6px;"></i> Kesim Sablonu Indir';
      elAddToCart.parentNode.insertBefore(pdfBtn, elAddToCart.nextSibling);

      // Modal
      var modal = document.createElement('div');
      modal.id = 'ozel-olcu-pdf-modal';
      modal.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:99999;justify-content:center;align-items:center;';
      modal.innerHTML =
        '<div style="background:#fff;border-radius:12px;padding:24px;max-width:400px;width:90%;position:relative;">' +
          '<h3 style="margin:0 0 16px;font-size:18px;color:#333;"><i class="fas fa-file-pdf" style="color:#9b59b6;"></i> Kesim Sablonu Talebi</h3>' +
          '<p style="font-size:13px;color:#666;margin:0 0 16px;">Bilgilerinizi girin, admin onayindan sonra telefonunuza indirme linki gonderilecektir.</p>' +
          '<div style="display:grid;gap:10px;">' +
            '<input type="text" id="pdf-req-ad" placeholder="Adiniz *" style="padding:10px 12px;border:1px solid #ddd;border-radius:8px;font-size:14px;">' +
            '<input type="text" id="pdf-req-soyad" placeholder="Soyadiniz" style="padding:10px 12px;border:1px solid #ddd;border-radius:8px;font-size:14px;">' +
            '<input type="tel" id="pdf-req-tel" placeholder="Telefon * (05xx xxx xx xx)" style="padding:10px 12px;border:1px solid #ddd;border-radius:8px;font-size:14px;">' +
            '<input type="email" id="pdf-req-email" placeholder="E-posta (opsiyonel)" style="padding:10px 12px;border:1px solid #ddd;border-radius:8px;font-size:14px;">' +
          '</div>' +
          '<div style="display:flex;gap:8px;margin-top:16px;">' +
            '<button id="pdf-req-submit" style="flex:1;padding:12px;background:#9b59b6;color:#fff;border:none;border-radius:8px;font-size:14px;cursor:pointer;">Talep Gonder</button>' +
            '<button id="pdf-req-cancel" style="padding:12px 20px;background:#eee;color:#666;border:none;border-radius:8px;font-size:14px;cursor:pointer;">Kapat</button>' +
          '</div>' +
          '<div id="pdf-req-status" style="margin-top:12px;font-size:13px;text-align:center;"></div>' +
        '</div>';
      document.body.appendChild(modal);

      // Amorf secildiginde butonu goster
      var shapeEl = document.getElementById('ozel-olcu-shape');
      function togglePdfBtn() {
        var isAmorf = shapeEl && (shapeEl.value === 'amorf' || shapeEl.value === 'daire' || shapeEl.value === 'oval');
        pdfBtn.style.display = isAmorf ? 'block' : 'none';
      }
      if (shapeEl) shapeEl.addEventListener('change', togglePdfBtn);
      setTimeout(togglePdfBtn, 500);

      // Modal ac/kapa
      pdfBtn.addEventListener('click', function() { modal.style.display = 'flex'; });
      document.getElementById('pdf-req-cancel').addEventListener('click', function() { modal.style.display = 'none'; });
      modal.addEventListener('click', function(e) { if (e.target === modal) modal.style.display = 'none'; });

      // Talep gonder
      document.getElementById('pdf-req-submit').addEventListener('click', async function() {
        var ad = document.getElementById('pdf-req-ad').value.trim();
        var soyad = document.getElementById('pdf-req-soyad').value.trim();
        var tel = document.getElementById('pdf-req-tel').value.trim();
        var email = document.getElementById('pdf-req-email').value.trim();
        var statusEl = document.getElementById('pdf-req-status');

        if (!ad) { statusEl.innerHTML = '<span style="color:#e74c3c;">Adinizi girin</span>'; return; }
        if (!tel || tel.length < 10) { statusEl.innerHTML = '<span style="color:#e74c3c;">Gecerli telefon girin</span>'; return; }

        // Amorf verisini al
        var shape = window.__OzelOlcuAmorf ? window.__OzelOlcuAmorf.getShape() : null;
        if (!shape) { statusEl.innerHTML = '<span style="color:#e74c3c;">Amorf sekil secin</span>'; return; }

        statusEl.innerHTML = '<span style="color:#9b59b6;">Gonderiliyor...</span>';
        this.disabled = true;

        try {
          var baseUrl = window.location.hostname === 'localhost' ? '' : 'https://dolcevita-massimo.ngrok.io';
          var resp = await fetch(baseUrl + '/amorf-pdf-request', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              musteri: { ad: ad, soyad: soyad, tel: tel, email: email },
              radii: shape.radii,
              widthCm: shape.widthCm,
              lengthCm: shape.lengthCm,
              edgeType: shape.edgeType
            })
          });
          var j = await resp.json();
          if (j.ok) {
            statusEl.innerHTML = '<span style="color:#27ae60;"><i class="fas fa-check-circle"></i> ' + j.message + '</span>';
            setTimeout(function() { modal.style.display = 'none'; }, 4000);
          } else {
            statusEl.innerHTML = '<span style="color:#e74c3c;">' + (j.error || 'Hata olustu') + '</span>';
          }
        } catch(e) {
          statusEl.innerHTML = '<span style="color:#e74c3c;">Baglanti hatasi</span>';
        }
        this.disabled = false;
      });
    })();
  }

  // ========== GENİŞLİK SNAP ==========
  function snapWidth(input) {
    var val = parseInt(input);
    if (!val || val < 1) return null;
    for (var i = 0; i < SNAP_RANGES.length; i++) {
      var r = SNAP_RANGES[i];
      if (val >= r.min && val <= r.max) return r.snap;
    }
    return null;
  }

  // ========== BOYUT DEĞİ��İMİ ==========
  function onDimensionChange() {
    var rawWidth = parseInt(elWidth.value);
    var rawLength = parseInt(elLength.value);

    // Şekil-ölçü uyarı onDimensionChange'den kaldırıldı — sadece kullanıcı
    // şekil butonuna tıkladığında çıkması için. Ölçü değişikliğinde otomatik uyarma.

    if (rawWidth > 0) {
      var snapped = snapWidth(rawWidth);
      if (snapped) {
        currentSnappedWidth = snapped;
        if (rawWidth !== snapped) {
          elWidthInfo.textContent = '→ ' + snapped + 'cm ruloya göre hesaplanacak';
          elWidthInfo.className = 'ozel-olcu-plus__info info';
        } else {
          elWidthInfo.textContent = snapped + 'cm rulo genişliği';
          elWidthInfo.className = 'ozel-olcu-plus__info info';
        }
      } else {
        currentSnappedWidth = null;
        elWidthInfo.textContent = 'Maksimum genişlik 200cm';
        elWidthInfo.className = 'ozel-olcu-plus__info error';
      }
    } else {
      currentSnappedWidth = null;
      elWidthInfo.textContent = '';
    }

    if (rawLength > 0) {
      if (rawLength < MIN_LENGTH) {
        elLengthInfo.textContent = 'Minimum uzunluk ' + MIN_LENGTH + 'cm';
        elLengthInfo.className = 'ozel-olcu-plus__info error';
      } else if (rawLength > MAX_LENGTH) {
        elLengthInfo.textContent = 'Maksimum uzunluk ' + MAX_LENGTH + 'cm';
        elLengthInfo.className = 'ozel-olcu-plus__info error';
      } else {
        elLengthInfo.textContent = '';
      }
    } else {
      elLengthInfo.textContent = '';
    }

    updateState();

    // ÖLÇÜ DEĞİŞİMİ → amorf motor + hotspot senkron
    var _shpDim = document.getElementById('ozel-olcu-shape');
    var _isAmorfDim = _shpDim && (_shpDim.value === 'amorf' || _shpDim.value === 'daire' || _shpDim.value === 'oval');
    if (_isAmorfDim) {
      // Amorf motoruna yeni ölçüleri bildir — sadece geçerli değerde, aksi halde mevcut state'i koru
      if (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.setDimensions) {
        var _curAmDim = null;
        try { _curAmDim = window.__OzelOlcuAmorf.getShape(); } catch(e) {}
        var _wCmDim = rawWidth >= 50 ? rawWidth : (_curAmDim ? _curAmDim.widthCm : 200);
        var _hCmDim = rawLength >= 50 ? rawLength : (_curAmDim ? _curAmDim.lengthCm : 200);
        try { window.__OzelOlcuAmorf.setDimensions(_wCmDim, _hCmDim); } catch(e) {}
      }
      // Galeri giydirme yeniden render — cooldown bypass (ölçü değişince anında)
      if (window.__amorfForceUpdate) window.__amorfForceUpdate();
      else if (window.__amorfGaleriGuncelle) window.__amorfGaleriGuncelle();
    } else {
      // Dikdörtgen: fire hotspot metni width/height okur — yenile
      try { updateFireHotspot(); } catch(e) {}
      try { updateEdgeFabricHotspot(); } catch(e) {}
    }

    if (currentSnappedWidth && rawLength >= MIN_LENGTH && rawLength <= MAX_LENGTH) {
      checkStock(currentSnappedWidth, rawLength);
    } else {
      // Olcu gecersiz/bossa onceki istegin gec yaniti eski stok durumunu
      // yeniden gostermemeli.
      if (stockCheckAbort) {
        stockCheckAbort.abort();
        stockCheckAbort = null;
      }
      hideStock();
    }
  }

  // ========== STOK KONTROL ==========
  function getStockCacheKeyForPolicy(barcode, lengthM, includeFullRolls) {
    // [DEMIRCI ASAMA 2] kenar tipi anahtara dahil: Demirci karari kenara bagli (bordur/biye/canvas → yok)
    return barcode + '-' + lengthM + '-' + (includeFullRolls ? 'all' : 'partial') + '-' + (selectedEdge || '');
  }

  function getStockCacheKey(barcode, lengthM) {
    return getStockCacheKeyForPolicy(barcode, lengthM, INCLUDE_FULL_ROLLS);
  }

  function getStockPolicyQuery() {
    // [DEMIRCI ASAMA 2 — 2026-09-26] kenar tipi de gonderilir: bordur/biye/canvas Demirci'de yapilamaz (sunucu EDGE_NOT_SUPPORTED doner)
    return (INCLUDE_FULL_ROLLS ? '&includeFullRolls=1' : '') + '&edge=' + encodeURIComponent(selectedEdge || '');
  }
  // [DEMIRCI ASAMA 2] Merkez (1-0-1) yok ama Demirci magaza stogu (1-0-40) var → siparis kabul edilir
  function _isDemirciOk(d) { return !!(d && d.available !== true && d.demirci && d.demirci.available === true); }
  function _demirciMsg(d) {
    var g = d && d.demirci && d.demirci.teslimGun;
    return '\u2713 Demirci ma\u011fazam\u0131z\u0131n sto\u011fundan haz\u0131rlan\u0131r' + (g ? ' (tahmini teslim +' + g + ' i\u015f g\u00fcn\u00fc)' : '');
  }

  function checkStock(width, lengthCm) {
    var barcode = BARCODES[String(width)];
    if (!barcode) {
      showStock(false, 'Bu genişlikte stok bilgisi yok');
      hideAltInfo();
      loadPatternAlternatives(width, lengthCm);
      return;
    }

    var lengthM = lengthCm / 100;
    var cacheKey = getStockCacheKey(barcode, lengthM);

    if (stockCache[cacheKey] && (Date.now() - stockCache[cacheKey].time < STOCK_CACHE_TTL)) {
      applyStockResult(stockCache[cacheKey].data);
      return;
    }

    if (stockCheckAbort) stockCheckAbort.abort();
    stockCheckAbort = new AbortController();

    showStock(null, 'Stok kontrol ediliyor...');

    var url = MASSIMO_API + '/check-roll-availability?barcode=' + encodeURIComponent(barcode) + '&length=' + lengthM + getStockPolicyQuery();
    fetch(url, { signal: stockCheckAbort.signal })
      .then(function(resp) { return resp.json(); })
      .then(function(data) {
        stockCache[cacheKey] = { data: data, time: Date.now() };
        applyStockResult(data);
      })
      .catch(function(err) {
        if (err.name === 'AbortError') return;
        showStock(false, 'Üretim kapasitemiz dolmuştur, gün içerisinde uygunluk durumuna göre sistem otomatik olarak tekrar açılacaktır.');
      });
  }

  function applyStockResult(data) {
    if (data.available) {
      showStock(true, '✓ ' + currentSnappedWidth + 'cm ruloda ' + data.suitableRollCount + ' uygun top mevcut');
      hideAltInfo();
      hidePatternAlternatives();
    } else if (_isDemirciOk(data)) { // [DEMIRCI ASAMA 2]
      showStock(true, _demirciMsg(data));
      hideAltInfo();
      hidePatternAlternatives();
    } else if (data.suggestion && data.suggestion.length > 0) {
      var suggestions = data.suggestion.map(function(s) { return Math.floor(s * 100) + 'cm'; }).join(', ');
      showStock(false, 'Bu ölçüde stok yok');
      showAltInfo(suggestions);
      loadPatternAlternatives(currentSnappedWidth, parseInt(elLength.value));
    } else {
      showStock(false, data.message || 'Bu ölçüde stok bulunmuyor');
      hideAltInfo();
      loadPatternAlternatives(currentSnappedWidth, parseInt(elLength.value));
    }
    updateState();
  }

  function showStock(available, text) {
    if (available === null) {
      hideAltInfo(); // yükleniyor → önceki alt info temizle
      hidePatternAlternatives();
    }
    elStockStatus.style.display = 'flex';
    elStockText.textContent = text;
    elStockStatus.className = 'ozel-olcu-plus__stock' +
      (available === true ? ' stock-ok' : available === false ? ' stock-error' : ' stock-loading');
  }

  function hideStock() {
    elStockStatus.style.display = 'none';
    hideAltInfo();
    hidePatternAlternatives();
  }

  // ========== ALTERNATİF ÖLÇÜ BİLGİSİ ==========
  function getOrCreateAltInfo() {
    var el = document.getElementById('ozel-olcu-alt-info');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ozel-olcu-alt-info';
      el.className = 'ozel-olcu-plus__alt-info';
      el.style.display = 'none';
      if (elAddToCart && elAddToCart.parentNode) {
        elAddToCart.parentNode.insertBefore(el, elAddToCart.nextSibling);
      }
    }
    return el;
  }

  function showAltInfo(suggestions) {
    var el = getOrCreateAltInfo();
    el.innerHTML = 'Bu ende istediğiniz boy stokta bulunmuyor. Alternatif boylar: <strong>' + suggestions + '</strong>.';
    el.style.display = 'block';
  }

  function hideAltInfo() {
    var el = document.getElementById('ozel-olcu-alt-info');
    if (el) el.style.display = 'none';
  }

  // ========== AYNI KALITEDE STOKLU DESENLER ==========
  function getOrCreatePatternAlternatives() {
    var el = document.getElementById('ozel-olcu-pattern-alternatives');
    if (!el) {
      el = document.createElement('section');
      el.id = 'ozel-olcu-pattern-alternatives';
      el.className = 'ozel-olcu-plus__pattern-alts';
      el.setAttribute('aria-live', 'polite');
      el.style.display = 'none';

      if (elStockStatus && elStockStatus.parentNode) {
        elStockStatus.parentNode.insertBefore(el, elStockStatus.nextSibling);
      }
    }
    return el;
  }

  function setPatternAlternativesHidden() {
    var el = document.getElementById('ozel-olcu-pattern-alternatives');
    if (!el) return;
    el.style.display = 'none';
    el.removeAttribute('aria-busy');
    el.innerHTML = '';
  }

  function hidePatternAlternatives() {
    if (alternativeStockAbort) {
      alternativeStockAbort.abort();
      alternativeStockAbort = null;
    }
    alternativeCheckSeq++;
    pendingAlternativeRequest = null;
    setPatternAlternativesHidden();
  }

  function showPatternAlternativesLoading(width, lengthCm) {
    var el = getOrCreatePatternAlternatives();
    el.innerHTML = '';
    el.style.display = 'block';
    el.setAttribute('aria-busy', 'true');

    var loading = document.createElement('div');
    loading.className = 'ozel-olcu-plus__pattern-alts-loading';

    var spinner = document.createElement('span');
    spinner.className = 'ozel-olcu-plus__pattern-alts-spinner';
    spinner.setAttribute('aria-hidden', 'true');

    var text = document.createElement('span');
    text.textContent = width + ' × ' + lengthCm + ' cm için aynı kalitedeki stoklu desenler kontrol ediliyor…';

    loading.appendChild(spinner);
    loading.appendChild(text);
    el.appendChild(loading);
  }

  function fetchPatternAlternativeStock(candidate, width, lengthM, signal) {
    var cfg = candidate.config || {};
    var barcodes = cfg.barcodes || {};
    var barcode = barcodes[String(width)];
    var api = cfg.massimoApi || MASSIMO_API;
    if (!barcode || !api) return Promise.resolve(null);

    var includeFullRolls = cfg.includeFullRolls === true;
    var cacheKey = getStockCacheKeyForPolicy(barcode, lengthM, includeFullRolls);
    if (stockCache[cacheKey] && (Date.now() - stockCache[cacheKey].time < STOCK_CACHE_TTL)) {
      return Promise.resolve({ candidate: candidate, data: stockCache[cacheKey].data });
    }

    var url = api + '/check-roll-availability?barcode=' + encodeURIComponent(barcode) + '&length=' + lengthM;
    if (includeFullRolls) url += '&includeFullRolls=1';

    return fetch(url, signal ? { signal: signal } : undefined)
      .then(function(resp) {
        if (!resp.ok) throw new Error('Stock request failed: ' + resp.status);
        return resp.json();
      })
      .then(function(data) {
        stockCache[cacheKey] = { data: data, time: Date.now() };
        return { candidate: candidate, data: data };
      })
      .catch(function() {
        return null;
      });
  }

  function renderPatternAlternatives(items, width, lengthCm) {
    var el = getOrCreatePatternAlternatives();
    el.innerHTML = '';
    el.style.display = 'block';
    el.removeAttribute('aria-busy');

    var head = document.createElement('div');
    head.className = 'ozel-olcu-plus__pattern-alts-head';

    var copy = document.createElement('div');
    var title = document.createElement('h3');
    title.className = 'ozel-olcu-plus__pattern-alts-title';
    var bridge = window.__OzelOlcuPatternBridge;
    var qualityLabel = bridge && typeof bridge.qualityLabel === 'function'
      ? bridge.qualityLabel()
      : (inlineCfg.qualityCode || 'aynı kalite');
    if (qualityLabel) qualityLabel = qualityLabel.charAt(0).toUpperCase() + qualityLabel.slice(1);
    title.textContent = 'Bu ölçüde stokta olan ' + qualityLabel + ' desenleri';
    var subtitle = document.createElement('p');
    subtitle.className = 'ozel-olcu-plus__pattern-alts-subtitle';
    subtitle.textContent = width + ' × ' + lengthCm + ' cm ölçünüz korunarak desene geçebilirsiniz.';
    copy.appendChild(title);
    copy.appendChild(subtitle);
    head.appendChild(copy);
    el.appendChild(head);

    var rail = document.createElement('div');
    rail.className = 'ozel-olcu-plus__pattern-alts-rail';

    items.forEach(function(item) {
      var candidate = item.candidate;
      var data = item.data || {};
      var cfg = candidate.config || {};
      var code = candidate.patternCode || cfg.patternCode || 'Alternatif desen';

      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'ozel-olcu-plus__pattern-alt-card';
      card.setAttribute('aria-label', code + ' desenine geç');

      var visual = document.createElement('span');
      visual.className = 'ozel-olcu-plus__pattern-alt-visual';
      var imageUrl = candidate.patternImage || cfg.patternImage || '';
      if (imageUrl) {
        var img = document.createElement('img');
        img.src = imageUrl.replace('width=800', 'width=360');
        img.alt = code;
        img.loading = 'lazy';
        img.decoding = 'async';
        visual.appendChild(img);
      } else if (candidate.patternBg && /^linear-gradient\(/i.test(candidate.patternBg)) {
        visual.style.backgroundImage = candidate.patternBg;
      }

      var body = document.createElement('span');
      body.className = 'ozel-olcu-plus__pattern-alt-body';
      var name = document.createElement('strong');
      name.className = 'ozel-olcu-plus__pattern-alt-name';
      name.textContent = code;
      var stock = document.createElement('span');
      stock.className = 'ozel-olcu-plus__pattern-alt-stock';
      stock.textContent = '✓ ' + (data.suitableRollCount || 1) + ' uygun top';
      var action = document.createElement('span');
      action.className = 'ozel-olcu-plus__pattern-alt-action';
      action.textContent = 'Bu desene geç →';
      body.appendChild(name);
      body.appendChild(stock);
      body.appendChild(action);

      card.appendChild(visual);
      card.appendChild(body);
      card.addEventListener('click', function() {
        var bridge = window.__OzelOlcuPatternBridge;
        if (bridge && typeof bridge.select === 'function' && bridge.select(candidate.key)) {
          hidePatternAlternatives();
        }
      });
      rail.appendChild(card);
    });

    el.appendChild(rail);
  }

  function loadPatternAlternatives(width, lengthCm) {
    if (alternativeStockAbort) {
      alternativeStockAbort.abort();
      alternativeStockAbort = null;
    }

    if (!width || !lengthCm || lengthCm < MIN_LENGTH || lengthCm > MAX_LENGTH) {
      hidePatternAlternatives();
      return;
    }

    var bridge = window.__OzelOlcuPatternBridge;
    if (!bridge || typeof bridge.getSameQualityPatterns !== 'function') {
      pendingAlternativeRequest = { width: width, lengthCm: lengthCm };
      setPatternAlternativesHidden();
      return;
    }

    pendingAlternativeRequest = null;
    var currentKey = bridge.currentKey();
    var candidates = bridge.getSameQualityPatterns().filter(function(candidate) {
      return candidate && candidate.key !== currentKey && candidate.config;
    });
    var seq = ++alternativeCheckSeq;

    if (!candidates.length) {
      setPatternAlternativesHidden();
      return;
    }

    showPatternAlternativesLoading(width, lengthCm);
    var lengthM = lengthCm / 100;
    var requestController = new AbortController();
    alternativeStockAbort = requestController;
    var progressiveAvailable = [];
    Promise.all(candidates.map(function(candidate, candidateIndex) {
      return fetchPatternAlternativeStock(candidate, width, lengthM, requestController.signal).then(function(result) {
        if (seq !== alternativeCheckSeq || requestController.signal.aborted) return result;
        if (!window.__OzelOlcuPatternBridge || window.__OzelOlcuPatternBridge.currentKey() !== currentKey) return result;
        if (currentSnappedWidth !== width || parseInt(elLength.value) !== lengthCm) return result;

        // En yavas stok cevabini bekletmeden bulunan ilk uygun deseni goster.
        // Sira, temadaki orijinal desen sirasina gore sabit kalir.
        if (result && result.data && result.data.available === true) {
          result._order = candidateIndex;
          progressiveAvailable.push(result);
          progressiveAvailable.sort(function(a, b) { return a._order - b._order; });
          renderPatternAlternatives(progressiveAvailable, width, lengthCm);
        }
        return result;
      });
    })).then(function(results) {
      if (alternativeStockAbort === requestController) alternativeStockAbort = null;
      if (seq !== alternativeCheckSeq) return;
      if (!window.__OzelOlcuPatternBridge || window.__OzelOlcuPatternBridge.currentKey() !== currentKey) return;
      if (currentSnappedWidth !== width || parseInt(elLength.value) !== lengthCm) return;

      var available = results.filter(function(result) {
        return result && result.data && result.data.available === true;
      });

      if (!available.length) {
        setPatternAlternativesHidden();
        return;
      }
      renderPatternAlternatives(available, width, lengthCm);
    }).catch(function() {
      if (alternativeStockAbort === requestController) alternativeStockAbort = null;
      if (seq === alternativeCheckSeq) setPatternAlternativesHidden();
    });
  }

  window.addEventListener('ozel-olcu:pattern-bridge-ready', function() {
    if (!pendingAlternativeRequest) return;
    var request = pendingAlternativeRequest;
    pendingAlternativeRequest = null;
    loadPatternAlternatives(request.width, request.lengthCm);
  });

  // ========== FİYAT ==========
  function calculatePrice() {
    // UI/state manipule edilse bile non-Paradiso Biye fiyatlanamaz.
    if (!_isEdgeAllowed(selectedEdge, inlineCfg)) return null;
    if (!currentSnappedWidth || !M2_PRICE) return null;

    var lengthCm = parseInt(elLength.value);
    if (!lengthCm || lengthCm < MIN_LENGTH || lengthCm > MAX_LENGTH) return null;

    var m2 = (currentSnappedWidth * lengthCm) / 10000;
    var edge = EDGE_TYPES[selectedEdge] || {};
    var edgeMult = edge.priceMultiplier || 1.0;
    var edgePPM = edge.pricePerMeter || 0;
    var edgeCost = 0;
    var edgePerimeter = 0;
    // Overlok seciliyse ve overlokM2Price varsa farkli m2 fiyat kullan
    var activeM2 = M2_PRICE;
    if ((selectedEdge === 'overlok' || selectedEdge === 'sacak') && inlineCfg.overlokM2Price && inlineCfg.overlokM2Price > 0) {
      activeM2 = inlineCfg.overlokM2Price;
    }
    var price;

    if (edgePPM > 0) {
      // METRETUL MODEL: base m2 + cevre x TL/m
      edgePerimeter = 2 * (currentSnappedWidth + lengthCm) / 100;
      edgeCost = edgePerimeter * edgePPM;
      price = (m2 * activeM2) + edgeCost;
    } else {
      // CARPAN MODEL (Paradiso): m2 x fiyat x carpan
      price = m2 * activeM2 * edgeMult;
    }

    var amorfSurcharge = 0;
    var amorfTemplateFee = 0;
    var _shpEl = document.getElementById("ozel-olcu-shape");
    var _isAmorf = _shpEl && _shpEl.value === "amorf";
    if (_isAmorf && typeof _amorfPricing !== "undefined") {
      amorfSurcharge = price * (_amorfPricing.surcharge / 100);
      amorfTemplateFee = _amorfPricing.templateFee || 1000;
      price = price + amorfSurcharge + amorfTemplateFee;
    }
    /* [DV-OO-INDIRIM-KAPISI 2026-07-31] Karsilastirma fiyati artik sabit x1,43 carpanindan
       UYDURULMAZ. Sadece gercek firsat kampanyasi isareti (dv-oo-kampanya snippet'inin bastigi
       window.__DV_OO_KAMPANYA__) varsa VE sayfanin kullandigi m2 fiyati gercekten kampanyali
       m2 fiyatiysa, kampanya oncesi fiyat orandan turetilir. Aksi halde comparePrice = price
       (fark yok) -> "Indirimsiz/tasarruf", "%X urun", "· %X indirim", "Liste fiyati" yuzeyleri
       kendiliginden kapanir; sepette %10 gibi GERCEK indirimler aynen gorunmeye devam eder. */
    var dvOoKampanya = window.__DV_OO_KAMPANYA__ || null;
    var comparePrice = price;
    if (dvOoKampanya &&
        Number(dvOoKampanya.salePrice) > 0 &&
        Number(dvOoKampanya.basePrice) > Number(dvOoKampanya.salePrice) &&
        Math.abs(activeM2 - Number(dvOoKampanya.salePrice)) < 1) {
      comparePrice = price * (Number(dvOoKampanya.basePrice) / Number(dvOoKampanya.salePrice));
    }

    return {
      price: Math.round(price * 100) / 100,
      comparePrice: Math.round(comparePrice * 100) / 100,
      m2: m2,
      m2Price: activeM2,
      edgeMultiplier: edgeMult,
      edgePricePerMeter: edgePPM,
      edgePerimeter: Math.round(edgePerimeter * 100) / 100,
      edgeCost: Math.round(edgeCost * 100) / 100,
      amorfSurcharge: Math.round(amorfSurcharge * 100) / 100,
      amorfTemplateFee: amorfTemplateFee,
      isAmorf: !!_isAmorf
    };
  }

  function formatTL(amount) {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
  }

  // ========== UI STATE ==========
  function updateState() {
    var priceData = calculatePrice();

    if (priceData) {
      elPriceDisplay.style.display = 'block';
      elPrice.textContent = formatTL(priceData.price);
      /* [DV-OO-INDIRIM-KAPISI] fark yoksa ustu cizili fiyat hic basilmaz */
      if (priceData.comparePrice > priceData.price + 0.5) {
        elComparePrice.textContent = formatTL(priceData.comparePrice);
        elComparePrice.style.display = '';
      } else {
        elComparePrice.textContent = '';
        elComparePrice.style.display = 'none';
      }
      // AI Vision section'ı özel ölçü fiyatıyla güncelle (variant:change event)
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: {
          variant: {
            price: Math.round(priceData.price * 100),
            compare_at_price: Math.round(priceData.comparePrice * 100),
            title: (currentSnappedWidth || '') + 'x' + (elLength && elLength.value || '') + 'cm'
          }
        }}));
      } catch(_evErr) {}
      var detail = '';
      var _edgeName = selectedEdge.charAt(0).toUpperCase() + selectedEdge.slice(1);
      if (priceData.isAmorf) {
        var _haliBase = priceData.edgePricePerMeter > 0 ? (priceData.m2 * priceData.m2Price) : (priceData.m2 * priceData.m2Price * priceData.edgeMultiplier);
        var _edgeLine = '';
        if (priceData.edgePricePerMeter > 0 && priceData.edgeCost > 0) {
          _edgeLine = ' + ' + _edgeName + ' (' + priceData.edgePerimeter + 'm x ' + formatTL(priceData.edgePricePerMeter) + '/m): ' + formatTL(priceData.edgeCost);
        }
        var _ozelUcr = priceData.amorfSurcharge + priceData.amorfTemplateFee;
        detail = 'Halı: ' + formatTL(_haliBase) + _edgeLine + ' + Özel Tasarım: ' + formatTL(_ozelUcr);
      } else if (priceData.edgePricePerMeter > 0) {
        var _basePrice = priceData.m2 * priceData.m2Price;
        detail = priceData.m2.toFixed(2) + ' m² x ' + formatTL(priceData.m2Price) + '/m² = ' + formatTL(_basePrice);
        if (priceData.edgeCost > 0) { detail += ' + ' + _edgeName + ' (' + priceData.edgePerimeter + 'm x ' + formatTL(priceData.edgePricePerMeter) + '/m): ' + formatTL(priceData.edgeCost); }
      } else {
        detail = currentSnappedWidth + 'cm × ' + elLength.value + 'cm = ' + priceData.m2.toFixed(2) + ' m² × ' + formatTL(priceData.m2Price) + '/m²';
        if (priceData.edgeMultiplier !== 1.0) { detail += ' × ' + priceData.edgeMultiplier + ' (' + selectedEdge + ')'; }
      }
      elPriceDetail.textContent = detail;
    } else {
      elPriceDisplay.style.display = 'none';
    }

    var hasValidInputs = isOrderInputValid();
    var isValid = isFormValid();
    // Only a known unavailable result disables the CTA. A pending pre-check
    // is advisory; addToCart performs the authoritative fresh verification.
    var _bc   = BARCODES[String(currentSnappedWidth)];
    var _lCm  = parseInt(elLength.value);
    var _ck   = (_bc && _lCm) ? getStockCacheKey(_bc, _lCm / 100) : null;
    var _hit  = _ck ? stockCache[_ck] : null;
    var stockKnownUnavailable = !!(_hit && _hit.data && !_hit.data.available && !_isDemirciOk(_hit.data)); // [DEMIRCI ASAMA 2]
    elAddToCart.disabled = !hasValidInputs || stockKnownUnavailable;
    if (isValid) {
      elBtnText.textContent = 'SEPETE EKLE';
    } else if (!currentSnappedWidth) {
      elBtnText.textContent = 'Genişlik girin';
    } else if (!parseInt(elLength.value) || parseInt(elLength.value) < MIN_LENGTH) {
      elBtnText.textContent = 'Uzunluk girin';
    } else if (edgeUsesFabric(selectedEdge) && !selectedBiyeColor) {
      elBtnText.textContent = 'Kumaş seçin';
    } else if (stockKnownUnavailable) {
      if (_hit.data.suggestion && _hit.data.suggestion.length > 0) {
        elBtnText.textContent = 'Bu ebatta stok yok';
      } else {
        elBtnText.textContent = 'Bu ölçüde stok yok';
      }
    } else {
      elBtnText.textContent = 'STOK DOĞRULAYIP SEPETE EKLE';
    }
  }

  // DV_NONBLOCKING_STOCK_CTA_20260803: the advisory pre-check may be pending; /cart/add still requires a fresh available result.
  function isOrderInputValid() {
    // Sepet ve fiyat ayni fail-closed kenar politikasini kullanir.
    if (!_isEdgeAllowed(selectedEdge, inlineCfg)) return false;
    if (!currentSnappedWidth) return false;
    var lengthCm = parseInt(elLength.value);
    if (!lengthCm || lengthCm < MIN_LENGTH || lengthCm > MAX_LENGTH) return false;
    // Dolce Vita visual-v3 akışında Yuvarlak tek bir Çap değeridir.
    // UI senkronuna rağmen sepet çağrısı manipüle edilirse eşit olmayan
    // en/boy üretim siparişine dönüşmesin; doğrulama fail-closed kalsın.
    var _dvRoot = document.getElementById('banner-product');
    var _dvShape = document.getElementById('ozel-olcu-shape');
    if (_dvRoot && _dvRoot.getAttribute('data-dv-order-flow') === 'visual-v3' &&
        _dvShape && _dvShape.value === 'daire') {
      var diameterCm = parseInt(elWidth.value);
      if (!diameterCm || diameterCm !== lengthCm) return false;
    }
    if (edgeUsesFabric(selectedEdge) && !selectedBiyeColor) return false;
    return true;
  }

  function isFormValid() {
    if (!isOrderInputValid()) return false;
    var barcode = BARCODES[String(currentSnappedWidth)];
    var lengthM = parseInt(elLength.value) / 100;
    var cacheKey = getStockCacheKey(barcode, lengthM);
    var cached = stockCache[cacheKey];
    return !!(cached && cached.data && (cached.data.available || _isDemirciOk(cached.data))); // [DEMIRCI ASAMA 2]
  }

  // ========== SEPETE EKLE ==========
  var _addToCartLock = false;
  // DV_SAFE_DRAFT_IDEMPOTENCY_V2_20260729
  var _draftPendingMemory = null;
  var _draftPendingStorageKey = 'dv:safe-draft:pending:v2';
  var _draftPendingTtlMs = 30 * 60 * 1000;

  function getDraftRequestSignature(payload) {
    return JSON.stringify({
      productHandle: payload.productHandle,
      width: payload.width,
      length: payload.length,
      edgeType: payload.edgeType,
      edgeColor: payload.edgeColor || null,
      shapeType: payload.shapeType || 'dikdortgen',
      radii: payload.radii || null
    });
  }

  function generateDraftIdempotencyKey() {
    var randomPart = Math.random().toString(36).slice(2, 12);
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint32Array(2);
      window.crypto.getRandomValues(bytes);
      randomPart = bytes[0].toString(36) + bytes[1].toString(36);
    }
    return 'dv_' + Date.now().toString(36) + '_' + randomPart;
  }

  function getOrCreateDraftIdempotencyKey(payload) {
    var signature = getDraftRequestSignature(payload);
    var stored = _draftPendingMemory;
    try {
      var raw = window.sessionStorage &&
        window.sessionStorage.getItem(_draftPendingStorageKey);
      if (raw) stored = JSON.parse(raw);
    } catch (_) {}

    if (
      stored &&
      stored.signature === signature &&
      typeof stored.key === 'string' &&
      Date.now() - Number(stored.createdAt || 0) < _draftPendingTtlMs
    ) {
      _draftPendingMemory = stored;
      return stored.key;
    }

    stored = {
      signature: signature,
      key: generateDraftIdempotencyKey(),
      createdAt: Date.now()
    };
    _draftPendingMemory = stored;
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(
          _draftPendingStorageKey,
          JSON.stringify(stored)
        );
      }
    } catch (_) {}
    return stored.key;
  }
  // DV_CHECKOUT_NETWORK_TIMEOUTS_V3_20260729
  function fetchWithTimeout(url, options, timeoutMs, timeoutMessage) {
    var requestOptions = {};
    Object.keys(options || {}).forEach(function(key) {
      requestOptions[key] = options[key];
    });
    var controller = window.AbortController ? new AbortController() : null;
    if (controller) requestOptions.signal = controller.signal;

    return new Promise(function(resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function() {
        if (settled) return;
        settled = true;
        if (controller) controller.abort();
        reject(new Error(timeoutMessage || 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.'));
      }, timeoutMs);

      window.fetch(url, requestOptions).then(function(response) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(response);
      }, function(error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (error && error.name === 'AbortError') {
          reject(new Error(timeoutMessage || 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.'));
          return;
        }
        reject(error);
      });
    });
  }

  // ══════════ [DV-SEPET 2026-07-31] TEMANIN KENDİ SEPETİNE EKLEME ══════════
  // Taslak sipariş / güvenli ödeme yönlendirmesi kaldırıldı. Artık özel ölçü satırı
  // Shopify sepetine gizli bir kesim varyantı olarak eklenir:
  //   varyant = rulo eni (80/100/120/160/200), adet = uzunluk (cm)
  //   satır tutarı = birim fiyat x uzunluk = m² fiyat x alan
  // Harita: assets/dv-kesim-varyantlari.js (dv-kesim-harita-uret.js ile üretilir)
  function dvKesimVaryant() {
    var harita = window.__DV_KESIM_VARIANTS__;
    if (!harita) return { hata: 'Sepet fiyat tablosu y\u00fcklenemedi. Sayfay\u0131 yenileyip tekrar deneyin.' };
    var kalite = _normalizeQualityCode(inlineCfg);
    var kenar = (selectedEdge === 'sacak') ? 'overlok' : selectedEdge;
    var kayit = harita[kalite + '|' + kenar];
    if (!kayit) return { hata: 'Bu \u00fcr\u00fcn i\u00e7in sepet tan\u0131m\u0131 bulunamad\u0131 (' + kalite + '/' + kenar + ').' };
    var v = kayit.enler && kayit.enler[String(currentSnappedWidth)];
    if (!v || !v.id) return { hata: currentSnappedWidth + ' cm rulo i\u00e7in sepet tan\u0131m\u0131 yok.' };
    return { id: v.id, birim: Number(v.birim), handle: kayit.handle };
  }

  // DV_ADS_ATTRIBUTION_SPECIAL_SIZE_FAIL_CLOSED_20260817
  function dvAttributionSpecialSizeClickState() {
    var params;
    try { params = new URL(window.location.href).searchParams; }
    catch (_) { return { present: false, valid: false }; }
    var found = [];
    ['gclid', 'gbraid', 'wbraid'].forEach(function(type) {
      var value = String(params.get(type) || '').trim();
      if (value) found.push(value);
    });
    return {
      present: found.length > 0,
      valid: found.length === 1 && /^[A-Za-z0-9._~-]{10,300}$/.test(found[0])
    };
  }

  function dvAttributionSpecialSizeMarketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return true;
      return Boolean(cp.marketingAllowed());
    } catch (_) {
      return true;
    }
  }

  function dvAttributionPrepareSpecialSize(properties) {
    var REF_RE = /^dvattr_[A-Za-z0-9_-]{30,80}$/;
    var clickState = dvAttributionSpecialSizeClickState();
    var marketingAllowed = dvAttributionSpecialSizeMarketingAllowed();
    var bridge = window.DVAdsAttribution;
    delete properties['_dvAttributionRef'];

    // A malformed click or an explicit consent denial must never block a buyer.
    if (!marketingAllowed || (clickState.present && !clickState.valid)) {
      return Promise.resolve(properties);
    }

    // Organic/direct buyers may proceed; preserve an already verified opaque ref.
    if (!clickState.present) {
      var storedRef = bridge && typeof bridge.getRef === 'function' ? bridge.getRef() : '';
      if (REF_RE.test(String(storedRef || ''))) properties['_dvAttributionRef'] = storedRef;
      return Promise.resolve(properties);
    }

    // A valid consented paid click is fail-closed: cart/add may run only after
    // capture resolves to an opaque ref. Timeout rejects this add-to-cart attempt.
    if (!bridge || typeof bridge.ready !== 'function' || typeof bridge.getRef !== 'function') {
      return Promise.reject(new Error('Reklam bağlantısı henüz doğrulanamadı. Lütfen tekrar deneyin.'));
    }
    var timeoutId;
    var timeoutPromise = new Promise(function(_, reject) {
      timeoutId = window.setTimeout(function() {
        reject(new Error('Reklam bağlantısı doğrulama süresi doldu. Lütfen tekrar deneyin.'));
      }, 6000);
    });
    return Promise.race([Promise.resolve().then(function() { return bridge.ready(); }), timeoutPromise])
      .then(function() {
        window.clearTimeout(timeoutId);
        var ref = bridge.getRef();
        if (!REF_RE.test(String(ref || ''))) {
          throw new Error('Reklam bağlantısı doğrulanamadı. Lütfen tekrar deneyin.');
        }
        properties['_dvAttributionRef'] = ref;
        return properties;
      }, function(error) {
        window.clearTimeout(timeoutId);
        throw error;
      });
  }

  function dvAttributionAssertSpecialSizeBeforePost(properties) {
    var REF_RE = /^dvattr_[A-Za-z0-9_-]{30,80}$/;
    var clickState = dvAttributionSpecialSizeClickState();
    var marketingAllowed = dvAttributionSpecialSizeMarketingAllowed();
    var suppliedRef = String(properties['_dvAttributionRef'] || '');
    var bridgeRef = "";
    try {
      var bridge = window.DVAdsAttribution;
      bridgeRef = bridge && typeof bridge.getRef === 'function' ? String(bridge.getRef() || '') : '';
    } catch (_) {}

    // Re-check consent and click validity synchronously at the FormData boundary.
    if (!marketingAllowed || (clickState.present && !clickState.valid)) {
      delete properties['_dvAttributionRef'];
      return properties;
    }

    if (clickState.present) {
      if (!REF_RE.test(suppliedRef) || !REF_RE.test(bridgeRef) || suppliedRef !== bridgeRef) {
        delete properties['_dvAttributionRef'];
        throw new Error('Reklam bağlantısı gönderimden önce doğrulanamadı. Lütfen tekrar deneyin.');
      }
      return properties;
    }

    // An organic continuation may carry a prior paid ref, but never a stale one.
    if (REF_RE.test(bridgeRef)) properties['_dvAttributionRef'] = bridgeRef;
    else delete properties['_dvAttributionRef'];
    return properties;
  }
  dvAttributionPrepareSpecialSize.dvContract = 'DV_ADS_ATTRIBUTION_SPECIAL_SIZE_FAIL_CLOSED_20260817';
  function dvSepeteEkle(properties, priceData) {
    var v = dvKesimVaryant();
    if (v.hata) {
      console.error('[OzelOlcuPlus] sepet tanimi:', v.hata);
      showError(v.hata); setLoading(false); _addToCartLock = false; return null;
    }
    var uzunlukCm = parseInt(elLength.value, 10);
    var satirTutar = Math.round(v.birim * uzunlukCm * 100) / 100;
    var sayfaTutar = priceData.price;
    // FİYAT KAPISI: sepete giden tutar sayfada yazandan YÜKSEK olamaz. Aşağı sapma
    // yalnızca birim fiyatın 2 ondalığa yuvarlanmasından gelebilir (<1 kuruş/cm).
    if (satirTutar > sayfaTutar + 0.005 || (sayfaTutar - satirTutar) > uzunlukCm * 0.01 + 0.005) {
      console.error('[OzelOlcuPlus] FIYAT KAPISI kapali', { satir: satirTutar, sayfa: sayfaTutar, birim: v.birim, uzunlukCm: uzunlukCm, varyant: v.id });
      showError('Fiyat do\u011frulamas\u0131 ba\u015far\u0131s\u0131z oldu, \u00fcr\u00fcn sepete eklenmedi. L\u00fctfen bizimle ileti\u015fime ge\u00e7in.');
      setLoading(false); _addToCartLock = false; return null;
    }

    // Aynı ölçü iki kez eklenirse Shopify satırları birleştirip adedi toplar (= halı boyu iki katına
    // çıkar). Her ekleme benzersiz bir _satirId taşır ki satırlar ayrı kalsın.
    properties['_satirId'] = 'oo_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 5);
    properties['_kesimVaryantId'] = String(v.id);
    properties['_birimFiyat'] = String(v.birim);
    properties['_sayfaTutar'] = String(sayfaTutar);
    if (inlineCfg && inlineCfg.name) properties['Model'] = String(inlineCfg.name);
    // [DV-SEPET-LINK 2026-08-02] sepet satiri gercek urune linklensin
    // DIKKAT: inlineCfg.productHandle Shopify handle'i DEGIL (ic anahtar, orn. 'tokyo-301-kahve') -> 404 verir.
    var _dvCfgK = inlineCfg || {};
    var _dvEdgeK = (document.querySelector('input[name="ozel-olcu-edge"]:checked') || {}).value || '';
    var _dvKaynakHandle = (_dvCfgK.shopifyHandles && _dvCfgK.shopifyHandles[_dvEdgeK]) || _dvCfgK.shopifyHandle || _dvCfgK.__resolvedPageHandle || ((window.location.pathname.split('/products/')[1] || '').split('?')[0].split('#')[0].split('/')[0]);
    if (_dvKaynakHandle) properties['_kaynakUrl'] = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + _dvKaynakHandle;

    var sections = [];
    try {
      document.dispatchEvent(new CustomEvent('cart:push:section.id', { bubbles: true, detail: { sections: sections } }));
    } catch (eS) {}

    dvAttributionAssertSpecialSizeBeforePost(properties);
    var fd = new FormData();
    fd.append('id', String(v.id));
    fd.append('quantity', String(uzunlukCm));
    // Public explanation only; calculation quantity and original measurements stay unchanged.
    properties['Kesim bilgisi'] = String(uzunlukCm) + ' cm (1 adet halı)';
    Object.keys(properties).forEach(function(k) {
      var deger = properties[k];
      if (deger === null || deger === undefined || deger === '') return;
      fd.append('properties[' + k + ']', String(deger));
    });
    if (sections.length) fd.append('sections', sections.join(','));

    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    _ozelOlcuCartBypass = true;
    return fetchWithTimeout(kok + 'cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }, 15000, 'Sepete ekleme zaman a\u015f\u0131m\u0131na u\u011frad\u0131. L\u00fctfen tekrar deneyin.')
      .then(function(resp) {
        return resp.json().catch(function() { return null; }).then(function(data) {
          if (!resp.ok) throw new Error((data && (data.description || data.message)) || '\u00dcr\u00fcn sepete eklenemedi.');
          return data;
        });
      })
      .then(function(data) {
        return fetch(kok + 'cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            _ozelOlcuCartBypass = false;
            if (data && data.sections) cart.sections = data.sections;
            // Temanin kendi akisi: hdt-cart-drawer bu olayi dinleyip drawer'i acar.
            document.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', actionAfterATC: 'open_cart_drawer', cart: cart }
            }));
            console.log('[OzelOlcuPlus] sepete eklendi:', v.handle, v.id, 'adet', uzunlukCm, '=', satirTutar, 'TL');
            return true;
          });
      });
  }

  function addToCart() {
    if (_addToCartLock) return;
    _addToCartLock = true;
    // The fresh check below remains the authoritative stock gate.
    if (!isOrderInputValid()) { _addToCartLock = false; return; }

    // Amorf/daire/oval modda: önizleme hazır değilse sepete ekleme (boş item olmasın).
    // Önce radii'si sıfır/undefined olmamalı + galeri görseli mevcut olmalı.
    var _shCheck = document.getElementById('ozel-olcu-shape');
    if (_shCheck && (_shCheck.value === 'amorf' || _shCheck.value === 'daire' || _shCheck.value === 'oval')) {
      var _shData = (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) ? window.__OzelOlcuAmorf.getShape() : null;
      var _radiiOk = _shData && _shData.radii && _shData.radii.length > 0 &&
                     Array.from(_shData.radii).some(function(r) { return r > 0.1; });
      var _galImg = document.getElementById('bp-product-img') || document.querySelector('.bp-gallery__main img');
      var _imgOk = _galImg && (_galImg.src.startsWith('data:') || (_galImg.naturalWidth > 50 && _galImg.naturalHeight > 50));
      if (!_radiiOk || !_imgOk) {
        showError('Halı önizlemesi henüz hazır değil, birkaç saniye sonra tekrar deneyin.');
        setLoading(false);
        _addToCartLock = false;
        return;
      }
    }

    var priceData = calculatePrice();
    if (!priceData) { _addToCartLock = false; return; }

    setLoading(true);
    hideError();

    var barcode = BARCODES[String(currentSnappedWidth)];
    var lengthM = parseInt(elLength.value) / 100;

    // 1. Son stok kontrolü
    var freshUrl = MASSIMO_API + '/check-roll-availability?barcode=' + encodeURIComponent(barcode) + '&length=' + lengthM + getStockPolicyQuery() + '&_t=' + Date.now();
    fetchWithTimeout(
      freshUrl,
      null,
      8000,
      'Stok kontrolü zaman aşımına uğradı. Lütfen tekrar deneyin.'
    )
      .then(function(resp) {
        if (!resp.ok) throw new Error('Stok servisi geçici olarak yanıt vermiyor.');
        return resp.json();
      })
      .then(function(stockData) {
        if (!stockData.available && !_isDemirciOk(stockData)) { // [DEMIRCI ASAMA 2]
          showError('Stok durumu değişti. Lütfen farklı bir öl��ü deneyin.');
          applyStockResult(stockData);
          setLoading(false);
          return;
        }

        // 2. Üretim özelliklerini hazırla ve satırı temanın sepetine ekle.
        return Promise.resolve().then(function() {
          // 3. Sunucunun yeniden doğrulayacağı üretim özelliklerini hazırla.
          var edgeLabel = (EDGE_TYPES[selectedEdge] && EDGE_TYPES[selectedEdge].label) || selectedEdge;
          var selectedFabricLabel = getSelectedFabricLabel();

          var properties = {
            'Genişlik': elWidth.value + 'cm (' + currentSnappedWidth + 'cm rulo)',
            'Uzunluk': elLength.value + 'cm',
            'Kenar Tipi': edgeLabel,
                        'Toplam m²': priceData.m2.toFixed(2),
            '_rollBarcode': barcode,
            '_snapWidth': String(currentSnappedWidth),
            '_edgeType': selectedEdge,
            '_m2Price': String(priceData.m2Price),
            '_edgeMultiplier': String(priceData.edgeMultiplier),
          };
          // [DEMIRCI ASAMA 2] Merkez'de yok, Demirci magaza stogundan hazirlanacak → siparis satirina kaynak isareti
          if (_isDemirciOk(stockData)) {
            properties['_dvSource'] = 'DEMIRCI DEPO';
            properties['_dvTeslimGun'] = String((stockData.demirci && stockData.demirci.teslimGun) || '');
            properties['Hazırlanacak Depo'] = 'Demirci Mağaza' + (stockData.demirci && stockData.demirci.teslimGun ? ' (tahmini +' + stockData.demirci.teslimGun + ' iş günü)' : '');
            // dolcesrv sozlesmesi: personel Nebim satir aciklamasina AYNEN kopyalar — "DEMIRCI DEPO | 200x350 | OVERLOK | DİKDÖRTGEN"
            var _dvShapeEl = document.getElementById('ozel-olcu-shape');
            var _dvShapeMap = { 'dikdortgen': 'DİKDÖRTGEN', 'daire': 'YUVARLAK', 'oval': 'OVAL', 'amorf': 'AMORF' };
            var _dvShapeTxt = _dvShapeEl ? (_dvShapeMap[_dvShapeEl.value] || String(_dvShapeEl.value || '').toUpperCase()) : 'DİKDÖRTGEN';
            properties['Demirci Açıklama'] = 'DEMIRCI DEPO | ' + currentSnappedWidth + 'x' + parseInt(elLength.value, 10) + ' | ' + String(edgeLabel || selectedEdge || '').toLocaleUpperCase('tr-TR') + ' | ' + _dvShapeTxt;
          }
          // Metretul kenar fiyati varsa ek properties
          if (priceData.edgePricePerMeter > 0) {
            properties['_edgePricePerMeter'] = String(priceData.edgePricePerMeter);
            properties['_edgePerimeter'] = String(priceData.edgePerimeter);
            properties['_edgeCost'] = String(priceData.edgeCost);
            if (priceData.edgeCost > 0) {
              properties['Kenar Ucreti'] = edgeLabel + ' (' + priceData.edgePerimeter + 'm x ' + formatTL(priceData.edgePricePerMeter) + '/m) = ' + formatTL(priceData.edgeCost);
            }
          }
          // Halı Şekli property — TÜM şekillerde eklenir (dikdörtgen dahil)
          var _shapeEl = document.getElementById('ozel-olcu-shape');
          if (_shapeEl) {
            var _shapeLabels = { 'dikdortgen': 'Dikdörtgen', 'amorf': 'Amorf', 'daire': 'Yuvarlak', 'oval': 'Oval' };
            var _shapeLabel = _shapeLabels[_shapeEl.value] || (_shapeEl.value.charAt(0).toUpperCase() + _shapeEl.value.slice(1));
            properties['Halı Şekli'] = _shapeLabel;
            properties['_shapeType'] = _shapeEl.value;
          }
          if (priceData.isAmorf) {
            properties["Özel Tasarım Ücreti"] = formatTL(priceData.amorfSurcharge + priceData.amorfTemplateFee);
            properties["_amorfKesim"] = String(priceData.amorfSurcharge);
            properties["_amorfSablon"] = String(priceData.amorfTemplateFee);
          }

          if (selectedFabricLabel && selectedEdge !== 'sacak') {
            properties[selectedEdge === 'bordur' ? 'Bordür Kumaşı' : 'Biye Rengi'] = selectedFabricLabel;
            properties['_edgeColor'] = selectedBiyeColor;
            if (selectedEdge === 'biye') properties['_biyeColor'] = selectedBiyeColor;
            if (selectedEdge === 'bordur') properties['_bordurColor'] = selectedBiyeColor;
          }

          // Preview capture -> localStorage
          try {
            var _capSrc = null;
            // 1. Amorf modda: galeri img (giydirmeli)
            var _shEl = document.getElementById("ozel-olcu-shape");
            if (_shEl && (_shEl.value === "amorf" || _shEl.value === "daire" || _shEl.value === "oval")) {
              var _gImg = document.querySelector(".hdt-slider__slide.is-selected img, .hdt-slider__slide:first-child img, .hdt-product__media-item img");
              if (_gImg && _gImg.src && _gImg.src.indexOf("data:") === 0) { var _rc=document.createElement("canvas"); _rc.width=250; _rc.height=Math.round(250*(_gImg.naturalHeight/_gImg.naturalWidth||1)); var _rx=_rc.getContext("2d"); _rx.fillStyle="#fff"; _rx.fillRect(0,0,_rc.width,_rc.height); _rx.drawImage(_gImg,0,0,_rc.width,_rc.height); _capSrc=_rc.toDataURL("image/jpeg",0.6); }
              if (!_capSrc) { var _aC = document.querySelector("#ozel-olcu-amorf-area canvas"); if (_aC) { var _tc=document.createElement("canvas"); _tc.width=250; _tc.height=250; var _tx=_tc.getContext("2d"); _tx.fillStyle="#fff"; _tx.fillRect(0,0,_tc.width,_tc.height); _tx.drawImage(_aC,0,0,250,250); _capSrc=_tc.toDataURL("image/jpeg",0.6); } }
            } else {
              // 2. Dikdortgen: preview canvas
              var _pC = document.getElementById("ozel-olcu-preview-canvas");
              if (_pC && _pC.width > 50) { var _tc2=document.createElement("canvas"); var _sw=250; var _sh=Math.round(_sw*(_pC.height/_pC.width)); _tc2.width=_sw; _tc2.height=_sh; var _tx2=_tc2.getContext("2d"); _tx2.fillStyle="#fff"; _tx2.fillRect(0,0,_sw,_sh); _tx2.drawImage(_pC,0,0,_sw,_sh); _capSrc=_tc2.toDataURL("image/jpeg",0.6); }
            }
            // 3. FALLBACK: capture bos veya yoksa, galeri ana img kullan (sacak/motor render etmemis icin)
            if (!_capSrc || _capSrc.length < 3000) {
              var _gFb = document.querySelector(".hdt-product__media-item img");
              if (_gFb && _gFb.complete && _gFb.naturalWidth > 100) {
                try {
                  var _tcF = document.createElement("canvas");
                  var _swF = 250;
                  var _shF = Math.round(_swF * (_gFb.naturalHeight / _gFb.naturalWidth));
                  _tcF.width = _swF; _tcF.height = _shF;
                  var _txF = _tcF.getContext("2d");
                  _txF.fillStyle = "#fff"; _txF.fillRect(0, 0, _swF, _shF);
                  _txF.drawImage(_gFb, 0, 0, _swF, _shF);
                  _capSrc = _tcF.toDataURL("image/jpeg", 0.6);
                } catch(e) { /* CORS - sessizce yut */ }
              }
            }
            var _uid = null;
            // GENERIC "ozel_olcu_preview" key KULLANILMIYOR — her amorf KENDİ unique _uid'sine
            // yazılır. Farklı amorfların karışmaması için generic fallback KALDIRILDI.
            if (_capSrc) { try { _uid="oc_"+Date.now()+"_"+Math.random().toString(36).substr(2,4); properties["_previewId"]=_uid; localStorage.setItem("ozel_olcu_preview_"+_uid, _capSrc);
            // Amorf config kaydet (restore icin)
            if (_shEl && (_shEl.value === "amorf" || _shEl.value === "daire" || _shEl.value === "oval") && window.__OzelOlcuAmorf) {
              var _shapeData = window.__OzelOlcuAmorf.getShape ? window.__OzelOlcuAmorf.getShape() : null;
              var _activeFab = document.querySelector(".ozel-olcu-plus__color-btn.active img, .ozel-olcu-plus__color--active img");
              var _amorfCfg = {
                shape: _shEl.value,
                productHandle: window.location.pathname.split("/products/")[1] || "",
                widthCm: parseInt(document.getElementById("ozel-olcu-width").value) || 80,
                lengthCm: parseInt(document.getElementById("ozel-olcu-length").value) || 100,
                edgeType: (document.querySelector("input[name=ozel-olcu-edge]:checked") || {}).value || "biye",
                radii: _shapeData ? Array.prototype.slice.call(_shapeData.radii) : null,
                fabricUrl: _activeFab ? _activeFab.src : null,
                ts: Date.now()
              };
              // Generic "ozel_olcu_amorf_config" key KALDIRILDI — her amorf kendi unique _uid ile saklanır,
              // farklı amorf'ların karışması imkansız.
              try { _amorfCfg._previewId=_uid; localStorage.setItem("ozel_olcu_amorf_config_"+_uid, JSON.stringify(_amorfCfg)); } catch(e2){}
              // CART PROPERTY'LERİNE DE KOY (localStorage yedek; temiz tarayıcıda bile kaybolmasın)
              if (_shapeData && _shapeData.radii && _shapeData.radii.length) {
                try {
                  properties['_radii'] = JSON.stringify(Array.prototype.slice.call(_shapeData.radii).map(function(r){return Math.round(r*1000)/1000;}));
                  properties['_amorfShape'] = _shEl.value;
                  if (_activeFab && _activeFab.src) properties['_fabricSwatchUrl'] = _activeFab.src;
                } catch(e3) {}
              }
              console.log("[OzelOlcu] Amorf config kaydedildi:", _amorfCfg.shape, _amorfCfg.widthCm+"x"+_amorfCfg.lengthCm);
            } console.log("[OzelOlcu] Preview kaydedildi:", _capSrc.length, "chars"); } catch(e){} }
          } catch(e) { console.warn("[OzelOlcu] Capture err:", e); }

          // Preview'i Shopify CDN'e yükle → checkout'ta "Önizleme" link property'si gösterilsin
          // (Shopify checkout sayfası özelleştirilemez ama line item property'leri görünür)
          var _previewUploadPromise = Promise.resolve(null);
          if (_capSrc && _uid) {
            var _apiBase = (inlineCfg && inlineCfg.massimoApi) ? inlineCfg.massimoApi.replace('/api/massimo','') : 'https://dolcevita-massimo.ngrok.io';
            _previewUploadPromise = fetchWithTimeout(_apiBase + '/api/massimo/ozel-olcu-plus-upload-fabric', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                filename: 'amorf-' + _uid + '.jpg',
                contentBase64: _capSrc.split(',')[1],
                contentType: 'image/jpeg'
              })
            }, 12000, 'Önizleme yüklemesi zaman aşımına uğradı.').then(function(r) {
              if (!r.ok) throw new Error('Önizleme servisi geçici olarak yanıt vermiyor.');
              return r.json();
            }).then(function(j) {
              if (j && j.ok && j.cdnUrl) {
                console.log('[OzelOlcu] Preview CDN:', j.cdnUrl);
                return j.cdnUrl;
              }
              return null;
            }).catch(function(eU) { console.warn('[OzelOlcu] CDN upload fail:', eU.message); return null; });
          }

          return _previewUploadPromise.then(function(cdnUrl) {
            // Görünür "Önizleme" link property'si — cart/checkout'ta müşteri tıklayıp
            // seçtiği amorf şeklini görebilsin. Ayrıca _previewImage backend referansı için.
            if (cdnUrl) {
              // Tema item-cart.liquid sepet gorselini item.properties["Onizleme"] anahtarindan okuyor.
              properties['Onizleme'] = cdnUrl;
              properties['_previewImage'] = cdnUrl;
            }
            // DV_ADS_ATTRIBUTION_SPECIAL_SIZE_FAIL_CLOSED_20260817
            return dvAttributionPrepareSpecialSize(properties).then(function() {
              return dvSepeteEkle(properties, priceData);
            });
          });
        })
        .then(function(eklendi) {
          if (!eklendi) { _addToCartLock = false; return; }
          setLoading(false);
          elAddToCart.classList.add('success');
          elBtnText.textContent = 'SEPETE EKLENDİ';
          _addToCartLock = false;
          window.setTimeout(function() {
            elAddToCart.classList.remove('success');
            updateState();
          }, 2500);
        });
      })
      .catch(function(err) {
        _ozelOlcuCartBypass = false;
        _addToCartLock = false;
        console.error('[OzelOlcuPlus] Sepete ekleme hatası:', err);
        showError(err && err.message ? err.message : 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.');
        setLoading(false);
      });
  }

  // DV_SAFE_DRAFT_CHECKOUT_20260729:
  // Public JSONP fiyat mutasyonu kaldırıldı; katalog fiyatı hiçbir zaman değişmez.

  // ========== SEPET DRAWER KAPATMA ==========
  function closeCartDrawer() {
    var dEl = document.getElementById('CartDrawer');
    if (!dEl) return;
    // PRIMARY: hdt-cart-drawer Web Component'in native close mekanizması.
    // global.min.js'de: this.addEventListener("dialog:forceClose", t=>{ this.closeDialog(); t.stopPropagation() })
    // closeDialog() → animateClose + scroll unlock + touch-action temizle + overlay kaldır.
    // Mobilde manual close yeterli değildi (touch lock kalıyordu). Bu event her şeyi düzgün kapatır.
    dEl.dispatchEvent(new CustomEvent('dialog:forceClose', { bubbles: true, cancelable: true, composed: true }));
    // SUPPLEMENTAL: manuel açış yaptıysak (component open attribute'ü set etmeden) class/style temizliği
    dEl.classList.add('hdt-hidden');
    dEl.classList.remove('active','is-open','open');
    dEl.setAttribute('aria-hidden','true');
    dEl.style.transform = '';
    dEl.style.visibility = '';  // '' → inline style sil, component kendi gizleme mantığını çalıştırsın
    document.body.classList.remove('hdt-drawer-open','drawer-open','overflow-hidden');
    document.body.style.overflow = '';
    document.body.style.touchAction = '';  // mobil touch lock temizle
    var ov = document.querySelector('.hdt-drawer-overlay, .drawer-overlay');
    if (ov) { ov.classList.remove('active'); ov.style.display = 'none'; }
    // Bizim ekledigimiz X butonu — sonraki açılışta tekrar gösterilecek
    var ourBtn = dEl.querySelector('.hdt-mini-cart__close');
    if (ourBtn) ourBtn.style.display = 'none';
  }
  // Overlay (bosluk) tiklaninca kapat
  document.addEventListener('click', function(e) {
    var dEl = document.getElementById('CartDrawer');
    if (!dEl || !dEl.classList.contains('active')) return;
    var overlay = e.target.closest('.hdt-drawer-overlay, .drawer-overlay');
    if (overlay) { closeCartDrawer(); return; }
    // Drawer disina tiklama
    if (!e.target.closest('#CartDrawer') && !e.target.closest('[data-cart-toggle]') && !e.target.closest('.hdt-mini-cart-icon')) {
      closeCartDrawer();
    }
  });
  // ESC tusu ile kapat
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // ========== SEPET GORSEL — sadece object-fit:contain, layout temaya bırakıldı ==========
  // 200px / 120px forcing kaldırıldı: item layout'u bozuyordu (yan yana blob, ürün bilgisi gizleniyordu).
  // Tema kendi CSS'i ile item boyutunu yönetir. Biz sadece amorf blob'un kırpılmamasını sağlarız.
  (function(){
    var s = document.createElement('style');
    s.textContent = '#CartDrawer .hdt-mini-cart__img img, #CartDrawer .hdt-mini-cart__image img { object-fit:contain!important; }';
    document.head.appendChild(s);
  })();
  // ========== SEPET DRAWER OBSERVER ==========
  var _cartDrawerObserver = null;
  var _swapInProgress = false;
  function startCartDrawerObserver() {
    if (_cartDrawerObserver) return;
    var drawer = document.getElementById("CartDrawer") || document.querySelector("[class*=cart-drawer]");
    if (!drawer) return;
    _cartDrawerObserver = new MutationObserver(function() {
      if (_swapInProgress) return;
      _swapInProgress = true;
      setTimeout(swapCartDrawerImage, 200);
      setTimeout(function() { swapCartDrawerImage(); setTimeout(function() { _swapInProgress = false; }, 500); }, 800);
    });
    _cartDrawerObserver.observe(drawer, { childList: true, subtree: true });
  }
  // ========== SEPET GORSEL DEGISTIRME ==========
  function _addRestoreParam() {
    try {
      var _cfg = localStorage.getItem("ozel_olcu_amorf_config");
      if (!_cfg) return;
      var _items = document.querySelectorAll("#CartDrawer .hdt-mini-cart__item a, #CartDrawer .hdt-line-item a");
      for (var i = 0; i < _items.length; i++) {
        var _a = _items[i];
        if (_a.href && _a.href.indexOf("restore_amorf") === -1 && _a.closest && _a.closest("[data-ozel-olcu]")) {
          _a.href += (_a.href.indexOf("?") > -1 ? "&" : "?") + "restore_amorf=1";
        }
      }
    } catch(e) {}
  }
  function swapCartDrawerImage() {
    try {
      fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
        if (!cart.items || !cart.items.length) return;
        var imgMap = {};
        cart.items.forEach(function(item, idx) {
          var isOzel = item.properties && item.properties["_edgeType"];
          if (!isOzel) return;
          var _iPrev = null;
          if (item.properties && item.properties["_previewId"]) {
            try { _iPrev = localStorage.getItem("ozel_olcu_preview_" + item.properties["_previewId"]); } catch(e) {}
          }
          // Generic fallback KALDIRILDI — her item SADECE kendi _previewId'sinden görüntü alır.
          // Aksi halde previewId lookup fail eden ürüne en son eklenen amorf kopyalanır!
          if (_iPrev) { imgMap[idx] = _iPrev; console.log("[Swap] preview:", item.properties["_previewId"], "idx:", idx); }
          else if (item.properties["_kumasImage"]) { imgMap[idx] = item.properties["_kumasImage"]; }
          // Fallback yok: eğer _previewId mevcutsa ama localStorage'da yoksa, varsayılan ürün
          // görseli (Shopify line item image) kalır — YANLIŞ amorf gösterilmez.
        });
        if (!Object.keys(imgMap).length) return;
        var imgs = document.querySelectorAll(".hdt-mini-cart__img img");
        if (!imgs.length) imgs = document.querySelectorAll(".hdt-page-cart__img img");
        if (!imgs.length) {
          var all = document.querySelectorAll("img");
          var found = [];
          all.forEach(function(i) {
            var p = i.closest("[class*=mini-cart],[class*=cart-drawer],[class*=CartDrawer],[class*=hdt-page-cart]");
            if (p && i.getBoundingClientRect().width > 0) found.push(i);
          });
          imgs = found;
        }
        Object.keys(imgMap).forEach(function(idx) {
          var img = imgs[parseInt(idx)];
          if (img) {
            // SADECE src değiştir — inline style yok. Layout tema CSS'i yönetir.
            img.src = imgMap[idx];
            img.srcset = '';
            img.style.objectFit = 'contain'; // kırpılma önlemi, başka hiçbir style değişmez
            console.log('[Swap] Img degistirildi, idx:', idx);
          }
        });
      });
    } catch(e) {}
  }
  // ========== SAYFA YUKLEME SWAP (pageload swap) ==========
  setTimeout(function() {
    var lsP = null;
    try { lsP = localStorage.getItem("ozel_olcu_preview"); } catch(e) {}
    if (lsP) {
      // Observer baslat — kullanici sepet simgesine tiklarsa swap tetiklensin
      startCartDrawerObserver();
      swapCartDrawerImage();
      if (window.location.pathname === "/cart") swapCartDrawerImage();
    }
  }, 2000);

    // ========== YARDIMCI ==========
  function setLoading(loading) {
    elAddToCart.disabled = loading;
    elBtnSpinner.style.display = loading ? 'inline-block' : 'none';
    if (loading) elBtnText.textContent = 'İşleniyor...';
  }

  function showError(msg) {
    elError.textContent = msg;
    elError.style.display = 'block';
  }

  function hideError() {
    elError.style.display = 'none';
  }

  function updateCartCount() {
    // v5.3-basak: HDT tema hdt-cart-count web component'i cart:change event'ını dinliyor.
    // cart:change dispatch edilince count otomatik güncellenir.
    // Bu fonksiyon ek olarak generic selector'ları da günceller (eski tema uyumluluğu için).
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // hdt-cart-count web component'leri cart:change ile güncelleniyor,
        // yine de fallback olarak textContent'i doğrudan set et
        document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble, [data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.style.display = '';
          else el.style.display = 'none';
        });
      })
      .catch(function() {});
  }

  // ========== BAŞLAT ==========
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ═══ AMORF ENTEGRASYON ═══
  (function initAmorfIntegration() {
    var shapeSelect = document.getElementById("ozel-olcu-shape");
    var amorfContainer = document.getElementById("ozel-olcu-amorf-container");
    var _allowExplicitAmorfRestore = /(?:^|[?&])restore_amorf=1(?:&|$)/.test(window.location.search);
    var _restoreDimensionsTouched = false;
    [elWidth, elLength].forEach(function(_dimensionInput) {
      if (!_dimensionInput) return;
      _dimensionInput.addEventListener('input', function(_event) {
        if (_event.isTrusted) _restoreDimensionsTouched = true;
      });
    });
    if (!shapeSelect || !amorfContainer) return;
    var amorfInitialized = false;
    shapeSelect.setAttribute("autocomplete", "off");
    // Browser autofill gecikmeli kontrol
    var _hasConfig = false;
    try { _hasConfig = !!localStorage.getItem("ozel_olcu_amorf_config"); } catch(e){}
    var _hasSessionAmorf = false;
    try { _hasSessionAmorf = !!sessionStorage.getItem("amorf_active"); } catch(e){}
    if (!_hasConfig && !_hasSessionAmorf) {
      setTimeout(function() {
        if ((shapeSelect.value === "amorf" || shapeSelect.value === "daire" || shapeSelect.value === "oval") && !amorfInitialized) {
          shapeSelect.value = "dikdortgen";
          amorfContainer.style.display = "none";
          console.log("[Amorf] Browser autofill engellendi");
        }
      }, 100);
    }

    // Şekil-ölçü uyarı modalı: daire seçildi ama ölçüler eşit değil → görsel oval olur
    // Veya oval seçildi ama ölçüler eşit → görsel daire olur. Sadece bilgilendirme.
    window.__shapeDimWarn = function(shape, w, h) { _maybeShowShapeDimWarning(shape, w, h); };
    function _maybeShowShapeDimWarning(shape, w, h) {
      if (!w || !h) return; // ölçü girilmediyse uyarma
      var mismatch = null;
      if (shape === 'daire' && w !== h) {
        mismatch = {
          title: 'Tam Yuvarlak İçin Eşit Ölçü',
          body: 'Siparişiniz <b>' + w + ' × ' + h + ' cm</b> olduğu için canlı önizleme <b>oval</b> olarak gözükecektir.<br><br>Tam yuvarlak istiyorsanız en ve boy alanlarını <b>eşit</b> girin (örn. ' + Math.max(w,h) + ' × ' + Math.max(w,h) + ' cm veya ' + Math.min(w,h) + ' × ' + Math.min(w,h) + ' cm).<br><br>Oval görüntü istiyorsanız mevcut ölçü aynı kalabilir.'
        };
      } else if (shape === 'oval' && w === h) {
        mismatch = {
          title: 'Oval İçin Farklı Ölçü Gerekli',
          body: 'Siparişiniz <b>' + w + ' × ' + h + ' cm</b> (eşit ölçü) olduğu için canlı önizleme <b>tam yuvarlak</b> olarak gözükecektir.<br><br>Oval görüntü için en ve boy alanlarını <b>farklı</b> girin (örn. ' + w + ' × ' + Math.round(w*1.4) + ' cm).<br><br>Yuvarlak görüntü istiyorsanız mevcut ölçü aynı kalabilir.'
        };
      }
      if (!mismatch) return;
      // Aynı uyarı son 5 saniyede gösterildiyse tekrar açma
      var now = Date.now();
      if (window.__lastShapeDimWarnTs && (now - window.__lastShapeDimWarnTs) < 5000) return;
      window.__lastShapeDimWarnTs = now;
      _openShapeDimWarnModal(mismatch.title, mismatch.body);
    }

    function _openShapeDimWarnModal(title, body) {
      var ov = document.getElementById('ozel-olcu-shape-warn-modal');
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'ozel-olcu-shape-warn-modal';
        ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:10004;display:none;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(2px);';
        ov.innerHTML = '<div style="background:#fff;max-width:440px;width:100%;border-radius:14px;padding:24px 22px 20px;box-shadow:0 24px 60px rgba(0,0,0,0.35);position:relative;line-height:1.65;">' +
          '<button type="button" aria-label="Kapat" class="soud-close" style="position:absolute;top:8px;right:8px;width:30px;height:30px;border:none;background:#f3f3f3;border-radius:50%;font-size:18px;color:#666;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;">&times;</button>' +
          '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">' +
            '<div style="width:34px;height:34px;border-radius:50%;background:#fff5f0;display:flex;align-items:center;justify-content:center;color:#e8622a;flex-shrink:0;border:1px solid rgba(232,98,42,0.25);">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
            '</div>' +
            '<h3 class="soud-title" style="margin:0;font-size:16px;font-weight:700;color:#1a1a1a;"></h3>' +
          '</div>' +
          '<p class="soud-body" style="margin:0 0 16px;font-size:13.5px;color:#444;"></p>' +
          '<button type="button" class="soud-ok" style="width:100%;padding:10px;background:#e8622a;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;">Anladım</button>' +
        '</div>';
        document.body.appendChild(ov);
        function closeM() { ov.style.display = 'none'; }
        ov.addEventListener('click', function(e) { if (e.target === ov) closeM(); });
        ov.querySelector('.soud-close').addEventListener('click', closeM);
        ov.querySelector('.soud-ok').addEventListener('click', closeM);
        document.addEventListener('keydown', function(ev) { if (ev.key === 'Escape' && ov.style.display !== 'none') closeM(); });
      }
      ov.querySelector('.soud-title').textContent = title;
      ov.querySelector('.soud-body').innerHTML = body;
      ov.style.display = 'flex';
    }

    function onShapeChange() {
      var _sv = shapeSelect.value;
      var isAmorf = (_sv === "amorf" || _sv === "daire" || _sv === "oval");
      var _isPureAmorf = (_sv === "amorf");
      if (isAmorf) {
        var _wI = document.getElementById("ozel-olcu-width");
        var _hI = document.getElementById("ozel-olcu-length");
        var _wV = _wI ? (parseInt(_wI.value) || 0) : 0;
        var _hV = _hI ? (parseInt(_hI.value) || 0) : 0;
        // Olcu girilmemisse amorf yine de acilir, kullanici kendi girer
        // Şekil-ölçü uyarısı — SADECE kullanıcı şekil butonuna tıkladıysa göster
        // (sayfa yenilenme / sessionStorage restore tetiklemesin)
        if (window.__userClickedShapeBtn) {
          _maybeShowShapeDimWarning(_sv, _wV, _hV);
          window.__userClickedShapeBtn = false;
        }
      }
      // Daire ve oval teknik olarak kontur motorunu kullanir; ancak kullaniciya
      // yalniz gercek amorf tasariminda preset/editor galerisi gosterilir.
      amorfContainer.style.display = _isPureAmorf ? "block" : "none";
      // Overlok/Sacak label toggle
      // Amorf veya Tokyo -> "Overlok", diger dikdortgen -> "Sacak"
      var _overlokLabel = document.querySelector('[data-edge="overlok"] .ozel-olcu-plus__radio-label');
      if (_overlokLabel) {
        var _qCode = (inlineCfg && inlineCfg.qualityCode || '').toLowerCase();
        var _isTokyo = _qCode.indexOf('tokyo') >= 0;
        _overlokLabel.textContent = 'Overlok';
      }
      // Amorf state'i sessionStorage'a kaydet — SADECE radii dolu ise (fireChange onChange'de
      // de yapılır, bu noktada henüz boş olabilir). Silme her zaman yapılır.
      try {
        if (isAmorf) {
          var _curEdge = (document.querySelector('input[name="ozel-olcu-edge"]:checked') || {}).value || 'biye';
          var _curSh = window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape ? window.__OzelOlcuAmorf.getShape() : null;
          var _hasR = _curSh && _curSh.radii && _curSh.radii.length > 0 &&
                      Array.from(_curSh.radii).some(function(r) { return r > 0.1; });
          if (_hasR) {
            sessionStorage.setItem('amorf_active', JSON.stringify({
              shape: _sv, edgeType: _curEdge,
              radii: Array.prototype.slice.call(_curSh.radii),
              widthCm: elWidth && parseInt(elWidth.value) > 0 ? parseInt(elWidth.value) : _curSh.widthCm,
              lengthCm: elLength && parseInt(elLength.value) > 0 ? parseInt(elLength.value) : _curSh.lengthCm,
              presetIdx: (typeof _curSh.presetIdx === 'number' ? _curSh.presetIdx : -1),
              ts: Date.now()
            }));
          }
        }
        else { sessionStorage.removeItem('amorf_active'); }
      } catch(e) {}

      // 4-buton şekil seçici: HER ZAMAN görünür, aktif buton vurgulanır.
      // Amorf aktifken ek olarak "Amorf Şeklini Kaldır" butonu altta görünür.
      var _removeBtn = document.getElementById('amorf-remove-btn');
      var _shapeBtns = document.getElementById('bp-shape-btns');
      if (_shapeBtns) {
        _shapeBtns.style.display = 'flex';
        var _allBtns = _shapeBtns.querySelectorAll('.bp-shape-btn');
        _allBtns.forEach(function(b) {
          var isActive = b.getAttribute('data-shape') === _sv;
          b.style.borderColor = isActive ? '#e8622a' : '#ddd';
          b.style.background = isActive ? '#fff5f0' : '#fff';
          b.style.color = isActive ? '#e8622a' : '#888';
          if (isActive) b.classList.add('active'); else b.classList.remove('active');
        });
      }
      if (_isPureAmorf) {
        if (!_removeBtn) {
          _removeBtn = document.createElement('button');
          _removeBtn.id = 'amorf-remove-btn';
          _removeBtn.type = 'button';
          _removeBtn.className = 'bp-shape-select';
          _removeBtn.style.cssText = 'width:100%;padding:10px 16px;border:1px solid #e8622a;border-radius:8px;background:#fff;color:#e8622a;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;transition:all .2s;margin-top:8px;';
          _removeBtn.innerHTML = '\u2715 Amorf \u015eeklini Kald\u0131r';
          _removeBtn.addEventListener('mouseenter', function() { this.style.background='#e8622a'; this.style.color='#fff'; });
          _removeBtn.addEventListener('mouseleave', function() { this.style.background='#fff'; this.style.color='#e8622a'; });
          _removeBtn.addEventListener('click', function() {
            shapeSelect.value = 'dikdortgen';
            shapeSelect.dispatchEvent(new Event('change'));
            if (typeof restoreAmorfPrimaryGallery === 'function') restoreAmorfPrimaryGallery();
          });
          var _btnParent = _shapeBtns ? _shapeBtns.parentElement : shapeSelect.parentElement;
          _btnParent.appendChild(_removeBtn);
        }
        _removeBtn.style.display = '';
      } else {
        if (_removeBtn) _removeBtn.style.display = 'none';
      }

      // FIX 2026-05-07-FAZ1: Yuvarlak/oval/amorf'ta bordur HİÇ GÖZÜKMEZ (teknik olarak yapılamaz).
      // Sacak: SADECE gerçek amorf'ta gizli. Yuvarlak/oval'da SERBEST → yapay saçak motoru
      // (Faz 2) çevreye saçak çubukları çizecek.
      var _edgeLabels = document.querySelectorAll('[data-edge]');
      for (var _ri=0; _ri<_edgeLabels.length; _ri++) {
        var _ek2 = _edgeLabels[_ri].getAttribute('data-edge');
        var _edgeExists = _isEdgeAllowed(_ek2, inlineCfg);
        // Bordür: sadece gerçek amorf (elle çizilen) şeklinde gizle
        // Daire/oval'da: Paradiso config'de bordür var → göster; diğer kaliteler _edgeExists=false → zaten gizli
        var _hideForShape = (_isPureAmorf && _ek2 === 'bordur') || (_isPureAmorf && _ek2 === 'sacak');
        var _show = _edgeExists && !_hideForShape;
        _edgeLabels[_ri].style.display = _show ? '' : 'none';
        _edgeLabels[_ri].style.opacity = '';
        _edgeLabels[_ri].style.pointerEvents = '';
        _edgeLabels[_ri].setAttribute('data-edge-allowed', _show ? 'true' : 'false');
      }
      // Bordür seçiliyken SADECE gerçek amorf'a (elle çizilen) geçişte biye'ye düş
      // Daire/oval: Paradiso için bordür geçerli — düşme
      if (_isPureAmorf && selectedEdge === 'bordur') {
        selectedEdge = _isEdgeAllowed('biye', inlineCfg) ? 'biye' : _getFallbackEdge(inlineCfg);
        var _biyeR = document.querySelector('input[name="ozel-olcu-edge"][value="' + selectedEdge + '"]');
        if (_biyeR) {
          _biyeR.checked = true;
          var _bL = _biyeR.closest('.ozel-olcu-plus__radio');
          if (_bL) {
            document.querySelectorAll('.ozel-olcu-plus__radio').forEach(function(l) { l.classList.remove('active'); });
            _bL.classList.add('active');
          }
        }
      }
      // FIX 2026-05-07-FAZ1: Saçak seçili iken SADECE GERÇEK AMORF'a geçişte → overlok'a düş.
      // Yuvarlak/oval'da Saçak SERBEST — yapay saçak motoru (Faz 2) çevreye saçak çizecek.
      if (_isPureAmorf && selectedEdge === 'sacak') {
        selectedEdge = 'overlok';
        var _olR = document.querySelector('input[name="ozel-olcu-edge"][value="overlok"]');
        if (_olR) {
          _olR.checked = true;
          var _oL = _olR.closest('.ozel-olcu-plus__radio');
          if (_oL) {
            document.querySelectorAll('.ozel-olcu-plus__radio').forEach(function(l) { l.classList.remove('active'); });
            _oL.classList.add('active');
          }
        }
      }
      if (!isAmorf) {
        var _warnEl = document.getElementById('ozel-olcu-edge-warning');
        hideAmorfDimOverlay();
        try { sessionStorage.removeItem('amorf_session'); } catch(e) {}
        if (_warnEl) _warnEl.style.display = 'none';
        // Normal teslimat suresi
        var _tEl2 = document.getElementById('bp-teslimat-sure');
        if (_tEl2) _tEl2.innerHTML = 'Tahmini <b>2-3 \u0130\u015f G\u00fcn\u00fc</b>';
      }
      // Zaten init ise sadece preset degistir
      if (isAmorf && amorfInitialized && window.__OzelOlcuAmorf) {
        if (_sv === "daire" && window.__OzelOlcuAmorf.selectPresetByName) {
          window.__OzelOlcuAmorf.selectPresetByName("Daire");
        } else if (_sv === "oval" && window.__OzelOlcuAmorf.selectPresetByName) {
          window.__OzelOlcuAmorf.selectPresetByName("Oval");
        } else if (_sv === "amorf" && !window.__amorfSkipRandomPreset && window.__OzelOlcuAmorf.selectRandomPreset) {
          // FIX E2: Amorf'a her tiklamada editor ACIK gelsin (kullanici istegi - revize)
          window.__OzelOlcuAmorf.selectRandomPreset();
          if (window.__OzelOlcuAmorf.openEditor) {
            setTimeout(function(){ window.__OzelOlcuAmorf.openEditor(); }, 50);
          }
        }
        // Galeri yeniden render — şekil değişti, giydirme güncellenmeli
        if (window.__amorfForceUpdate) {
          setTimeout(function() { window.__amorfForceUpdate(); }, 200);
        } else if (window.__amorfGaleriGuncelle) {
          setTimeout(function() { window.__amorfGaleriGuncelle(); }, 200);
        }
      }
      if (isAmorf && !amorfInitialized && window.__OzelOlcuAmorf) {
        var wCm = parseInt(document.getElementById("ozel-olcu-width").value) || 80;
        var hCm = parseInt(document.getElementById("ozel-olcu-length").value) || 100;
        var edgeRadio = document.querySelector("input[name=ozel-olcu-edge]:checked");
        var currentEdge = edgeRadio ? edgeRadio.value : "biye";
        var _skipAmorfOnChange = (_sv === "daire" || _sv === "oval");
        window.__OzelOlcuAmorf.init(amorfContainer, {
          widthCm: wCm, lengthCm: hCm,
          edgeType: currentEdge === "bordur" ? "bordur" : (currentEdge === "biye" ? "biye" : (currentEdge === "sacak" ? "sacak" : "overlok")),
          onChange: function(data) {
            if (!_skipAmorfOnChange && window.__amorfGaleriGuncelle && !window.__doUpdateInProgress) { clearTimeout(window.__amorfGaleriDebounce); window.__amorfGaleriDebounce = setTimeout(function(){ window.__amorfGaleriGuncelle(); }, 300); }
            // Amorf boyut overlay guncelle — widthCm/lengthCm her zaman var (module state)
            if (data.widthCm && data.lengthCm) {
              updateAmorfDimOverlay(data);
              // Hotspot pozisyonunu amorf sekline gore guncelle
              updateEdgeFabricHotspot();
            }
            // Preset badge güncelle
            if (data.presetLabel && data.presetGradient) {
              _updatePresetBadge(data.presetLabel, data.presetGradient, data.radii);
            }
            // sessionStorage — şekil gerçekten set olduktan sonra (radii dolu) kaydet
            try {
              var _hasShape = data.radii && data.radii.length > 0 &&
                              Array.from(data.radii).some(function(r) { return r > 0.1; });
              if (_hasShape && data.widthCm && data.lengthCm) {
                var _curEdge2 = (document.querySelector('input[name="ozel-olcu-edge"]:checked') || {}).value || 'biye';
                sessionStorage.setItem('amorf_active', JSON.stringify({
                  shape: (document.getElementById('ozel-olcu-shape') || {}).value || 'amorf',
                  edgeType: _curEdge2,
                  radii: Array.prototype.slice.call(data.radii),
                  widthCm: data.widthCm,
                  lengthCm: data.lengthCm,
                  presetIdx: (typeof data.presetIdx === 'number' ? data.presetIdx : -1),
                  ts: Date.now()
                }));
              }
            } catch(eSS) {}
            console.log("[Amorf] Sekil degisti \u2014 Alan:", data.areaM2.toFixed(2), "m2, Cevre:", data.perimeterM.toFixed(2), "m");
          }
        });
        amorfInitialized = true;
        // Amorf secildiginde otomatik rastgele preset (restore sırasında skip)
        if (_sv === "amorf" && !window.__amorfSkipRandomPreset && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.selectRandomPreset) {
          setTimeout(function() {
            window.__OzelOlcuAmorf.selectRandomPreset();
            // FIX E2: Ilk init sonrasinda editoru otomatik AC
            if (window.__OzelOlcuAmorf.openEditor) window.__OzelOlcuAmorf.openEditor();
          }, 200);
        }
        // Daire/Oval preset secimi
        if ((_sv === "daire" || _sv === "oval") && window.__OzelOlcuAmorf.selectPresetByName) {
          window.__OzelOlcuAmorf.selectPresetByName(_sv === "daire" ? "Daire" : "Oval");
          _skipAmorfOnChange = false;
          if (window.__amorfGaleriGuncelle) setTimeout(function(){ window.__amorfGaleriGuncelle(); }, 2000);
        }
        console.log("[Amorf] Editor baslatildi:", wCm + "x" + hCm + "cm");
        // Amorf teslimat suresi guncelle
        var _tEl = document.getElementById('bp-teslimat-sure');
        if (_tEl) _tEl.innerHTML = 'Tahmini <b>3-5 \u0130\u015f G\u00fcn\u00fc</b> <span style="font-size:10px;color:#999;">(\u00d6zel \u00dcretim)</span>';
      }
      // Dikdörtgen moda geçince aktif fabric+edge ile preview motorunu tetikle
      if (!isAmorf && window.__ozelOlcuPreview) {
        setTimeout(function() {
          // Seçili kumaşı DOM'dan oku (amorf motoru preview state'ini set etmez)
          var _activeFabImg = document.querySelector('.ozel-olcu-plus__color-btn.active img');
          var _fabUrl = _activeFabImg ? _activeFabImg.src : (typeof getFabric === 'function' ? getFabric() : null);
          var _edgeEl = document.querySelector('.ozel-olcu-plus__radio.bp-edge-btn.active, [data-edge].active');
          var _et = (_edgeEl && _edgeEl.dataset.edge) || 'biye';
          if (_fabUrl && window.__ozelOlcuPreview && window.__ozelOlcuPreview.update) {
            window.__ozelOlcuPreview.update({ edgeType: _et, fabricUrl: _fabUrl });
          }
        }, 200);
      }
    }
    shapeSelect.addEventListener("change", onShapeChange);
    // Sayfa yuklemede overlok/sacak label ayarla
    (function() {
      var _isAmorfInit = (shapeSelect.value === 'amorf' || shapeSelect.value === 'daire' || shapeSelect.value === 'oval');
      var _qCode2 = (inlineCfg && inlineCfg.qualityCode || '').toLowerCase();
      var _isTokyo2 = _qCode2.indexOf('tokyo') >= 0;
      var _olLabel = document.querySelector('[data-edge="overlok"] .ozel-olcu-plus__radio-label');
      if (_olLabel) _olLabel.textContent = 'Overlok';
    })();
    // Browser autofill korumasi: config yoksa amorf acma
    var _hasAmorfConfig = false;
    try { _hasAmorfConfig = !!localStorage.getItem("ozel_olcu_amorf_config"); } catch(e){}
    var _hasSessionAmorf2 = false;
    try {
      _hasSessionAmorf2 = _allowExplicitAmorfRestore && !!sessionStorage.getItem("amorf_active");
    } catch(e){}
    if ((shapeSelect.value === "amorf" || shapeSelect.value === "daire" || shapeSelect.value === "oval") && !_hasAmorfConfig && !_hasSessionAmorf2) {
      shapeSelect.value = "dikdortgen";
      amorfContainer.style.display = "none";
    } else if (shapeSelect.value === "amorf" || shapeSelect.value === "daire" || shapeSelect.value === "oval") {
      // v5.0 fix: sessionStorage'da amorf_active varsa skip flag SET — onShapeChange icinde
      // selectRandomPreset() cagrisi kullanicinin kaydedilmis radii'sini EZMESIN. Aksi halde
      // sayfa yenilemede/cart-geri'de shape=amorf oldugunda shape RANDOMIZE ediliyordu.
      if (_hasSessionAmorf2) {
        window.__amorfSkipRandomPreset = true;
      }
      onShapeChange();
    }
    // AKTIF SessionStorage restore — sayfa yenilemede amorf'u geri yukle
    if (shapeSelect.value === "dikdortgen" && _hasSessionAmorf2) {
      try {
        var _ssData = JSON.parse(sessionStorage.getItem("amorf_active"));
        if (_ssData && _ssData.shape && _ssData.ts && (Date.now() - _ssData.ts) < 3600000) {
          console.log("[Amorf] SessionStorage restore:", _ssData.shape, 'edge:', _ssData.edgeType, 'w:', _ssData.widthCm, 'l:', _ssData.lengthCm, 'radii:', _ssData.radii ? _ssData.radii.length : 'none');
          // Ölçüleri inputlara yaz + input event dispatch (onDimensionChange tetiklensin,
          // stok kontrolü + currentSnappedWidth güncellensin, "Ölçü giriniz" uyarısı düşsün).
          if (_ssData.widthCm && elWidth && !elWidth.value) {
            elWidth.value = _ssData.widthCm;
            elWidth.dispatchEvent(new Event('input', { bubbles: true }));
          }
          if (_ssData.lengthCm && elLength && !elLength.value) {
            elLength.value = _ssData.lengthCm;
            elLength.dispatchEvent(new Event('input', { bubbles: true }));
          }
          // Random preset'i skip et (kullanıcının şeklini koruyacağız)
          window.__amorfSkipRandomPreset = true;
          setTimeout(function() {
            // Kullanıcı bu 300ms içinde kendi seçimini yaptıysa RESTORE YAPMA
            if (window.__userClickedShapeBtn) {
              console.log('[Amorf] Session restore ATLANDI — kullanıcı elle şekil seçti');
              return;
            }
            shapeSelect.value = _ssData.shape;
            shapeSelect.dispatchEvent(new Event("change"));
            // Preset idx varsa loadPreset ile restore (hem radii hem preset highlight doğru olur)
            // Aksi halde sadece setRadii (kullanıcı elle özelleştirdiyse)
            var _savedIdx = (typeof _ssData.presetIdx === 'number' && _ssData.presetIdx >= 0) ? _ssData.presetIdx : -1;
            if (_savedIdx >= 0 && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.loadPreset) {
              setTimeout(function() {
                window.__OzelOlcuAmorf.loadPreset(_savedIdx);
                console.log("[Amorf] Preset restore (idx):", _savedIdx);
                // Radii setRadii ile override et (kullanıcı özelleştirdiyse farklıdır)
                if (_ssData.radii && _ssData.radii.length && window.__OzelOlcuAmorf.setRadii) {
                  setTimeout(function() {
                    window.__OzelOlcuAmorf.setRadii(_ssData.radii);
                  }, 80);
                }
              }, 600);
            } else if (_ssData.radii && _ssData.radii.length) {
              setTimeout(function() {
                if (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.setRadii) {
                  window.__OzelOlcuAmorf.setRadii(_ssData.radii);
                  console.log("[Amorf] Radii restore:", _ssData.radii.length, "nokta");
                }
              }, 600);
            }
            // Edge type'ı da restore et
            if (_ssData.edgeType) {
              setTimeout(function() {
                var _eRadio = document.querySelector('input[name="ozel-olcu-edge"][value="' + _ssData.edgeType + '"]');
                if (_eRadio && !_eRadio.checked) {
                  _eRadio.checked = true;
                  _eRadio.dispatchEvent(new Event('change', {bubbles: true}));
                }
                // Flag'i reset et
                setTimeout(function() { window.__amorfSkipRandomPreset = false; }, 500);
              }, 900);
            } else {
              setTimeout(function() { window.__amorfSkipRandomPreset = false; }, 1500);
            }
          }, 300);
        } else {
          sessionStorage.removeItem("amorf_active");
        }
      } catch(e) { sessionStorage.removeItem("amorf_active"); }
    }
    // SessionStorage restore DEVRE DISI (performans)
    (function _restoreAmorfSession() { return; // DISABLED
      try {
        var _ss = sessionStorage.getItem('amorf_session');
        if (!_ss) return;
        var _sd = JSON.parse(_ss);
        // 1 saat gecmisse sil
        if (_sd.ts && (Date.now() - _sd.ts) > 3600000) { sessionStorage.removeItem('amorf_session'); return; }
        // Ayni urun sayfasinda mi?
        if (window.location.pathname.indexOf('/products/') === -1) return;
        console.log('[Amorf] Session restore basliyor:', _sd.widthCm + 'x' + _sd.lengthCm);
        // Olculeri doldur
        var _wE = document.getElementById('ozel-olcu-width');
        var _hE = document.getElementById('ozel-olcu-length');
        if (_wE && _sd.widthCm) { _wE.value = _sd.widthCm; _wE.dispatchEvent(new Event('input', {bubbles:true})); }
        if (_hE && _sd.lengthCm) { _hE.value = _sd.lengthCm; _hE.dispatchEvent(new Event('input', {bubbles:true})); }
        // Kenar tipi
        if (_sd.edgeType) {
          var _eR = document.querySelector('input[name=ozel-olcu-edge][value=' + _sd.edgeType + ']');
          if (_eR) { _eR.checked = true; _eR.dispatchEvent(new Event('change', {bubbles:true})); }
        }
        // Kumas
        if (_sd.fabricUrl) {
          setTimeout(function() {
            var _btns = document.querySelectorAll('.ozel-olcu-plus__color-btn img');
            for (var fi = 0; fi < _btns.length; fi++) {
              if (_btns[fi].src === _sd.fabricUrl) { _btns[fi].parentElement.click(); break; }
            }
          }, 300);
        }
        // Amorf sec + radii restore
        setTimeout(function() {
          // Kullanıcı kendi şeklini seçmişse override YAPMA
          if (window.__userClickedShapeBtn) {
            console.log('[Amorf] Session amorf restore ATLANDI — kullanıcı elle şekil seçti');
            return;
          }
          shapeSelect.value = 'amorf';
          shapeSelect.dispatchEvent(new Event('change'));
          if (_sd.radii && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.setRadii) {
            setTimeout(function() {
              window.__OzelOlcuAmorf.setRadii(_sd.radii);
              console.log('[Amorf] Session radii restore:', _sd.radii.length, 'nokta');
            }, 600);
          }
        }, 400);
      } catch(e) { console.warn('[Amorf] Session restore hata:', e); }
    })();

    // Amorf config restore — CART-DRIVEN (v5.0, 2026-04-22)
    // ÖNCEKI BUG: localStorage.getItem("ozel_olcu_amorf_config") — bu generic key artik ASLA
    // yazilmiyor (add-to-cart her amorf icin UID-keyed `ozel_olcu_amorf_config_{uid}` yaziyor).
    // KÖK NEDEN: dead-key okuma → sepetten geri donusta shape kaybolmasi.
    // YENI AKIS: /cart.js oku → current product handle ile eslesen ozel-olcu line item'i bul →
    //  1) `_previewId` varsa → localStorage `ozel_olcu_amorf_config_{uid}` → full radii/wCm/lCm/edge
    //  2) Aksi halde line item properties'ten (_radii, _shapeType, _edgeType, Genişlik/Uzunluk) oku
    // GARANTI: session storage tab-kapalı/yeni-tab senaryolarinda da shape restore edilir.
    (function _restoreAmorfConfigFromCart() {
      try {
        // Normal urun acilisi her zaman yeni ve bos bir siparistir. Sepetteki
        // eski olculer yalniz acik bir "duzenle" niyetiyle geri yuklenebilir.
        if (!_allowExplicitAmorfRestore) {
          console.log("[Amorf] Cart restore ATLANDI — acik duzenleme istegi yok");
          return;
        }
        var _curHandle = window.location.pathname.split("/products/")[1] || "";
        if (_curHandle.indexOf("?") > -1) _curHandle = _curHandle.split("?")[0];
        if (_curHandle.indexOf("/") > -1) _curHandle = _curHandle.split("/")[0];
        if (!_curHandle) return;

        // Tab-ici sessionStorage restore zaten calisti mi? (path A) O zaman cart-restore gereksiz.
        var _sessionActive = false;
        try { _sessionActive = !!sessionStorage.getItem("amorf_active"); } catch(e){}
        if (_sessionActive) { console.log("[Amorf] Cart restore ATLANDI — sessionStorage zaten var"); return; }

        fetch("/cart.js", { credentials: "same-origin" })
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(cart) {
            if (!cart || !cart.items || !cart.items.length) return;

            // Eslesen amorf item'i bul — ayni product handle'i (biye/bordur varyantlari dahil)
            // SHOPIFY_HANDLES[_tgtH] mantigiyla biye<->bordur ayri urun handle'lari;
            // biye ve bordur varyanti ayni kalitenin paraleli oldugu icin her item'in url'sini taratip
            // current handle ile eslestir.
            var _match = null;
            for (var i = 0; i < cart.items.length; i++) {
              var it = cart.items[i];
              var p = it.properties || {};
              if (!p._edgeType || !p._shapeType) continue;
              if (p._shapeType !== 'amorf' && p._shapeType !== 'daire' && p._shapeType !== 'oval') continue;
              var _itUrl = (it.url || '').split('?')[0];
              var _itHandle = _itUrl.split('/products/')[1] || '';
              _itHandle = _itHandle.split('/')[0];
              if (_itHandle === _curHandle) { _match = it; break; }
            }
            if (!_match) { console.log("[Amorf] Cart restore: current product icin amorf item yok"); return; }

            var p = _match.properties || {};
            var _shape = p._shapeType || p._amorfShape;
            var _edge = p._edgeType || 'biye';

            // 1) UID-keyed localStorage config (full data — add-to-cart'ta yazildi)
            var _fullCfg = null;
            if (p._previewId) {
              try {
                var _lc = localStorage.getItem('ozel_olcu_amorf_config_' + p._previewId);
                if (_lc) _fullCfg = JSON.parse(_lc);
              } catch(e) {}
            }

            // 2) Fallback: line item properties (backup yol — localStorage silinse bile calisir)
            function _parseCmFromLabel(lbl) {
              if (!lbl) return 0;
              var m = String(lbl).match(/(\d+)\s*cm/i);
              return m ? parseInt(m[1], 10) : 0;
            }
            var _wCm = (_fullCfg && _fullCfg.widthCm) || _parseCmFromLabel(p['Genişlik']) || 0;
            var _lCm = (_fullCfg && _fullCfg.lengthCm) || _parseCmFromLabel(p['Uzunluk']) || 0;
            var _radii = null;
            if (_fullCfg && _fullCfg.radii && _fullCfg.radii.length) {
              _radii = _fullCfg.radii;
            } else if (p._radii) {
              try {
                var _parsed = JSON.parse(p._radii);
                if (Array.isArray(_parsed) && _parsed.length) _radii = _parsed;
              } catch(e) {}
            }
            var _fabricUrl = (_fullCfg && _fullCfg.fabricUrl) || p._fabricSwatchUrl || null;

            if (!_wCm || !_lCm || !_radii || !_radii.length) {
              console.log("[Amorf] Cart restore: eksik veri, atlandi (w=" + _wCm + " l=" + _lCm + " radii=" + (_radii ? _radii.length : 0) + ")");
              return;
            }

            console.log("[Amorf] Cart restore BASLIYOR:", _shape, _wCm + "x" + _lCm, "edge:", _edge, "radii:", _radii.length, "source:", _fullCfg ? "uid-localStorage" : "cart-props");

            // Kullanici gecikmeli sepet cevabi gelmeden olcuye veya sekle
            // dokunduysa tum restore'u atla; boyut/sekil/kenar birlikte kalir.
            if (_restoreDimensionsTouched || window.__userClickedShapeBtn) {
              console.log('[Amorf] Cart restore ATLANDI — kullanici forma dokundu');
              return;
            }

            window.__amorfSkipRandomPreset = true;
            window.__amorfRestoreInProgress = true;

            // Genislik/uzunluk (sadece kullanici bosken yaz)
            var _wEl = document.getElementById("ozel-olcu-width");
            var _hEl = document.getElementById("ozel-olcu-length");
            if (_wEl && !_wEl.value) { _wEl.value = _wCm; _wEl.dispatchEvent(new Event("input", { bubbles: true })); }
            if (_hEl && !_hEl.value) { _hEl.value = _lCm; _hEl.dispatchEvent(new Event("input", { bubbles: true })); }

            // Kenar tipi restore
            if (_edge) {
              var _eRadio = document.querySelector('input[name=ozel-olcu-edge][value=' + _edge + ']');
              if (_eRadio && !_eRadio.checked) {
                _eRadio.checked = true;
                _eRadio.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }

            // Sekil + radii restore (amorf init + setRadii)
            setTimeout(function() {
              if (window.__userClickedShapeBtn) { window.__amorfRestoreInProgress = false; window.__amorfSkipRandomPreset = false; return; }
              if (shapeSelect.value !== _shape) {
                shapeSelect.value = _shape;
                shapeSelect.dispatchEvent(new Event("change"));
              }
              // Radii — amorf editor init olduktan sonra setRadii/loadPreset
              setTimeout(function() {
                if (!window.__OzelOlcuAmorf) { window.__amorfRestoreInProgress = false; window.__amorfSkipRandomPreset = false; return; }
                var _presetIdx = (_fullCfg && typeof _fullCfg.presetIdx === 'number' && _fullCfg.presetIdx >= 0) ? _fullCfg.presetIdx : -1;
                if (_presetIdx >= 0 && window.__OzelOlcuAmorf.loadPreset) {
                  window.__OzelOlcuAmorf.loadPreset(_presetIdx);
                  setTimeout(function() {
                    if (window.__OzelOlcuAmorf.setRadii) window.__OzelOlcuAmorf.setRadii(_radii);
                  }, 80);
                } else if (window.__OzelOlcuAmorf.setRadii) {
                  window.__OzelOlcuAmorf.setRadii(_radii);
                }
                console.log("[Amorf] Cart radii restore tamam:", _radii.length, "nokta");
              }, 500);

              // Kumas restore (varsa)
              if (_fabricUrl) {
                setTimeout(function() {
                  var _all = document.querySelectorAll(".ozel-olcu-plus__color-btn img");
                  for (var fi = 0; fi < _all.length; fi++) {
                    if (_all[fi].src === _fabricUrl) {
                      var _btn = _all[fi].parentElement;
                      if (_btn && !_btn.classList.contains('active')) _btn.click();
                      break;
                    }
                  }
                }, 1800);
              }

              // Post-slider giydirme tekrar uygula (slider takeover sonrasi gorsel bozulmasin)
              [1500, 3000, 5500].forEach(function(ms) {
                setTimeout(function() {
                  if (window.__amorfGaleriGuncelle) window.__amorfGaleriGuncelle();
                }, ms);
              });

              // Flag'leri temizle (kullanici bundan sonra non-shape secimler yaparsa geometry korunsun
              // ancak random preset tekrar acilabilsin ornegin sekil butonuna tiklarsa)
              setTimeout(function() {
                window.__amorfSkipRandomPreset = false;
                window.__amorfRestoreInProgress = false;
              }, 2500);
            }, 300);
          })
          .catch(function(err) { console.warn("[Amorf] Cart restore fetch hata:", err && err.message); });
      } catch(e) { console.warn("[Amorf] Cart restore outer hata:", e && e.message); }
    })();
    // === BANNER CONFIG RESTORE (ana sayfa banner'dan gelen secimler) ===
    (function _restoreBannerConfig() {
      try {
        var _urlP = new URLSearchParams(window.location.search);
        var _ow = _urlP.get('_ow'), _oh = _urlP.get('_oh');
        var _shape = _urlP.get('_shape'), _edge = _urlP.get('_edge');
        if (!_ow && !_shape) return; // Banner'dan gelmemis
        // Kalite tab navigate'ten geldik — sessionStorage amorf'u temizle (yeni state URL'de)
        try { sessionStorage.removeItem('amorf_active'); } catch(_se) {}

        // localStorage'dan ekstra veri oku (radii, renk)
        var _bcfg = null;
        try { var _bs = localStorage.getItem('ozel_olcu_banner_config');
          if (_bs) { _bcfg = JSON.parse(_bs);
            if (_bcfg.ts && (Date.now() - _bcfg.ts) > 300000) _bcfg = null; // 5dk gecmisse sil
          }
        } catch(e) {}

        console.log("[Banner] Config restore:", _ow+"x"+_oh, _shape, _edge);

        // 1. Genislik/uzunluk
        var _wEl = document.getElementById("ozel-olcu-width");
        var _hEl = document.getElementById("ozel-olcu-length");
        if (_wEl && _ow) { _wEl.value = _ow; _wEl.dispatchEvent(new Event("input", {bubbles:true})); }
        if (_hEl && _oh) { _hEl.value = _oh; _hEl.dispatchEvent(new Event("input", {bubbles:true})); }

        // 2. Kenar tipi
        if (_edge) {
          if (!_isEdgeAllowed(_edge, inlineCfg)) _edge = _getFallbackEdge(inlineCfg);
          var _eRadio = document.querySelector('input[name="ozel-olcu-edge"][value="' + _edge + '"]');
          if (_eRadio) { _eRadio.checked = true; _eRadio.dispatchEvent(new Event("change", {bubbles:true})); }
        }

        // 3. Sekil (setTimeout — amorf editor yuklenmeyi bekle)
        if (_shape && _shape !== 'dikdortgen') {
          setTimeout(function() {
            var _shSel = document.getElementById("ozel-olcu-shape");
            if (_shSel) {
              _shSel.value = _shape;
              _shSel.dispatchEvent(new Event("change"));
              console.log("[Banner] Sekil secildi:", _shape);

              // 4. Amorf radii (varsa)
              if (_shape === 'amorf' && _bcfg && _bcfg.radii && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.setRadii) {
                setTimeout(function() {
                  window.__OzelOlcuAmorf.setRadii(_bcfg.radii);
                  console.log("[Banner] Amorf radii restore:", _bcfg.radii.length, "nokta");
                }, 2000);
              }
            }
          }, 400);
        }

        // 5. URL temizle
        if (window.history && window.history.replaceState) {
          var _cleanUrl = window.location.pathname;
          window.history.replaceState({}, '', _cleanUrl);
        }

        // 6. localStorage temizle
        try { localStorage.removeItem('ozel_olcu_banner_config'); } catch(e) {}

      } catch(e) { console.warn("[Banner] Restore hata:", e); }
    })();
    console.log("[Amorf] Entegrasyon hazir");
  })();

  // ========== REINIT CONFIG (banner-product için) ==========
  window.__reinitOzelOlcuConfig = function(newCfg) {
    if (!newCfg) return;

    // ── KULLANICI DURUMUNU KORU — kalite değişince ölçü + amorf şekli SİLİNMEZ ──
    var _prevShape = null, _prevRadii = null, _prevEdge = null, _prevFabric = selectedBiyeColor;
    try {
      var _shSelPre = document.getElementById('ozel-olcu-shape');
      _prevShape = _shSelPre && _shSelPre.value;
      if ((_prevShape === 'amorf' || _prevShape === 'daire' || _prevShape === 'oval') &&
          window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
        var _amPre = window.__OzelOlcuAmorf.getShape();
        if (_amPre && _amPre.radii && _amPre.radii.length) {
          _prevRadii = Array.prototype.slice.call(_amPre.radii);
        }
      }
      var _eChecked = document.querySelector('input[name="ozel-olcu-edge"]:checked');
      _prevEdge = _eChecked && _eChecked.value || null;
    } catch(e) {}

    inlineCfg = newCfg;
    window.__OZEL_OLCU_CONFIG__ = newCfg;
    MASSIMO_API = newCfg.massimoApi || '';
    SNAP_RANGES = newCfg.snapRanges || [];
    M2_PRICE = newCfg.m2Price || 0;
    BARCODES = newCfg.barcodes || {};
    INCLUDE_FULL_ROLLS = newCfg.includeFullRolls === true;
    EDGE_TYPES = newCfg.edgeTypes || {};
    SHOPIFY_HANDLES = newCfg.shopifyHandles || {};
    // FIX 2026-05-07-SACAK: Yeni kalitede sacak alias yenile (Tokyo HARIC)
    _ensureSacakAlias();
    _syncBiyeAvailability(newCfg);
    COMPARE_MULTIPLIER = newCfg.compareMultiplier || 1.43;
    // State reset (fabric sıfırlanır — yeni kalitenin kumaşı gösterilir).
    // Ölçü + amorf şekli + KENAR TİPİ KORUNUR (yeni kalitede mevcutsa).
    // FIX 2026-05-07: kullanıcı saçak/bordür seçtiyse desen/kalite değişiminde KORU.
    selectedEdge = (_prevEdge && _isEdgeAllowed(_prevEdge, newCfg)) ? _prevEdge : _getFallbackEdge(newCfg);
    // Ayni kalite icindeki desen gecisinde musterinin biye/bordur kumasini koru.
    // Yeni config bu kodu icermiyorsa renderBiyeColors guvenli sekilde ilk secenege duser.
    selectedBiyeColor = _prevFabric;
    currentSnappedWidth = null;
    stockCache = {};
    // Variant ID'yi aktif desen + kenar kombinasyonundan guncelle. Tek-urunlu
    // Macaron/Sumatra configleri shopifyVariantIds tasir; yalnizca eski
    // shopifyVariantId alanina bakmak sepete onceki deseni ekleyebiliyordu.
    syncVariantIdForEdge(newCfg, selectedEdge);
    // UI: ölçü inputları SİLİNMEZ (kullanıcı değiştirmedikçe korunur).
    // elWidth.value / elLength.value — olduğu gibi bırakılır.
    if (elWidthInfo) elWidthInfo.textContent = '';
    if (elLengthInfo) elLengthInfo.textContent = '';
    hideStock();
    if (elPriceDisplay) elPriceDisplay.style.display = 'none';
    if (elAddToCart) elAddToCart.disabled = true;
    if (elBtnText) elBtnText.textContent = 'Lütfen ölçü girin';
    if (elError) elError.textContent = '';
    // Kenar tiplerini ve kumaş swatch'larını yeniden render et
    renderBiyeColors();
    // Edge buton visibility guncelle — config'de olmayan kenar tiplerini gizle
    var _edgeBtns = document.querySelectorAll('[data-edge]');
    // FIX 2026-05-07-FAZ1.1: Shape-aware edge visibility — amorf'ta saçak/bordur gizli, yuvarlak/oval'da sadece bordur gizli
    var _qcShape = document.getElementById('ozel-olcu-shape');
    var _qcShapeVal = _qcShape ? _qcShape.value : 'dikdortgen';
    var _qcIsAmorf = (_qcShapeVal === 'amorf' || _qcShapeVal === 'daire' || _qcShapeVal === 'oval');
    var _qcIsPureAmorf = (_qcShapeVal === 'amorf');
    var _qcFlowRoot = document.getElementById('banner-product');
    var _qcIsDvVisualV3 = !!(_qcFlowRoot && _qcFlowRoot.getAttribute('data-dv-order-flow') === 'visual-v3');
    for (var _ei = 0; _ei < _edgeBtns.length; _ei++) {
      var _edgeKey = _edgeBtns[_ei].getAttribute('data-edge');
      // Reinit ve manuel secim ayni kuralda kalir: yalniz gercek amorf,
      // sacak ve bordur kenarlarini gizler; yuvarlak/oval gizlemez.
      var _qcHideForShape = _qcIsDvVisualV3
        ? (_qcIsPureAmorf && (_edgeKey === 'bordur' || _edgeKey === 'sacak'))
        : ((_qcIsAmorf && _edgeKey === 'bordur') || (_qcIsPureAmorf && _edgeKey === 'sacak'));
      _edgeBtns[_ei].style.display = (_isEdgeAllowed(_edgeKey, newCfg) && !_qcHideForShape) ? '' : 'none';
    }
    // FIX 2026-05-07: korunmuş selectedEdge'in radio'sunu aktif yap (biye/bordur/overlok)
    var _activeRadio = document.querySelector('input[name="ozel-olcu-edge"][value="' + selectedEdge + '"]');
    if (_activeRadio) {
      _activeRadio.checked = true;
      var _activeLabel = _activeRadio.closest('.ozel-olcu-plus__radio');
      if (_activeLabel) {
        document.querySelectorAll('.ozel-olcu-plus__radio').forEach(function(l) { l.classList.remove('active'); });
        _activeLabel.classList.add('active');
      }
    }
    // Overlok/Sacak label guncelle
    var _shSel3 = document.getElementById('ozel-olcu-shape');
    var _isAmorf3 = _shSel3 && (_shSel3.value === 'amorf' || _shSel3.value === 'daire' || _shSel3.value === 'oval');
    var _qCode3 = (newCfg.qualityCode || '').toLowerCase();
    var _isTokyo3 = _qCode3.indexOf('tokyo') >= 0;
    var _olLabel2 = document.querySelector('[data-edge="overlok"] .ozel-olcu-plus__radio-label');
    if (_olLabel2) _olLabel2.textContent = 'Overlok';
    console.log('[OzelOlcu] Config reinit:', newCfg.productHandle || 'unknown', '| edges:', Object.keys(EDGE_TYPES).join(','));

    // ── AMORF RANDOM PRESET ENGELLE ──
    // banner-product.js 50ms sonra shapeSelect'e 'change' dispatch eder → onShapeChange
    // tetiklenir. Amorf init olmuşsa orada selectRandomPreset() çağrılır ve şekli rastgele
    // değiştirir. Flag'i set edip dispatch sonrası sıfırlıyoruz — kullanıcının çizdiği
    // şekil kalite değişiminde KORUNUR.
    if (_prevShape === 'amorf' || _prevShape === 'daire' || _prevShape === 'oval') {
      window.__amorfSkipRandomPreset = true;
    }

    // ── PREVIEW YENİLE: yeni kalitenin kumaşı gösterilir (eskisi değil) ──
    // Preview engine'e AÇIKÇA edge type'ı bildir (currentEdgeType cached olabilir)
    try {
      var _preview0 = window.__ozelOlcuPreview;
      if (_preview0 && _preview0.setEdgeType) { _preview0.setEdgeType(selectedEdge); }
    } catch(e) {}
    try { notifyPreview(); } catch(e) {}
    // Gallery image swap'dan sonra (updateGallery ~300-500ms) preview'i tekrar zorla
    // (eski kalite üzerinde render'lanmış bordur gibi stale state temizlensin)
    setTimeout(function() {
      try {
        var _preview1 = window.__ozelOlcuPreview;
        if (_preview1 && _preview1.setEdgeType) _preview1.setEdgeType(selectedEdge);
        if (typeof notifyPreview === 'function') notifyPreview();
      } catch(e) {}
    }, 600);
    // İkinci re-fire — product image lazy load uzun sürerse (networks idle değil)
    setTimeout(function() {
      try {
        var _preview2 = window.__ozelOlcuPreview;
        if (_preview2 && _preview2.setEdgeType) _preview2.setEdgeType(selectedEdge);
        if (typeof notifyPreview === 'function') notifyPreview();
      } catch(e) {}
    }, 1600);

    // ── AMORF ŞEKLİ KORU: kullanıcının önceki radii'sini yeni kalitede de uygula ──
    var _renderDone = function() {
      try { window.dispatchEvent(new CustomEvent('amorf:render:complete')); } catch(e) {}
    };
    if ((_prevShape === 'amorf' || _prevShape === 'daire' || _prevShape === 'oval') && _prevRadii) {
      // 120ms: banner-product.js 50ms change dispatch SONRA çalışır → onShapeChange
      // selectRandomPreset'i skip etti; biz gerçek radii'yi geri yazıyoruz.
      setTimeout(function() {
        try {
          if (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.setRadii) {
            window.__OzelOlcuAmorf.setRadii(_prevRadii);
          }
          if (window.__amorfForceUpdate) window.__amorfForceUpdate();
          else if (window.__amorfGaleriGuncelle) window.__amorfGaleriGuncelle();
        } catch(e) {}
        // Render bitti — loader'ı kapat + skip flag'ini kaldır
        setTimeout(function() {
          window.__amorfSkipRandomPreset = false;
          _renderDone();
        }, 500);
      }, 150);
    } else {
      // Dikdörtgen: fabric değişimi sonrası preview güncellendi, loader'ı kısa süre sonra kapat
      setTimeout(_renderDone, 400);
    }

    // ── ÖLÇÜ KORU: validation + stok kontrolü yeniden çalışsın ──
    // (elWidth/elLength değerleri silinmedi; input event dispatch ile onDimensionChange tetiklenir)
    setTimeout(function() {
      try {
        if (elWidth && elWidth.value) {
          elWidth.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } catch(e) {}
    }, 200);
  };

})();

  // ═══ AMORF GIYDIRME — sadece 1. galeri görselini güncelle ═══
  var _amorfGalleryOriginals = null;
  function getPrimaryGallerySlideImg() {
    var slideImg = document.querySelector('.hdt-slider__slide.hdt-product__media-item img');
    if (slideImg && slideImg.src) return slideImg;
    slideImg = document.querySelector('.hdt-product__media-item img, .product__media img');
    return slideImg && slideImg.src ? slideImg : null;
  }

  function getPrimaryGalleryThumbImg() {
    var thumbImg = document.querySelector('.hdt-slider__slide.hdt-thumbnail__media img');
    if (thumbImg && thumbImg.src) return thumbImg;
    thumbImg = document.querySelector('.hdt-thumbnail__media img');
    return thumbImg && thumbImg.src ? thumbImg : null;
  }

  function ensureAmorfGalleryOriginals() {
    if (_amorfGalleryOriginals) return _amorfGalleryOriginals;
    var slideImg = getPrimaryGallerySlideImg();
    var thumbImg = getPrimaryGalleryThumbImg();
    var zoomSpan = document.querySelector('.zoom-data[data-high-res-src]');
    var zoomImg = document.querySelector('.hdt-enhanced-zoom-image');
    _amorfGalleryOriginals = {
      slideSrc: slideImg ? (slideImg.getAttribute('data-original-src') || slideImg.src) : null,
      slideSrcset: slideImg ? slideImg.srcset : null,
      slideDt: slideImg ? slideImg.getAttribute('dt') : null,
      thumbSrc: thumbImg ? (thumbImg.getAttribute('data-original-src') || thumbImg.src) : null,
      thumbSrcset: thumbImg ? thumbImg.srcset : null,
      zoomSrc: zoomSpan ? zoomSpan.getAttribute('data-high-res-src') : null,
      zoomImgSrc: zoomImg ? zoomImg.src : null
    };
    return _amorfGalleryOriginals;
  }

  var _amorfCurrentDataUrl = null;
  function applyAmorfToPrimaryGallery(dataUrl) {
    var slideImg = getPrimaryGallerySlideImg();
    if (!slideImg || !dataUrl) return;
    ensureAmorfGalleryOriginals();
    _amorfCurrentDataUrl = dataUrl;
    window._amorfCurrentDataUrl = dataUrl;

    slideImg.setAttribute('data-original-src', _amorfGalleryOriginals.slideSrc || slideImg.src);
    slideImg.src = dataUrl;
    slideImg.srcset = '';
    if (slideImg.hasAttribute('dt')) slideImg.setAttribute('dt', dataUrl);

    var thumbImg = getPrimaryGalleryThumbImg();
    if (thumbImg) {
      thumbImg.setAttribute('data-original-src', _amorfGalleryOriginals.thumbSrc || thumbImg.src);
      thumbImg.src = dataUrl;
      thumbImg.srcset = '';
    }

    var zoomSpan = document.querySelector('.zoom-data[data-high-res-src]');
    if (zoomSpan) zoomSpan.setAttribute('data-high-res-src', dataUrl);
    var zoomImg = document.querySelector('.hdt-enhanced-zoom-image');
    if (zoomImg) zoomImg.src = dataUrl;

    // bp-gallery lightbox: data-zoom-src attribute (banner-product.js bunu okuyor)
    if (slideImg.hasAttribute('data-zoom-src')) slideImg.setAttribute('data-zoom-src', dataUrl);
    // Ayrica tum galeri img'lerinde data-zoom-src varsa guncelle
    document.querySelectorAll('[data-media-type="image"] img[data-zoom-src]').forEach(function(zImg) {
      zImg.setAttribute('data-zoom-src', dataUrl);
    });

    // Cetvel/ruler z-index duzeltmesi — img position:relative cetvelleri kapatiyor
    slideImg.style.zIndex = '1';
    var rulers = document.querySelectorAll('.bp-ruler');
    for (var ri = 0; ri < rulers.length; ri++) {
      rulers[ri].style.zIndex = '20';
    }

    // Lightbox selector'indaki img'leri de guncelle (PhotoSwipe buradan okuyor)
    var lbImgs = document.querySelectorAll('.hdt-product-media__main [data-media-type="image"] img');
    if (lbImgs.length > 0) {
      var firstLbImg = lbImgs[0];
      if (firstLbImg !== slideImg) {
        firstLbImg.setAttribute('data-original-src', firstLbImg.getAttribute('data-original-src') || firstLbImg.src);
        firstLbImg.src = dataUrl;
        firstLbImg.srcset = '';
      }
    }
  }

  // PhotoSwipe/Lightbox hook: modal acildiginda amorf gorseli uygula
  (function initPswpHook() {
    if (typeof MutationObserver === 'undefined') return;
    var _pswpObserver = new MutationObserver(function(mutations) {
      if (!_amorfCurrentDataUrl) return;
      for (var m = 0; m < mutations.length; m++) {
        for (var n = 0; n < mutations[m].addedNodes.length; n++) {
          var node = mutations[m].addedNodes[n];
          if (node.nodeType !== 1) continue;
          // PhotoSwipe popup veya herhangi bir lightbox modal
          var isPswp = (node.classList && (node.classList.contains('pswp') || node.classList.contains('pswp__container')));
          var isLightbox = node.querySelector && node.querySelector('.pswp__img, .pswp__zoom-wrap img, [class*="lightbox"] img');
          if (isPswp || isLightbox) {
            setTimeout(function() {
              var pswpImgs = document.querySelectorAll('.pswp__img, .pswp__zoom-wrap img, .pswp__item img');
              for (var pi = 0; pi < pswpImgs.length; pi++) {
                if (pswpImgs[pi].src && pswpImgs[pi].src.indexOf('data:') !== 0) {
                  pswpImgs[pi].src = _amorfCurrentDataUrl;
                  pswpImgs[pi].srcset = '';
                  console.log('[Amorf] PhotoSwipe img guncellendi');
                  break;
                }
              }
            }, 100);
            setTimeout(function() {
              var pswpImgs = document.querySelectorAll('.pswp__img, .pswp__zoom-wrap img, .pswp__item img');
              for (var pi = 0; pi < pswpImgs.length; pi++) {
                if (pswpImgs[pi].src && pswpImgs[pi].src.indexOf('data:') !== 0) {
                  pswpImgs[pi].src = _amorfCurrentDataUrl;
                  pswpImgs[pi].srcset = '';
                }
              }
            }, 500);
          }
        }
      }
    });
    _pswpObserver.observe(document.body, { childList: true, subtree: true });
    console.log('[Amorf] PhotoSwipe lightbox hook aktif');
  })();

  function restoreAmorfPrimaryGallery() {
    if (!_amorfGalleryOriginals) return;
    var slideImg = getPrimaryGallerySlideImg();
    var thumbImg = getPrimaryGalleryThumbImg();
    var zoomSpan = document.querySelector('.zoom-data[data-high-res-src]');
    var zoomImg = document.querySelector('.hdt-enhanced-zoom-image');

    if (slideImg && _amorfGalleryOriginals.slideSrc) {
      slideImg.src = _amorfGalleryOriginals.slideSrc;
      slideImg.setAttribute('data-original-src', _amorfGalleryOriginals.slideSrc);
      slideImg.srcset = _amorfGalleryOriginals.slideSrcset || '';
      if (_amorfGalleryOriginals.slideDt) slideImg.setAttribute('dt', _amorfGalleryOriginals.slideDt);
    }
    if (thumbImg && _amorfGalleryOriginals.thumbSrc) {
      thumbImg.src = _amorfGalleryOriginals.thumbSrc;
      thumbImg.setAttribute('data-original-src', _amorfGalleryOriginals.thumbSrc);
      thumbImg.srcset = _amorfGalleryOriginals.thumbSrcset || '';
    }
    if (zoomSpan && _amorfGalleryOriginals.zoomSrc) {
      zoomSpan.setAttribute('data-high-res-src', _amorfGalleryOriginals.zoomSrc);
    }
    if (zoomImg && _amorfGalleryOriginals.zoomImgSrc) {
      zoomImg.src = _amorfGalleryOriginals.zoomImgSrc;
    }
  }

  // Amorf boyut + fire overlay (galeri uzerinde)
  function updateAmorfDimOverlay(data) {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery) return;

    var overlay = document.getElementById('bp-amorf-dim-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'bp-amorf-dim-overlay';
      overlay.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:18;';
      // Hotspot CSS (IKEA tarzi pulse dot)
      if (!document.getElementById('bp-hotspot-css')) {
        var _hsCss = document.createElement('style');
        _hsCss.id = 'bp-hotspot-css';
        _hsCss.textContent =
          '@keyframes bp-pulse{0%{box-shadow:0 0 0 0 rgba(232,98,42,.4)}70%{box-shadow:0 0 0 8px rgba(232,98,42,0)}100%{box-shadow:0 0 0 0 rgba(232,98,42,0)}}' +
          '.bp-hs{position:absolute;z-index:25;cursor:pointer;pointer-events:auto}' +
          '.bp-hs__dot{width:20px;height:20px;border-radius:50%;background:#fff;border:2px solid #e8622a;animation:bp-pulse 2s infinite;transition:transform .2s;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#e8622a}' +
          '.bp-hs__dot:hover{transform:scale(1.2)}' +
          '.bp-hs__tip{display:none;position:absolute;z-index:30;width:190px}' +
          '.bp-hs__tip-inner{background:#fff;border-radius:8px;padding:10px 12px;box-shadow:0 4px 16px rgba(0,0,0,.12);font-size:11px;line-height:1.5;color:#555}' +
          '.bp-hs__tip-inner b{color:#e8622a;font-weight:700}' +
          '.bp-hs.open .bp-hs__tip{display:block}' +
          '.bp-hs.open .bp-hs__dot{animation:none;background:#e8622a;color:#fff;border-color:#e8622a}' +
          '.bp-dim-label{position:absolute;z-index:18;pointer-events:none;color:#e8622a;font-size:10px;font-weight:600;opacity:0.8}';
        document.head.appendChild(_hsCss);
      }

      // Dışarı tıklayınca kapat
      if (!window._bpHsClickHandler) {
        window._bpHsClickHandler = true;
        document.addEventListener('click', function(e) {
          if (!e.target.closest('.bp-hs')) {
            document.querySelectorAll('.bp-hs.open').forEach(function(el) { el.classList.remove('open'); });
          }
        });
      }

      overlay.innerHTML =
        '<div id="bp-dim-h" style="position:absolute;z-index:18;pointer-events:none;display:flex;align-items:center;gap:0;bottom:26px;left:50%;transform:translateX(-50%);"></div>' +
        '<div id="bp-dim-v" style="position:absolute;z-index:18;pointer-events:none;display:flex;flex-direction:column;align-items:center;gap:0;left:6px;top:50%;transform:translateY(-50%);"></div>' +
        '<div class="bp-hs" id="bp-hs-info" style="top:70%;left:4%;"></div>';
    gallery.appendChild(overlay);

    // Hotspot click handler — tooltip portal'da açılır (galery overflow kırpmaz)
    function setupHotspot(id, tipHtml) {
      var hs = document.getElementById(id);
      if (!hs || hs._init) return;
      hs._init = true;
      hs.innerHTML = '<div class="bp-hs__dot">\u2460</div><div class="bp-hs__tip" style="display:none;"><div class="bp-hs__tip-inner" id="' + id + '-text">' + tipHtml + '</div></div>';
      hs.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        var inner = document.getElementById(id + '-text');
        var html = inner ? inner.innerHTML : tipHtml;
        window.__bpPortalTip.toggle(hs, html);
      });
    }
    setupHotspot('bp-hs-info', 'Bilgilendirme');


    }

    // Amorf ölçü çizgileri template ruler ile AYNI bölümde:
    // - Genişlik (en): altta, template "200 cm" ruler'ının hemen üstünde "192 cm ①"
    // - Uzunluk (boy): solda, template "300 cm" ruler'ının hemen sağında "288 cm ①"
    // Her iki uçta OK tipi + dashed çizgi. Şeklin üzerinden geçmez, ruler ile çakışmaz.
    var dimH = document.getElementById('bp-dim-h');
    var dimV = document.getElementById('bp-dim-v');
    var _pImg = document.getElementById('bp-product-img');

    // Galeri alt + sol padding — template ruler (24px) + amorf dim (20px) yan yana
    gallery.style.paddingTop = '6px';
    gallery.style.paddingBottom = '52px';
    gallery.style.paddingLeft = '52px';
    gallery.style.paddingRight = '';
    if (_pImg) _pImg.style.transform = '';

    // Ruler etiketleri yalın template ölçüsü
    var _hLbl = document.getElementById('bp-ruler-h-label');
    var _vLbl = document.getElementById('bp-ruler-v-label');
    if (_hLbl) _hLbl.textContent = data.widthCm + ' cm';
    if (_vLbl) _vLbl.textContent = data.lengthCm + ' cm';

    // Dinamik genişlik — amorf şeklinin template içindeki oranı × ruler genişliği
    var _rulerW = gallery.querySelector('.bp-ruler--h');
    var _rulerWpx = _rulerW ? _rulerW.offsetWidth : gallery.offsetWidth * 0.5;
    var _wRatio = (data.shapeWidthCm || 0) / (data.widthCm || 100);
    var _dimWpx = Math.round(_rulerWpx * _wRatio);

    var _rulerH = gallery.querySelector('.bp-ruler--v');
    var _rulerHpx = _rulerH ? _rulerH.offsetWidth : gallery.offsetHeight * 0.4;
    var _hRatio = (data.shapeHeightCm || 0) / (data.lengthCm || 200);
    var _dimHpx = Math.round(_rulerHpx * _hRatio);

    // ① hotspot için yardımcı — tooltip YUKARI doğru açılır, ölçü çizgilerini kesmez
    function _amorfDimHotspot(idSuffix) {
      return '<span class="bp-hs bp-hs-inline" id="bp-hs-amorf-' + idSuffix + '" style="position:relative;display:inline-flex;margin-left:4px;align-items:center;pointer-events:auto;">' +
        '<span class="bp-hs__dot" style="width:14px;height:14px;font-size:8px;">\u2460</span>' +
        '<span class="bp-hs__tip" style="bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);width:min(220px, 80vw);max-width:220px;">' +
          '<span class="bp-hs__tip-inner">Amorf \u015fekliniz bu \u00f6l\u00e7\u00fcde <b>\u00fcretilir</b>. Sipari\u015f alan\u0131 rulodan kesilecek \u015fablon \u00f6l\u00e7\u00fcs\u00fcd\u00fcr; amorf kenarlar biraz daha k\u00fc\u00e7\u00fckt\u00fcr.</span>' +
        '</span>' +
      '</span>';
    }

    // Ok ucları (CSS triangle)
    var _arrL = '<span style="flex-shrink:0;width:0;height:0;border-top:4px solid transparent;border-bottom:4px solid transparent;border-right:6px solid #e8622a;"></span>';
    var _arrR = '<span style="flex-shrink:0;width:0;height:0;border-top:4px solid transparent;border-bottom:4px solid transparent;border-left:6px solid #e8622a;"></span>';
    var _arrU = '<span style="flex-shrink:0;width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:6px solid #e8622a;"></span>';
    var _arrD = '<span style="flex-shrink:0;width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:6px solid #e8622a;"></span>';

    // Yatay amorf dim — EN BÖLÜMÜNDE (template ruler bottom:4-24px; amorf dim bottom:45px — şekle yakın)
    if (dimH) {
      dimH.style.cssText = 'position:absolute;z-index:18;display:flex;align-items:center;gap:2px;bottom:45px;left:50%;transform:translateX(-50%);width:' + _dimWpx + 'px;pointer-events:none;';
      dimH.innerHTML =
        _arrL +
        '<span style="flex:1;border-top:1.4px dashed #e8622a;opacity:0.95;"></span>' +
        '<span style="padding:2px 6px;color:#e8622a;font-size:10px;font-weight:700;white-space:nowrap;background:rgba(255,255,255,0.95);border-radius:3px;display:inline-flex;align-items:center;pointer-events:auto;">' + (data.shapeWidthCm || '') + ' cm' + _amorfDimHotspot('w') + '</span>' +
        '<span style="flex:1;border-top:1.4px dashed #e8622a;opacity:0.95;"></span>' +
        _arrR;
    }

    // Dikey amorf dim — BOY BÖLÜMÜNDE (template ruler left:4-24px; amorf dim left:45px — şekle yakın)
    if (dimV) {
      dimV.style.cssText = 'position:absolute;z-index:18;display:flex;flex-direction:column;align-items:center;gap:2px;left:45px;top:50%;transform:translateY(-50%);height:' + _dimHpx + 'px;pointer-events:none;';
      dimV.innerHTML =
        _arrU +
        '<span style="flex:1;border-left:1.4px dashed #e8622a;opacity:0.95;"></span>' +
        '<span style="padding:4px 3px;color:#e8622a;font-size:10px;font-weight:700;white-space:nowrap;background:rgba(255,255,255,0.95);border-radius:3px;display:inline-flex;flex-direction:column;align-items:center;gap:3px;pointer-events:auto;">' +
          '<span style="writing-mode:vertical-lr;transform:rotate(180deg);">' + (data.shapeHeightCm || '') + ' cm</span>' +
          _amorfDimHotspot('h') +
        '</span>' +
        '<span style="flex:1;border-left:1.4px dashed #e8622a;opacity:0.95;"></span>' +
        _arrD;
    }

    // ① hotspot click handler (w ve h için) — portal tooltip
    ['w', 'h'].forEach(function(suf) {
      var hs = document.getElementById('bp-hs-amorf-' + suf);
      if (hs && !hs._inited) {
        hs._inited = true;
        hs.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          var inner = hs.querySelector('.bp-hs__tip-inner');
          var html = inner ? inner.innerHTML : 'Amorf üretim ölçüsü';
          window.__bpPortalTip.toggle(hs, html);
        });
      }
    });

    // Hotspot (ⓘ) — sol altta sabit (şekilden ve ruler'dan uzak)
    var _hsInfo = document.getElementById('bp-hs-info');
    if (_hsInfo) {
      _hsInfo.style.cssText = 'top:72%;left:4%;';
    }
    var hsInfo = document.getElementById('bp-hs-info-text');
    if (hsInfo) {
      var _hsHtml = 'Sipari\u015finiz <b>' + data.widthCm + '\u00d7' + data.lengthCm + ' cm</b> rulo alan\u0131ndan \u00f6zel olarak kesilecektir.';
      if (data.shapeWidthCm && data.shapeHeightCm) {
        _hsHtml += '<br><span style="margin-top:4px;display:inline-block;">\u00dcretim ebad\u0131: <b>' + data.shapeWidthCm + '\u00d7' + data.shapeHeightCm + ' cm</b></span>';
      }
      hsInfo.innerHTML = _hsHtml;
    }
  }

  function _updatePresetBadge(label, gradient, radii) {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery) return;
    var badge = document.getElementById('bp-preset-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'bp-preset-badge';
      badge.style.cssText = 'position:absolute;top:10px;left:10px;z-index:22;display:flex;align-items:center;gap:5px;background:rgba(255,255,255,0.95);backdrop-filter:blur(6px);padding:3px 8px 3px 3px;border-radius:12px;box-shadow:0 2px 10px rgba(0,0,0,0.12);cursor:pointer;pointer-events:auto;transition:all .2s;';
      badge.innerHTML = '<div class="bp-hs__dot" style="width:20px;height:20px;font-size:10px;flex-shrink:0;">3</div><svg id="bp-preset-svg" viewBox="0 0 28 24" width="22" height="18"></svg><span id="bp-preset-name" style="font-size:9px;font-weight:600;color:#666;letter-spacing:0.2px;"></span>';
      badge.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        var panel = document.getElementById('amorf-editor-panel');
        var btnE = document.getElementById('amorf-btn-editor');
        if (panel) {
          var isOpen = panel.style.display !== 'none';
          panel.style.display = isOpen ? 'none' : 'block';
          if (btnE) {
            btnE.style.borderColor = isOpen ? '#ddd' : '#e8622a';
            btnE.style.color = isOpen ? '#888' : '#e8622a';
            btnE.textContent = isOpen ? '\u270f\ufe0f \u015eekli D\u00fczenle' : '\u2715 Edit\u00f6r\u00fc Kapat';
          }
        }
        var amorfC = document.getElementById('ozel-olcu-amorf-container');
        if (amorfC && panel && panel.style.display !== 'none') amorfC.scrollIntoView({behavior:'smooth', block:'center'});
      });
      gallery.appendChild(badge);
    }
    // SVG guncelle
    var svg = document.getElementById('bp-preset-svg');
    var name = document.getElementById('bp-preset-name');
    if (name) name.textContent = label;
    if (svg && radii) {
      var N = radii.length || 60;
      var pts = [];
      for (var j = 0; j < N; j++) {
        var a = (j / N) * Math.PI * 2 - Math.PI / 2;
        pts.push({ x: 14 + Math.cos(a) * radii[j] * 11, y: 12 + Math.sin(a) * radii[j] * 10 });
      }
      var d = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
      var T = 0.28;
      for (var j = 0; j < N; j++) {
        var p0 = pts[(j - 1 + N) % N], p1 = pts[j], p2 = pts[(j + 1) % N], p3 = pts[(j + 2) % N];
        d += ' C' + (p1.x + T * (p2.x - p0.x)).toFixed(1) + ',' + (p1.y + T * (p2.y - p0.y)).toFixed(1) + ' ' + (p2.x - T * (p3.x - p1.x)).toFixed(1) + ',' + (p2.y - T * (p3.y - p1.y)).toFixed(1) + ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
      }
      d += 'Z';
      var gc = gradient || ['#e8622a', '#c2410c'];
      svg.innerHTML = '<defs><linearGradient id="pbg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="' + gc[0] + '"/><stop offset="100%" stop-color="' + gc[1] + '"/></linearGradient></defs><path d="' + d + '" fill="url(#pbg)" stroke="rgba(0,0,0,0.08)" stroke-width="0.4"/>';
    }
  }

  function hideAmorfDimOverlay() {
    var el = document.getElementById('bp-amorf-dim-overlay');
    if (el) el.style.display = 'none';
    // Gorseli ve galeriyi normal pozisyonuna dondur
    var _pImg2 = document.getElementById('bp-product-img');
    if (_pImg2) _pImg2.style.transform = '';
    var _gal2 = document.querySelector('.bp-gallery__main');
    if (_gal2) {
      _gal2.style.paddingBottom = '16px';
      _gal2.style.paddingTop = '';
      _gal2.style.paddingLeft = '';
      _gal2.style.paddingRight = '';
    }
    var _rH2 = document.querySelector('.bp-ruler--h');
    if (_rH2) _rH2.style.bottom = '0px';
    var pb = document.getElementById('bp-preset-badge');
    if (pb) pb.style.display = 'none';
  }
  function showAmorfDimOverlay() {
    var el = document.getElementById('bp-amorf-dim-overlay');
    if (el) el.style.display = '';
  }

  (function initAmorfPreview() {
    function isAmorfMode() { var s = document.getElementById("ozel-olcu-shape"); return s && (s.value === "amorf" || s.value === "daire" || s.value === "oval"); }
    var observer = new MutationObserver(function() {
      if (!isAmorfMode() || !window.__OzelOlcuAmorf) return;
      if (window.__amorfGaleriGuncelle) window.__amorfGaleriGuncelle();
    });
    setTimeout(function() {
      var colorWrap = document.querySelector(".ozel-olcu-plus__colors, [class*=color-grid]");
      if (colorWrap) observer.observe(colorWrap, {attributes: true, subtree: true, attributeFilter: ["class"]});
      document.querySelectorAll(".ozel-olcu-plus__color-btn").forEach(function(el) {
        el.addEventListener("click", function() {
          if (!isAmorfMode()) return;
          if (window.__amorfGaleriGuncelle) setTimeout(function() { window.__amorfGaleriGuncelle(); }, 100);
        });
      });
    }, 1500);
    console.log("[Amorf] Giydirme hook hazir");
    // Tumu/Burclar tab yonetimi amorf.js tarafindan yapiliyor
  })();


// === AMORF GIYDIRME v2 ===
var _amorfPricing = {surcharge: 30, templateFee: 1000};
var _amorfShapeSelect = document.getElementById("ozel-olcu-shape");
var _amorfPricingEnabled = !_amorfShapeSelect || _amorfShapeSelect.getAttribute("data-amorf-enabled") !== "false";
if (_amorfPricingEnabled) {
  fetch((window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.massimoApi || "") + "/ozel-olcu-amorf-pricing").then(function(r){return r.json()}).then(function(d){
    _amorfPricing.surcharge = d.amorfSurchargePercent || 30;
    _amorfPricing.templateFee = d.amorfTemplateFee || 1000;
    console.log("[Amorf] Fiyat:", _amorfPricing);
  }).catch(function(){});
}
var _origProductSrc = null;
// __resetAmorfOriginals IIFE icinde tanimlanacak
(function initAmorfGiydirme() {
  var _timer = null, _lastUrl = null;
  function isAmorf() { var s = document.getElementById("ozel-olcu-shape"); return s && (s.value === "amorf" || s.value === "daire" || s.value === "oval"); }
  function getFabric() { var a = document.querySelector(".ozel-olcu-plus__color-btn.active img"); return a ? a.src : null; }
  function getGallery() { return document.querySelector(".hdt-slider__slide img, .hdt-product__media-item img, .product__media img"); }
  var _updating = false; var _lastUpdateTime = 0; var _renderVersion = 0;
  // Desen/kalite degisiminde TUM state'i sifirla
  window.__resetAmorfOriginals = function() {
    _origProductSrc = null;
    _amorfGalleryOriginals = null;
    _updating = false;
    _lastUpdateTime = 0;
    _lastUrl = null;
    console.log('[Amorf] Full state reset (originals + cooldown + updating)');
  };
  function doUpdate() {
    // Safety: 10sn'den uzun suredir _updating true ise zorla reset
    if (_updating && (Date.now() - _lastUpdateTime > 10000)) {
      console.warn("[Amorf] _updating 10sn takili kaldi, zorla reset");
      _updating = false;
    }
    if (_updating) return;
    if (Date.now() - _lastUpdateTime < 200) return;
    _updating = true; _lastUpdateTime = Date.now();
    var _myVersion = ++_renderVersion;
    if (typeof window.__OzelOlcuAmorf === "undefined") { _updating = false; return; }
    if (isAmorf() === false) { _updating = false; return; }
    var _wEl = document.getElementById("ozel-olcu-width");
    var _hEl = document.getElementById("ozel-olcu-length");
    // Input geçerliyse kullan, değilse MEVCUT amorf state'ini koru (ölçü sıfırlanmasın)
    var _curShapeDims = null;
    try { _curShapeDims = window.__OzelOlcuAmorf.getShape(); } catch(e) {}
    var _parsedW = _wEl ? parseInt(_wEl.value) : NaN;
    var _parsedH = _hEl ? parseInt(_hEl.value) : NaN;
    var _wV = (_parsedW > 0) ? _parsedW : (_curShapeDims ? _curShapeDims.widthCm : 200);
    var _hV = (_parsedH > 0) ? _parsedH : (_curShapeDims ? _curShapeDims.lengthCm : 200);
    if (_wV < 50) _wV = _curShapeDims ? _curShapeDims.widthCm : 200;
    if (_hV < 50) _hV = _curShapeDims ? _curShapeDims.lengthCm : 200;
    window.__doUpdateInProgress = true;
    window.__OzelOlcuAmorf.setDimensions(_wV, _hV);
    window.__doUpdateInProgress = false;
    var url = getFabric();
    if (url === null) { _updating = false; return; }
    _lastUrl = url;
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onerror = function() { console.warn("[Amorf] Fabric image load hatasi"); _updating = false; };
    img.onload = function() {
      var g = getGallery();
      if (g === null) { _updating = false; return; }
      if (_origProductSrc === null) {
        // Orijinal CDN gorselini yakala — data:url ASLA kullanma (amorf uzerine amorf bugu)
        var _origAttr = g.getAttribute('data-original-src');
        if (_origAttr && _origAttr.indexOf('data:') !== 0) {
          _origProductSrc = _origAttr;
        } else if (g.src && g.src.indexOf('data:') !== 0) {
          _origProductSrc = g.src;
        } else {
          // Galeri data:url ile dolmus — elMainImage veya CDN fallback
          var _mainImg = document.getElementById('bp-product-img');
          var _mainOrig = _mainImg ? _mainImg.getAttribute('data-original-src') : null;
          if (_mainOrig && _mainOrig.indexOf('data:') !== 0) {
            _origProductSrc = _mainOrig;
          } else {
            // Son care: thumbnail'den CDN URL bul
            var _thumbs = document.querySelectorAll('.bp-thumb[data-original], .bp-thumb[data-src]');
            for (var _ti = 0; _ti < _thumbs.length; _ti++) {
              var _tSrc = _thumbs[_ti].getAttribute('data-original') || _thumbs[_ti].getAttribute('data-src');
              if (_tSrc && _tSrc.indexOf('data:') !== 0) { _origProductSrc = _tSrc; break; }
            }
            if (!_origProductSrc) _origProductSrc = g.src; // geriye kalan ne varsa
          }
        }
        g.setAttribute("data-original-src", _origProductSrc);
        console.log("[Amorf] origProductSrc yakalandi:", _origProductSrc.substring(0, 80));
      }
      var origSrc = _origProductSrc;
      var prodImg = new Image();
      prodImg.crossOrigin = "anonymous";
      prodImg.onerror = function() { console.warn("[Amorf] Product image load hatasi:", origSrc.substring(0,60)); _updating = false; };
      prodImg.onload = function() {
        // Versiyon eskiyse (sonradan yeni ölçü geldi) sonucu atma
        if (_myVersion !== _renderVersion) { _updating = false; return; }
        try {
          var c = document.createElement("canvas");
          c.width = prodImg.naturalWidth || 800;
          c.height = prodImg.naturalHeight || 800;
          window.__OzelOlcuAmorf.renderPreview(img, c, prodImg);
          if (_myVersion !== _renderVersion) { _updating = false; return; }
          var dataUrl = c.toDataURL("image/png");
          applyAmorfToPrimaryGallery(dataUrl);
          console.log("[Amorf] Galeri guncellendi v" + _myVersion);
        } catch(e) {
          console.error("[Amorf] renderPreview hatasi:", e.message);
        }
        _updating = false;
      };
      prodImg.src = origSrc;
    };
    img.src = url;
  }
  function schedule() { if (_timer) clearTimeout(_timer); _timer = setTimeout(doUpdate, 5000); }
  function now() { if (_timer) clearTimeout(_timer); doUpdate(); }
  window.__amorfGaleriGuncelle = function() { if (_timer) clearTimeout(_timer); _timer = setTimeout(doUpdate, 1500); };
  window.__amorfForceUpdate = function() { if (_timer) clearTimeout(_timer); _updating = false; _lastUpdateTime = 0; doUpdate(); };
  var sel = document.getElementById("ozel-olcu-shape");
  if (sel) sel.addEventListener("change", function() {
    if (this.value === "amorf" || this.value === "daire" || this.value === "oval") {
            var wEl = document.getElementById("ozel-olcu-width");
            var hEl = document.getElementById("ozel-olcu-length");
            var wVal = wEl ? (parseInt(wEl.value) || 0) : 0;
            var hVal = hEl ? (parseInt(hEl.value) || 0) : 0;
            // Olcu girilmemisse amorf yine de acilir
            window.__amorfActive = true;
            setTimeout(now, 500);
          }
    else { window.__amorfActive = false; restoreAmorfPrimaryGallery(); }
  });
  setTimeout(function() {
    var sw = document.querySelectorAll(".ozel-olcu-plus__color-btn");
    for (var i = 0; i < sw.length; i++) sw[i].addEventListener("click", function() { if (isAmorf()) setTimeout(now, 300); });
  }, 1500);
  setInterval(function() { if (isAmorf() === false) return;
    var _iw = document.getElementById("ozel-olcu-width");
    var _ih = document.getElementById("ozel-olcu-length");
    if (_iw && _ih && ((parseInt(_iw.value) || 0) < 50 || (parseInt(_ih.value) || 0) < 50)) return;
    var c = getFabric(); if (c && c !== _lastUrl) now(); }, 5000);
  console.log("[Amorf] Giydirme v2 hazir");
})();
